export const conversations = [
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Nils", "Jake"],
    start: "2018-09-23T13:40:00",
    messages: [
      {
        author: "Jake",
        time: "13:40",
        text: "can they not get group a"
      },
      {
        author: "Nils",
        time: "13:41",
        text: "No, because if lms have to go into d, you're left to place na, EU and CN"
      },
      {
        author: "Nils",
        time: "13:41",
        text: "Neither eu or cn can go into b"
      },
      {
        author: "Nils",
        time: "13:41",
        text: "So the only way to populate it is with c9"
      },
      {
        author: "Nils",
        time: "13:42",
        text: "Means TL get either edg or G2, so that group becomes a lot harder"
      },
      {
        author: "Jake",
        time: "13:43",
        text: "right yeah you're right"
      },
      {
        author: "Nils",
        time: "13:45",
        text: "FNC gonna smash though so that's all that matters :D"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Nils", "Charlie"],
    start: "2018-11-20T18:14:00",
    messages: [
      {
        author: "Nils",
        time: "18:14",
        text: "I like the idea of Bwipo moves mid, soaz stays with fnc ot play top"
      },
      {
        author: "Charlie",
        time: "18:15",
        text: "did bwipo ever play mid back when they were doing lots of position swaps?"
      },
      {
        author: "Nils",
        time: "18:16",
        text: "He played mages botlane"
      },
      {
        author: "Nils",
        time: "18:16",
        text: "So not really but I assume he could"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Jamie", "Charlie"],
    start: "2019-01-13T21:18:00",
    messages: [
      {
        author: "Charlie",
        time: "21:18",
        text: "i dont think its that jg is op.  more that a shit jg is more of a detriment than a shit laner"
      },
      {
        author: "Jamie",
        time: "21:19",
        text: "so its more impactful? but thats the nature of the role"
      },
      {
        author: "Charlie",
        time: "21:19",
        text: "ye"
      },
      {
        author: "Jamie",
        time: "21:19",
        text: "so it should be good"
      },
      {
        author: "Jamie",
        time: "21:20",
        text: "its also probs the most difficult role tho"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Charlie", "Kasai"],
    start: "2019-05-01T19:31:00",
    messages: [
      {
        author: "Charlie",
        time: "19:31",
        text: "She's like if you wanna take afk laning to the extreme"
      },
      {
        author: "Kasai",
        time: "19:32",
        text: "perfect for me"
      },
      {
        author: "Charlie",
        time: "19:32",
        text: "literally just attach to adc and press q or e every 10 secs"
      },
      {
        author: "Charlie",
        time: "19:32",
        text: "pop out to proc passive"
      },
      {
        author: "Charlie",
        time: "19:32",
        text: "ez game"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Jake", "Kasai"],
    start: "2019-05-09T16:15:00",
    messages: [
      {
        author: "Jake",
        time: "16:15",
        text: "you realise"
      },
      {
        author: "Jake",
        time: "16:15",
        text: "if you specify region and ranks enough"
      },
      {
        author: "Jake",
        time: "16:15",
        text: "you can make so many champs look broken"
      },
      {
        author: "Jake",
        time: "16:15",
        text: "but i guess cause it backs up your opinion it must be relevant"
      },
      {
        author: "Kasai",
        time: "16:15",
        text: "I chose shyv cause I love her design but her kit is boring as fuck"
      },
      {
        author: "Jake",
        time: "16:16",
        text: "guys annie is complete bonkers look at that d+ winrate in na"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Nils", "Charlie"],
    start: "2019-09-26T19:27:00",
    messages: [
      {
        author: "Nils",
        time: "19:27",
        text: "fucking hell why is every company designing pages as if the only input people use now is touch screens"
      },
      {
        author: "Nils",
        time: "19:27",
        text: "touch screens and mobile interfaces"
      },
      {
        author: "Charlie",
        time: "19:28",
        text: "its basically the same as the old one except every colour is just a more annoying version of the previous colour"
      },
      {
        author: "Nils",
        time: "19:31",
        text: "What's insane"
      },
      {
        author: "Nils",
        time: "19:31",
        text: "is I'm actually really thinking about having SKT not making it out of the group"
      },
      {
        author: "Nils",
        time: "19:32",
        text: "Even though I still think they're a top 3 team at worlds"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Nils", "Jake"],
    start: "2019-10-19T11:33:00",
    messages: [
      {
        author: "Jake",
        time: "11:33",
        text: "ye"
      },
      {
        author: "Jake",
        time: "11:33",
        text: "preety much a lose to rng dooms them"
      },
      {
        author: "Jake",
        time: "11:33",
        text: "the 2 main things that need to happen would be fnc beaing able to beat rng once or twice if needed"
      },
      {
        author: "Jake",
        time: "11:34",
        text: "and CG to pull of some upset"
      },
      {
        author: "Nils",
        time: "11:35",
        text: "RNG beating SKT in the first game is also p bad for them too"
      },
      {
        author: "Nils",
        time: "11:35",
        text: "just that one result would guarantee a tiebreaker unless they go 3-0"
      },
      {
        author: "Jake",
        time: "11:36",
        text: "ye but hoping to get through without a tie breaker is preety unrealistic anyway"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Nils", "Charlie"],
    start: "2019-10-19T15:06:00",
    messages: [
      {
        author: "Charlie",
        time: "15:06",
        text: "okay so if fnc beat rng they're guaranteed at least a tiebreaker for 2nd"
      },
      {
        author: "Nils",
        time: "15:06",
        text: "ya"
      },
      {
        author: "Nils",
        time: "15:06",
        text: "and then we hope clutch can carry eu"
      },
      {
        author: "Nils",
        time: "15:06",
        text: "by winning some games"
      },
      {
        author: "Charlie",
        time: "15:06",
        text: "and if cg beat rng as well then fnc straight up get 2nd"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Nils", "Charlie"],
    start: "2019-11-10T12:08:00",
    messages: [
      {
        author: "Charlie",
        time: "12:08",
        text: "last year mako did 18 kilos of cocaine before the performance though"
      },
      {
        author: "Nils",
        time: "12:09",
        text: "i was asleep for it and still don't think i've watched it so"
      },
      {
        author: "Nils",
        time: "12:09",
        text: "i'll keep it that way"
      },
      {
        author: "Charlie",
        time: "12:09",
        text: "its actually awful"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Nils", "Kasai"],
    start: "2020-08-08T10:55:00",
    messages: [
      {
        author: "Kasai",
        time: "10:55",
        text: "Is anyone interested in getting fall guys?"
      },
      {
        author: "Nils",
        time: "10:56",
        text: "I know a lot of us are but I'm kinda sad that the max premade party size is only 4"
      },
      {
        author: "Kasai",
        time: "10:56",
        text: "Im sure if people Q up at the same time theyll get in the same game tho right?"
      },
      {
        author: "Nils",
        time: "10:57",
        text: "I imagine it can happen but they have like 1.5m players in a few days so idk :p"
      },
      {
        author: "Nils",
        time: "10:57",
        text: "I still do wanna play it tho"
      },
      {
        author: "Kasai",
        time: "10:57",
        text: "WAIT WHAT"
      },
      {
        author: "Kasai",
        time: "10:57",
        text: "thats a fucking lot"
      },
      {
        author: "Kasai",
        time: "10:58",
        text: "holy moly"
      },
      {
        author: "Nils",
        time: "10:58",
        text: "FallGuysJoe\nLead Game Designer 47 points 3 days ago\nI think possibly, yeah! We just have to be careful because we don't want large groups pubstoming too hard or being able to grief other players. Plus for every play we add the complexity of the feature grows, so we have to balance this with the urgency of other features."
      },
      {
        author: "Nils",
        time: "10:58",
        text: "on increasing the max party size"
      },
      {
        author: "Kasai",
        time: "11:00",
        text: "hmmmmm whack"
      },
      {
        author: "Nils",
        time: "11:04",
        text: "Had a look around and a lot of people say they had a decent success rate of queueing as 2/3 different groups at the same time to get into the same game"
      },
      {
        author: "Kasai",
        time: "11:10",
        text: "good thats really great to hear"
      },
      {
        author: "Kasai",
        time: "11:10",
        text: "and really is it that big of a deal if you arent?"
      },
      {
        author: "Kasai",
        time: "11:11",
        text: "I got the game now so just hmu if anyone wants to plati t"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Nils", "Charlie"],
    start: "2020-08-19T18:10:00",
    messages: [
      {
        author: "Nils",
        time: "18:10",
        text: "holy shit 200k viewers watching this guy still trying to get his very first fall guys win"
      },
      {
        author: "Charlie",
        time: "18:23",
        text: "how long has he been trying"
      },
      {
        author: "Nils",
        time: "18:23",
        text: "8 days so far"
      },
      {
        author: "Charlie",
        time: "18:23",
        text: "fuck"
      },
      {
        author: "Nils",
        time: "18:25",
        text: "he must've made literally hundreds of thousands in subs and donations in the last week"
      },
      {
        author: "Nils",
        time: "18:25",
        text: "just from the fallguys twitter trolling him (promoting him) for not having a win"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Jamie", "Nils"],
    start: "2020-09-09T17:53:00",
    messages: [
      {
        author: "Nils",
        time: "17:53",
        text: "Can't wait them to do the same with summoner spells next year"
      },
      {
        author: "Nils",
        time: "17:54",
        text: "You can have 4 summoner spells but only one keystone/mythic spell and 3 supporting ones"
      },
      {
        author: "Nils",
        time: "17:54",
        text: "Flash is now a mythic SS and they add another few equally strong ones"
      },
      {
        author: "Jamie",
        time: "17:55",
        text: "make tp mythic too"
      },
      {
        author: "Nils",
        time: "17:55",
        text: "Runes and items have both gone this direction"
      },
      {
        author: "Nils",
        time: "17:55",
        text: "Then they can revert the needs they kept giving it"
      },
      {
        author: "Nils",
        time: "17:55",
        text: "Nerfs"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Joey", "Kasai"],
    start: "2020-12-20T16:56:00",
    messages: [
      {
        author: "Joey",
        time: "16:56",
        text: "sounds like an anxiety thing ngl"
      },
      {
        author: "Kasai",
        time: "16:58",
        text: "I guess its something everyone has to decide whether they're ok doing that? You know?"
      },
      {
        author: "Joey",
        time: "16:59",
        text: "true"
      },
      {
        author: "Kasai",
        time: "17:00",
        text: "Like for me if my friends are playing ranked in a channel Ill join ask if theyre ok having me there but ill say they can still speak swedish I just want to watch or whatever. But if its just people chilling I just join and hope they cool with me being there?"
      },
      {
        author: "Joey",
        time: "17:01",
        text: "in this server at least i odnt think there are many people who would get annoyeed if u join a call"
      },
      {
        author: "Joey",
        time: "17:01",
        text: "unless theyre playing ranked or somsething"
      },
      {
        author: "Kasai",
        time: "17:02",
        text: "Ye idk depends on what theyre doing I suppose :)"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Nils", "Charlie"],
    start: "2021-09-15T15:42:00",
    messages: [
      {
        author: "Nils",
        time: "15:42",
        text: "Still surprised mikyx is going"
      },
      {
        author: "Charlie",
        time: "15:43",
        text: "imo would have been better to keep him and trade rekkles"
      },
      {
        author: "Nils",
        time: "15:43",
        text: "Clash of styles with rekkles I guess, and they'd rather keep him than miky"
      },
      {
        author: "Charlie",
        time: "15:43",
        text: "but rekkles just too expensive ig"
      },
      {
        author: "Nils",
        time: "15:44",
        text: "Yeah and also probably brings in a ton of merch sales just from his name"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Nils", "Charlie"],
    start: "2021-10-18T13:47:00",
    messages: [
      {
        author: "Charlie",
        time: "13:47",
        text: "my take away from week 2 thusfar is that leblanc is broken as shit"
      },
      {
        author: "Nils",
        time: "14:06",
        text: "yeah but that involves the LPL winning a game, so pretty unlikely"
      },
      {
        author: "Charlie",
        time: "14:07",
        text: "oh yeah nils u remember that a load of people weirdly were in the second highest point group?"
      },
      {
        author: "Charlie",
        time: "14:07",
        text: "for pickems"
      },
      {
        author: "Charlie",
        time: "14:07",
        text: "its because if you dont pick anything it locks you something random"
      },
      {
        author: "Charlie",
        time: "14:07",
        text: "but it locks the same random thing for everyone"
      },
      {
        author: "Charlie",
        time: "14:08",
        text: "which this year involved a perfect group 1"
      },
      {
        author: "Nils",
        time: "14:08",
        text: "ahahaha fuck"
      },
      {
        author: "Nils",
        time: "14:08",
        text: "i would've actually had more points rn if I forgot to do them..."
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Freddie", "Charlie"],
    start: "2021-10-31T11:39:00",
    messages: [
      {
        author: "Freddie",
        time: "11:39",
        text: "i've been saying roger federer should make a league team with dinosaurs for years!"
      },
      {
        author: "Charlie",
        time: "11:40",
        text: "enjoying how it took you 12 business days to type that"
      },
      {
        author: "Freddie",
        time: "11:40",
        text: "lol"
      },
      {
        author: "Charlie",
        time: "11:41",
        text: "best guess i have is that limit's real name is dino"
      },
      {
        author: "Charlie",
        time: "11:41",
        text: "but i dont know what that has to do with tennis"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Jake", "Charlie"],
    start: "2021-11-10T15:57:00",
    messages: [
      {
        author: "Jake",
        time: "15:57",
        text: "that makes sense"
      },
      {
        author: "Charlie",
        time: "15:57",
        text: "i knew a bunch of people at school played and i had literally nothing to do so i though fuck it why not"
      },
      {
        author: "Jake",
        time: "15:57",
        text: "if you asked anyone they might have warned u"
      },
      {
        author: "Charlie",
        time: "15:57",
        text: "and thats why children shouldnt be allowed to make decisions"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Charlie", "Nic"],
    start: "2021-11-19T21:01:00",
    messages: [
      {
        author: "Nic",
        time: "21:01",
        text: "I do, I was walking with my classmates about it the other day"
      },
      {
        author: "Nic",
        time: "21:02",
        text: "made them all smell me, they said I smell exquisite"
      },
      {
        author: "Charlie",
        time: "21:02",
        text: "their danish senses are fried"
      },
      {
        author: "Charlie",
        time: "21:02",
        text: "dont believe a word"
      },
      {
        author: "Nic",
        time: "21:03",
        text: "Charlie you've never said anything of value, so why are you starting now? :(("
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Imogen", "Nic"],
    start: "2021-12-04T04:42:00",
    messages: [
      {
        author: "Nic",
        time: "04:42",
        text: "Literally the guy from xfiles we talked about earlier says the n-word and the f-word all the time in the show californication"
      },
      {
        author: "Nic",
        time: "04:42",
        text: "and Charlie says the n word 2 times in always sunny"
      },
      {
        author: "Imogen",
        time: "04:42",
        text: "Those are tv shows"
      },
      {
        author: "Nic",
        time: "04:42",
        text: "So yeah, if you're a professional bad words user you're allowed?"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Imogen", "Nic"],
    start: "2021-12-04T04:54:00",
    messages: [
      {
        author: "Imogen",
        time: "04:54",
        text: "I think what sheepie said was the best worded, even though for you its nothing and no ill intent please consider the damage it can cause even if unintentionally"
      },
      {
        author: "Nic",
        time: "04:55",
        text: "as I said, it's considered. I think we also have to consider the different worlds we may come from. I dunno but I have a bunch of good gay friends, and we call each other the f-word all the time. Different ways of being raised, different cultures different friends"
      },
      {
        author: "Nic",
        time: "04:56",
        text: "I won't use it here again"
      },
      {
        author: "Imogen",
        time: "04:56",
        text: "There will be people who that word will upset and trigger, for you its a word you may wish to have no power but even so it will damage someone"
      },
      {
        author: "Nic",
        time: "04:56",
        text: "I just think context and environment matters, didn't think it would hurt you guys but it clearly did, and well I am sorry about that"
      },
      {
        author: "Nic",
        time: "04:57",
        text: "Didn't think much of it, which was clearly stupid of me"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Imogen", "Nic"],
    start: "2021-12-24T18:57:00",
    messages: [
      {
        author: "Nic",
        time: "18:57",
        text: "I'm everywhere"
      },
      {
        author: "Imogen",
        time: "19:05",
        text: "yo drunk nic ?"
      },
      {
        author: "Nic",
        time: "19:07",
        text: "Sadly nah"
      },
      {
        author: "Nic",
        time: "19:07",
        text: "Don't like being drunk with family gotta take care of my grandma she has trouble walking"
      },
      {
        author: "Nic",
        time: "19:08",
        text: "So if I start having trouble walking too it'll be bad news"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Jake", "Charlie"],
    start: "2021-12-30T20:46:00",
    messages: [
      {
        author: "Charlie",
        time: "20:46",
        text: "i made that exact joke last tme someone had this bug ama"
      },
      {
        author: "Jake",
        time: "20:49",
        text: "tru and it was banger back then and now"
      },
      {
        author: "Charlie",
        time: "20:49",
        text: "ill fuckin do it again too"
      },
      {
        author: "Jake",
        time: "20:50",
        text: "<@!99525203293384704> finish that food buddy i can only edge for so long"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Imogen", "Nic"],
    start: "2022-01-02T13:48:00",
    messages: [
      {
        author: "Nic",
        time: "13:48",
        text: "ae is correct if you don't have a keyboard or finding out another way"
      },
      {
        author: "Imogen",
        time: "13:48",
        text: "\u00e6"
      },
      {
        author: "Nic",
        time: "13:48",
        text: "and then AA for \u00e5 and no clue what \u00f8 is"
      },
      {
        author: "Nic",
        time: "13:49",
        text: "thinking it is oo but never seen that ever in old texts"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Jake", "Charlie"],
    start: "2022-01-05T21:47:00",
    messages: [
      {
        author: "Charlie",
        time: "21:47",
        text: "he was terrible but he windwalls my ult every time and all of my deaths were him pressing r and then killing me in 2 autos"
      },
      {
        author: "Jake",
        time: "21:47",
        text: "ye but he needs another champion to set him up for ults"
      },
      {
        author: "Charlie",
        time: "21:47",
        text: "less crit damage doesnt mean shit when you get 50% armour pen for pressing r"
      },
      {
        author: "Charlie",
        time: "21:47",
        text: "he does not"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Jake", "Charlie"],
    start: "2022-01-15T03:59:00",
    messages: [
      {
        author: "Charlie",
        time: "03:59",
        text: "i dont want to call a girl mommy but you can never say never"
      },
      {
        author: "Jake",
        time: "04:00",
        text: "if leanbeafpatty asked charlie."
      },
      {
        author: "Jake",
        time: "04:00",
        text: "you would be barkin rn"
      },
      {
        author: "Charlie",
        time: "04:00",
        text: "i know things about myself now that a year ago i would've said \"never\"\nwho knows where the future will lead me"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Jake", "Charlie"],
    start: "2022-01-21T16:49:00",
    messages: [
      {
        author: "Charlie",
        time: "16:49",
        text: "well its not random entirely"
      },
      {
        author: "Charlie",
        time: "16:50",
        text: "there it picked buggy bc b is a more common letter than f or v"
      },
      {
        author: "Charlie",
        time: "16:50",
        text: "so it gives buggy more weight"
      },
      {
        author: "Jake",
        time: "16:51",
        text: "i feel like those words would be damn hard for even a more refined bot"
      },
      {
        author: "Jake",
        time: "16:51",
        text: "letters are so uncommon that it doesnt get many clues till the 3rd guess"
      },
      {
        author: "Jake",
        time: "16:51",
        text: "and even then its gonna be hard to seperate the last 3"
      },
      {
        author: "Charlie",
        time: "16:52",
        text: "the change im making at the moment means if it has 3 letters where the position is known, it will do the smart thing instead of just starting to guess"
      },
      {
        author: "Charlie",
        time: "16:52",
        text: "but in that instance it didnt have 3+ greens until puppy at guess 5"
      },
      {
        author: "Jake",
        time: "16:52",
        text: "yee"
      },
      {
        author: "Jake",
        time: "16:53",
        text: "that optimisation wouldnt help much at all here"
      },
      {
        author: "Jake",
        time: "16:53",
        text: "someone contact google"
      },
      {
        author: "Jake",
        time: "16:54",
        text: "ask them to make a self learning wordle bot"
      },
      {
        author: "Jake",
        time: "16:54",
        text: "so i can find a word to beat it,"
      },
      {
        author: "Charlie",
        time: "17:03",
        text: "i changed a < to a > to make it choose the worst words instead of the best"
      },
      {
        author: "Charlie",
        time: "17:03",
        text: "the 3 starting words it wants to give me are \"jeeze\" \"jugum\" \"qajaq\""
      },
      {
        author: "Jake",
        time: "17:03",
        text: "qajaq"
      },
      {
        author: "Jake",
        time: "17:04",
        text: "i would love to see the real bot try qajaq"
      },
      {
        author: "Charlie",
        time: "17:04",
        text: "well wordle wont allow it so i guess thats not an issue"
      },
      {
        author: "Jake",
        time: "17:04",
        text: "damn"
      },
      {
        author: "Charlie",
        time: "17:04",
        text: "i just used a list of every scrabble legal word"
      },
      {
        author: "Jake",
        time: "17:06",
        text: "looks like there is no official list of words worldle uses"
      },
      {
        author: "Charlie",
        time: "17:07",
        text: "yeah different sites use different lists"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Charlie", "Nic"],
    start: "2022-01-23T14:28:00",
    messages: [
      {
        author: "Nic",
        time: "14:28",
        text: "wild rift's actually pretty good"
      },
      {
        author: "Nic",
        time: "14:28",
        text: "I hope it comes on console soon, but It probs won't for another year"
      },
      {
        author: "Charlie",
        time: "14:29",
        text: "my hope is that theyre using mobile as like a testing platform"
      },
      {
        author: "Charlie",
        time: "14:29",
        text: "and theyre just gonna port the whole thing over to pc"
      },
      {
        author: "Nic",
        time: "14:30",
        text: "sounds a bit like a stretch"
      },
      {
        author: "Nic",
        time: "14:30",
        text: "but the game would be better for it"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Jake", "Nic"],
    start: "2022-01-23T17:46:00",
    messages: [
      {
        author: "Nic",
        time: "17:46",
        text: "okay so william isn't coming so I'll go jerk off instead"
      },
      {
        author: "Nic",
        time: "17:47",
        text: "I might play after"
      },
      {
        author: "Jake",
        time: "17:47",
        text: "And by the time you sell it you don\u2019t really care about the 300g loss"
      },
      {
        author: "Jake",
        time: "17:47",
        text: "The benefit is being able to back sooner for spikes"
      },
      {
        author: "Jake",
        time: "17:47",
        text: "Which is fair"
      },
      {
        author: "Nic",
        time: "17:47",
        text: "yeah but being able to back earlier for a noon quiver is pretty good"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Imogen", "Nic"],
    start: "2022-01-24T17:52:00",
    messages: [
      {
        author: "Nic",
        time: "17:52",
        text: "I'd have a lot of questions"
      },
      {
        author: "Nic",
        time: "17:52",
        text: "I paid for these keys and he showed mes creenshot with them being on my account"
      },
      {
        author: "Imogen",
        time: "17:52",
        text: "Okay one sec"
      },
      {
        author: "Nic",
        time: "17:52",
        text: "but will they actually be on my account when I get it back?"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Jamie", "Jake"],
    start: "2022-01-31T17:48:00",
    messages: [
      {
        author: "Jamie",
        time: "17:48",
        text: "dont get mad if people play badly, just int/troll or build awfully"
      },
      {
        author: "Jamie",
        time: "17:48",
        text: "rectum licker"
      },
      {
        author: "Jake",
        time: "17:49",
        text: "man that its literally the worst thing you can do"
      },
      {
        author: "Jamie",
        time: "17:53",
        text: "people that REFUSE to buy antiheal deserve to have their toenails ripped out"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Jamie", "Charlie"],
    start: "2022-02-01T14:38:00",
    messages: [
      {
        author: "Jamie",
        time: "14:38",
        text: "rip <@!181369671231078400>"
      },
      {
        author: "Charlie",
        time: "14:38",
        text: "down for jake to play adc in customs if i can play renata on the other team"
      },
      {
        author: "Jamie",
        time: "14:40",
        text: "they\u2019ll just shielf his damage instead dw"
      },
      {
        author: "Charlie",
        time: "14:41",
        text: "ivern cant shield him if he's busy auto attacking his teammates"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Jake", "Charlie"],
    start: "2022-02-02T16:43:00",
    messages: [
      {
        author: "Jake",
        time: "16:43",
        text: "fix fucking support items, there is no reason why supports should have the same gold income as everyone else and reach 1/2 items the same time as others"
      },
      {
        author: "Charlie",
        time: "16:43",
        text: "honestly riot should hire me\nyou saw my support item fix jake?"
      },
      {
        author: "Charlie",
        time: "16:44",
        text: "im cracked fr"
      },
      {
        author: "Jake",
        time: "16:44",
        text: "ye true"
      },
      {
        author: "Jake",
        time: "16:44",
        text: "juat slow down generation and in return make it so support builds dont fall off a cliff after quest completion by increasing the total gold"
      },
      {
        author: "Charlie",
        time: "16:45",
        text: "hold on ill drop it here so everyone else can revel in my genius"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Jake", "Charlie"],
    start: "2022-02-02T19:03:00",
    messages: [
      {
        author: "Charlie",
        time: "19:03",
        text: "bens gone now"
      },
      {
        author: "Jake",
        time: "19:04",
        text: "hoenstly harry"
      },
      {
        author: "Jake",
        time: "19:04",
        text: "i think you just have to tick off the other roles when you feel like playing sup"
      },
      {
        author: "Charlie",
        time: "19:04",
        text: "i think you could actually be matched against most of us support, and then it would even the difference in another role, but yours and bens mmr were so far apart it couldnt make it work"
      },
      {
        author: "Charlie",
        time: "19:05",
        text: "it would have to have like jake vs me in top lane to counteract"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Imogen", "Charlie"],
    start: "2022-02-07T04:16:00",
    messages: [
      {
        author: "Charlie",
        time: "04:16",
        text: "refuse to believe the optimal first word doesnt have an s"
      },
      {
        author: "Charlie",
        time: "04:24",
        text: "one thing all these wordle analysis things fail to take into account is that the words chosen aren't random, studies like these will use one of the open source wordle sites to spam games to get data but those sites all just pick random words from a list.  In real wordle, the guy who made it has hand picked the words for the next several hundred days, in order to avoid words like \"salet\" and \"reast\", its impossible to use significant data to determine the best word to start with simply because we dont have an accurate read on the pool of words we're guessing from, therefore its more ingenuous to generalise and give a list of several hundred words saying they're all optimal, a difference of 0.01 average guesses required will be entirely negated by the nature of handpicking the words"
      },
      {
        author: "Charlie",
        time: "04:24",
        text: "thank you for coming to my ted talk"
      },
      {
        author: "Imogen",
        time: "04:27",
        text: "This image feels a bit like it is just assets thrown together"
      },
      {
        author: "Imogen",
        time: "04:27",
        text: "I THINK SO"
      },
      {
        author: "Imogen",
        time: "04:34",
        text: "Whys that so long"
      },
      {
        author: "Charlie",
        time: "04:34",
        text: "i nerded out sorry"
      },
      {
        author: "Imogen",
        time: "04:34",
        text: "Im here to ask selena and sheepie to platonically spoon with me cause i\u2019m cold"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#games-chat",
    participants: ["Charlie", "Sam"],
    start: "2022-02-09T21:18:00",
    messages: [
      {
        author: "Sam",
        time: "21:18",
        text: "lowkey i rly got it so i could get one of those doorbells with a camera so i can wait til the food delivery guy is leaving it on my doorstep and leaving"
      },
      {
        author: "Charlie",
        time: "21:19",
        text: "i put in delivery instructions \"dont knock just leave it on the porch ill come get it\""
      },
      {
        author: "Sam",
        time: "21:19",
        text: "i do that too"
      },
      {
        author: "Sam",
        time: "21:19",
        text: "but sometimes they wait"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Nic", "Smuck"],
    start: "2022-02-10T13:58:00",
    messages: [
      {
        author: "Nic",
        time: "13:58",
        text: "I might"
      },
      {
        author: "Nic",
        time: "13:59",
        text: "just the concept on evil. Writing a psychology paper. A pretty important one too. The point specifically I am writing about is whether or not a person is born evil or becomes evil"
      },
      {
        author: "Nic",
        time: "14:00",
        text: "focusing on Ed Kemper"
      },
      {
        author: "Smuck",
        time: "14:00",
        text: "Oooh, it's due Monday? You haven't started yet? That's true uni mentality"
      },
      {
        author: "Nic",
        time: "14:01",
        text: "man I'm gross like that, I don't think I have ever written a paper that wasn't like 2-3 days before due"
      },
      {
        author: "Smuck",
        time: "14:01",
        text: "As someone who struggles to write 1-2 pages a day. I can never understand that"
      },
      {
        author: "Nic",
        time: "14:03",
        text: "When I write I write, I don't stop really"
      },
      {
        author: "Smuck",
        time: "14:05",
        text: "I respect it"
      },
      {
        author: "Nic",
        time: "14:06",
        text: "I do think writing the same amount of pages over a smaller span of time is better, less stressful"
      },
      {
        author: "Smuck",
        time: "14:08",
        text: "JAKE"
      },
      {
        author: "Smuck",
        time: "14:08",
        text: "SHOOT YOUR SHOT MAN"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Nils", "Imogen"],
    start: "2022-02-12T14:02:00",
    messages: [
      {
        author: "Imogen",
        time: "14:02",
        text: "Wordle 238 5/6\n\u2b1b\ud83d\udfe8\u2b1b\ud83d\udfe8\ud83d\udfe8\n\u2b1b\ud83d\udfe9\ud83d\udfe8\ud83d\udfe8\u2b1b\n\u2b1b\u2b1b\u2b1b\u2b1b\u2b1b\n\ud83d\udfe8\ud83d\udfe9\ud83d\udfe9\u2b1b\ud83d\udfe8\n\ud83d\udfe9\ud83d\udfe9\ud83d\udfe9\ud83d\udfe9\ud83d\udfe9"
      },
      {
        author: "Nils",
        time: "14:02",
        text: "Daily Quordle #19\n8\ufe0f\u20e35\ufe0f\u20e3\n7\ufe0f\u20e39\ufe0f\u20e3\nquordle.com\n\ud83d\udfe8\ud83d\udfe8\u2b1c\ud83d\udfe8\u2b1c \u2b1c\ud83d\udfe8\u2b1c\u2b1c\u2b1c\n\u2b1c\u2b1c\u2b1c\u2b1c\u2b1c \u2b1c\ud83d\udfe9\ud83d\udfe8\u2b1c\u2b1c\n\u2b1c\u2b1c\u2b1c\ud83d\udfe8\ud83d\udfe9 \u2b1c\ud83d\udfe8\u2b1c\ud83d\udfe8\ud83d\udfe9\n\ud83d\udfe9\u2b1c\u2b1c\u2b1c\ud83d\udfe9 \ud83d\udfe8\ud83d\udfe9\ud83d\udfe8\ud83d\udfe9\ud83d\udfe9\n\u2b1c\u2b1c\ud83d\udfe8\u2b1c\ud83d\udfe9 \ud83d\udfe9\ud83d\udfe9\ud83d\udfe9\ud83d\udfe9\ud83d\udfe9\n\u2b1c\ud83d\udfe9\u2b1c\u2b1c\u2b1c \u2b1b\u2b1b\u2b1b\u2b1b\u2b1b\n\u2b1c\ud83d\udfe9\u2b1c\u2b1c\u2b1c \u2b1b\u2b1b\u2b1b\u2b1b\u2b1b\n\ud83d\udfe9\ud83d\udfe9\ud83d\udfe9\ud83d\udfe9\ud83d\udfe9 \u2b1b\u2b1b\u2b1b\u2b1b\u2b1b\n\ud83d\udfe8\u2b1c\u2b1c\u2b1c\u2b1c \u2b1c\ud83d\udfe9\u2b1c\u2b1c\u2b1c\n\ud83d\udfe8\u2b1c\u2b1c\u2b1c\ud83d\udfe9 \u2b1c\u2b1c\u2b1c\u2b1c\u2b1c\n\u2b1c\u2b1c\ud83d\udfe9\u2b1c\u2b1c \u2b1c\u2b1c\u2b1c\u2b1c\ud83d\udfe9\n\u2b1c\u2b1c\u2b1c\u2b1c\u2b1c \u2b1c\u2b1c\u2b1c\u2b1c\ud83d\udfe9\n\u2b1c\u2b1c\u2b1c\u2b1c\u2b1c \u2b1c\u2b1c\u2b1c\u2b1c\ud83d\udfe9\n\u2b1c\ud83d\udfe9\ud83d\udfe9\ud83d\udfe9\ud83d\udfe9 \u2b1c\u2b1c\u2b1c\u2b1c\u2b1c\n\ud83d\udfe9\ud83d\udfe9\ud83d\udfe9\ud83d\udfe9\ud83d\udfe9 \ud83d\udfe9\u2b1c\u2b1c\u2b1c\u2b1c\n\u2b1b\u2b1b\u2b1b\u2b1b\u2b1b \u2b1c\u2b1c\u2b1c\u2b1c\ud83d\udfe9\n\u2b1b\u2b1b\u2b1b\u2b1b\u2b1b \ud83d\udfe9\ud83d\udfe9\ud83d\udfe9\ud83d\udfe9\ud83d\udfe9"
      },
      {
        author: "Imogen",
        time: "14:02",
        text: "THE WHITE"
      },
      {
        author: "Nils",
        time: "14:02",
        text: "It's quordle! :P"
      },
      {
        author: "Nils",
        time: "14:02",
        text: "4 wordles at once"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#games-chat",
    participants: ["Imogen", "Charlie"],
    start: "2022-02-27T02:48:00",
    messages: [
      {
        author: "Imogen",
        time: "02:48",
        text: "honestly hes making me laugh loads"
      },
      {
        author: "Imogen",
        time: "02:49",
        text: "i saw his video with cdawgva, and i knew of ludwig but never watched him till then"
      },
      {
        author: "Imogen",
        time: "02:49",
        text: "and now"
      },
      {
        author: "Imogen",
        time: "02:49",
        text: "well"
      },
      {
        author: "Charlie",
        time: "02:49",
        text: "honestly i dont find him funny at all, but i have to respect him as a streamer"
      },
      {
        author: "Charlie",
        time: "02:49",
        text: "he was born to be an entertainer"
      },
      {
        author: "Imogen",
        time: "02:49",
        text: "true"
      },
      {
        author: "Imogen",
        time: "02:49",
        text: "like even if you dont enjoy his humour he is dedicated"
      },
      {
        author: "Charlie",
        time: "02:50",
        text: "most streamers i dont find funny its because their \"funny\" is just being loud and overreacting"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Jake", "Charlie"],
    start: "2022-03-05T17:48:00",
    messages: [
      {
        author: "Jake",
        time: "17:48",
        text: "okay but what if i play solo and dont want to top lane."
      },
      {
        author: "Charlie",
        time: "17:48",
        text: "eat shit"
      },
      {
        author: "Jake",
        time: "17:49",
        text: "idk i think the point is duo q is inheritanly bad for competitive"
      },
      {
        author: "Jake",
        time: "17:49",
        text: "so why have it at all"
      },
      {
        author: "Jake",
        time: "17:50",
        text: "if you want to duo go play flex"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Nils", "Charlie"],
    start: "2022-03-10T22:16:00",
    messages: [
      {
        author: "Nils",
        time: "22:16",
        text: "could be right"
      },
      {
        author: "Charlie",
        time: "22:16",
        text: "says ive only played 2 ranked games ever"
      },
      {
        author: "Nils",
        time: "22:16",
        text: "I know I had a 22 game winstreak and this only shows 10 as the longest"
      },
      {
        author: "Charlie",
        time: "22:16",
        text: "i know i had a 21 game loss streak and this shows 9 as the longest"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Jake", "Charlie"],
    start: "2022-03-17T13:59:00",
    messages: [
      {
        author: "Charlie",
        time: "13:59",
        text: "complimenting a yuumi for using their passive and trading effectively and manoeuvring through teamfights is like complimenting a veigar player for using q to stack minions"
      },
      {
        author: "Charlie",
        time: "14:00",
        text: "its the minimum requirement to play the champion with any degree of effectiveness"
      },
      {
        author: "Charlie",
        time: "14:00",
        text: "if you arent doing that why did you lock in the champion"
      },
      {
        author: "Jake",
        time: "14:01",
        text: "the argument is that its not that easy to do those things"
      },
      {
        author: "Charlie",
        time: "14:01",
        text: "it is"
      },
      {
        author: "Jake",
        time: "14:01",
        text: "then why did her skill curve look like that"
      },
      {
        author: "Jake",
        time: "14:02",
        text: "and not like neekos or mordekaisers"
      },
      {
        author: "Charlie",
        time: "14:02",
        text: "because people flat out refused to do any of those things"
      },
      {
        author: "Charlie",
        time: "14:02",
        text: "its not that theyre difficult and people struggled to learn the champion"
      },
      {
        author: "Charlie",
        time: "14:02",
        text: "they were just so convinced you  could afk and collect lp they refused to do anything else"
      },
      {
        author: "Charlie",
        time: "14:02",
        text: "thats how i play her to this day"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Jake", "Charlie"],
    start: "2022-03-20T16:20:00",
    messages: [
      {
        author: "Jake",
        time: "16:20",
        text: "its a good idea in concept"
      },
      {
        author: "Jake",
        time: "16:20",
        text: "pros always complain about high ping and otps lowering the quality of solo q"
      },
      {
        author: "Jake",
        time: "16:21",
        text: "especially na solo q"
      },
      {
        author: "Charlie",
        time: "16:21",
        text: "it worked for a bit but they stopped bothering and now theres only 1-2 games a day"
      },
      {
        author: "Charlie",
        time: "16:21",
        text: "bc na pros realised if they actually have a good practice environment they wont have an excuse for being shit anymore"
      },
      {
        author: "Jake",
        time: "16:21",
        text: "ye but thats on the pros more then anything"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Jake", "Imogen"],
    start: "2022-03-25T13:03:00",
    messages: [
      {
        author: "Imogen",
        time: "13:03",
        text: "I feel threatened"
      },
      {
        author: "Imogen",
        time: "13:03",
        text: "\u201cI like this job, i like drive car \ud83d\ude98 \u201c"
      },
      {
        author: "Jake",
        time: "13:04",
        text: "A lot of people are accusing him of exaggerating or straight up lying"
      },
      {
        author: "Imogen",
        time: "13:04",
        text: "Cat become pancake"
      },
      {
        author: "Jake",
        time: "13:05",
        text: "Head coach for For a top Na team makes easily 6 figures with all living expenses payed"
      },
      {
        author: "Jake",
        time: "13:06",
        text: "He also asked for somewhere around 400k from all the players and staff combined"
      },
      {
        author: "Jake",
        time: "13:07",
        text: "And people who he asked for money for were asked for different amounts and given different reasons"
      },
      {
        author: "Jake",
        time: "13:09",
        text: "Most of this comes from DL and sword art"
      },
      {
        author: "Jake",
        time: "13:12",
        text: "Guess there is no point speculating exactly what\u2019s true until the investigation is done"
      },
      {
        author: "Jake",
        time: "13:13",
        text: "But bottom line is the person who has a significant say in whether you keep your job asking for money is fucked up"
      },
      {
        author: "Jake",
        time: "13:14",
        text: "And the guy essentially straight up stealing from sword art is fucked"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Jake", "Smuck"],
    start: "2022-04-02T17:13:00",
    messages: [
      {
        author: "Smuck",
        time: "17:13",
        text: "Larsen no"
      },
      {
        author: "Jake",
        time: "17:16",
        text: "ill let you know when we are done but im not sure how long"
      },
      {
        author: "Jake",
        time: "17:16",
        text: "im sorry i asked for them to schedule it in nowwish cause i thought we would start playin in the evening"
      },
      {
        author: "Smuck",
        time: "17:16",
        text: "Who is the girl in the kit kat commercial?"
      },
      {
        author: "Smuck",
        time: "17:16",
        text: "Make up artist probably?"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Jake", "Charlie"],
    start: "2022-04-05T00:54:00",
    messages: [
      {
        author: "Charlie",
        time: "00:54",
        text: "dont care champs been busted since they gave him 5 barrels"
      },
      {
        author: "Charlie",
        time: "00:55",
        text: "(mainly bc thats when they changed the crit damage not bc of the 5 barrels)"
      },
      {
        author: "Jake",
        time: "01:03",
        text: "man try playing him he is in no way that strong unless you are a god at the champ"
      },
      {
        author: "Charlie",
        time: "01:03",
        text: "aoe 2k crits are not okay \ud83d\udc9e"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Freddie", "Charlie"],
    start: "2022-04-06T00:17:00",
    messages: [
      {
        author: "Freddie",
        time: "00:17",
        text: "\ud83c\udf0e Apr 6, 2022 \ud83c\udf0d\n\ud83d\udd25 10 | Avg. Guesses: 6.23\n\u2b1c\u2b1c\u2b1c\ud83d\udfe9 = 4\nim absolutely cracked"
      },
      {
        author: "Charlie",
        time: "00:18",
        text: "\ud83c\udf0e Apr 6, 2022 \ud83c\udf0d\n\ud83d\udd25 12 | Avg. Guesses: 8.92\n\u2b1c\u2b1c\u2b1c\u2b1c\ud83d\udfe8\ud83d\udfe9 = 6"
      },
      {
        author: "Charlie",
        time: "00:18",
        text: "wtf"
      },
      {
        author: "Freddie",
        time: "00:18",
        text: "all skill"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Jamie", "Jake"],
    start: "2022-04-11T11:05:00",
    messages: [
      {
        author: "Jamie",
        time: "11:05",
        text: "anyone know how to fix start menu not working, says i need to sign out and shut down that way"
      },
      {
        author: "Jake",
        time: "11:06",
        text: "screenshot?"
      },
      {
        author: "Jamie",
        time: "11:07",
        text: "fucks my fps if i do it and cba restarting pc lmao"
      },
      {
        author: "Jamie",
        time: "11:07",
        text: "looks like this"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Jake", "Charlie"],
    start: "2022-04-13T02:31:00",
    messages: [
      {
        author: "Charlie",
        time: "02:31",
        text: "Wordle 298 4/6\n\u2b1b\u2b1b\u2b1b\u2b1b\u2b1b\n\ud83d\udfe8\ud83d\udfe8\u2b1b\u2b1b\u2b1b\n\u2b1b\u2b1b\u2b1b\u2b1b\u2b1b\n\ud83d\udfe9\ud83d\udfe9\ud83d\udfe9\ud83d\udfe9\ud83d\udfe9"
      },
      {
        author: "Jake",
        time: "02:31",
        text: "hoyl shit"
      },
      {
        author: "Jake",
        time: "02:41",
        text: "Wordle 298 4/6\n\u2b1b\u2b1b\u2b1b\u2b1b\u2b1b\n\ud83d\udfe9\u2b1b\ud83d\udfe9\u2b1b\u2b1b\n\u2b1b\u2b1b\ud83d\udfe8\u2b1b\u2b1b\n\ud83d\udfe9\ud83d\udfe9\ud83d\udfe9\ud83d\udfe9\ud83d\udfe9"
      },
      {
        author: "Charlie",
        time: "02:48",
        text: "You guys know who I haven't played league with in a long time?  <@134105000442986496> .  I miss the good old days playing on NA with Sam.  That's where I found my love of Trundle.  I remember smacking towers and clubbing fools on EboyDestroyer until the early hours of the morning. I remember learning how cracked Otter is at terrorist champs.  I remember Jake's Ezreal.  I think it's fair to say that Sam was the catalyst for all this.  Without Sam there would be no NA league sessions, and without those, who knows where we'd be now?  As I type this I am in call with my 2 chums Imogen and Tapenga, both of whom I would never have met if not for Sam.  She truly is the backbone of this server and I owe her more than words can describe.  I don't know if I'll ever be able to repay this debt Sam, but perhaps a joyous bout of League of Legends will suffice for now.  What do you say?"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Jake", "Charlie"],
    start: "2022-04-17T18:39:00",
    messages: [
      {
        author: "Jake",
        time: "18:39",
        text: "ye so 1 in 30"
      },
      {
        author: "Jake",
        time: "18:39",
        text: "ish"
      },
      {
        author: "Charlie",
        time: "18:39",
        text: "okay thats fair"
      },
      {
        author: "Jake",
        time: "18:40",
        text: "regardless even with the perfectly made algorithm your chance of going to 0 flips tends to 1 as your number of flips made goes to infinity"
      },
      {
        author: "Jake",
        time: "18:41",
        text: "i just thought the score would be a loooot higher then 4k"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#cannae-talk",
    participants: ["Imogen", "Sam"],
    start: "2022-05-03T15:58:00",
    messages: [
      {
        author: "Imogen",
        time: "15:58",
        text: "Yeah i\u2019m down with maybe childhood friends? Grew up same town?"
      },
      {
        author: "Imogen",
        time: "15:59",
        text: "6gb is nothing to 112gb"
      },
      {
        author: "Sam",
        time: "15:59",
        text: "yall are so cute"
      },
      {
        author: "Imogen",
        time: "15:59",
        text: "Sammie!! Wanna be apart of the childhood friends or wanna be related etc?"
      },
      {
        author: "Imogen",
        time: "16:03",
        text: "RDR IS DOWNLOADED, next part"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Jake", "Charlie"],
    start: "2022-05-12T00:51:00",
    messages: [
      {
        author: "Charlie",
        time: "00:51",
        text: "Wordle 327 4/6\n\u2b1b\u2b1b\u2b1b\u2b1b\ud83d\udfe8\n\ud83d\udfe8\ud83d\udfe8\u2b1b\u2b1b\ud83d\udfe8\n\ud83d\udfe9\ud83d\udfe9\ud83d\udfe9\ud83d\udfe9\u2b1b\n\ud83d\udfe9\ud83d\udfe9\ud83d\udfe9\ud83d\udfe9\ud83d\udfe9"
      },
      {
        author: "Charlie",
        time: "00:52",
        text: "omg lesbian"
      },
      {
        author: "Jake",
        time: "01:03",
        text: "i got exams soon but im down to forget all responsibilities"
      },
      {
        author: "Charlie",
        time: "01:04",
        text: "i got work but they're begging me to book time off bc i have like a month of pto saved up"
      },
      {
        author: "Jake",
        time: "01:05",
        text: "Wordle 327 4/6\n\ud83d\udfe8\u2b1b\u2b1b\ud83d\udfe8\u2b1b\n\u2b1b\u2b1b\ud83d\udfe9\u2b1b\u2b1b\n\ud83d\udfe9\ud83d\udfe9\ud83d\udfe9\u2b1b\u2b1b\n\ud83d\udfe9\ud83d\udfe9\ud83d\udfe9\ud83d\udfe9\ud83d\udfe9"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Blithe", "Charlie"],
    start: "2022-05-23T23:19:00",
    messages: [
      {
        author: "Charlie",
        time: "23:19",
        text: "yas and yone and irelia are nightmares in general"
      },
      {
        author: "Blithe",
        time: "23:19",
        text: "Good point"
      },
      {
        author: "Charlie",
        time: "23:19",
        text: "not sure there are many champs thinking aw fuck yes irelia"
      },
      {
        author: "Blithe",
        time: "23:20",
        text: "I mean I think gp is broken too don't get me wrong, it's just I feel like there is a little room to play with"
      },
      {
        author: "Blithe",
        time: "23:20",
        text: "But in all honesty lots of league things are a lil busted right now if you ask me"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Blithe", "Nic"],
    start: "2022-06-12T10:30:00",
    messages: [
      {
        author: "Blithe",
        time: "10:30",
        text: "Probably for the better, I've been there too multiple times and felt miserable because I simply kept going. I think a healthy balance between league and other games is the best where you simply have days where you don't play league at all. I feel better like this"
      },
      {
        author: "Nic",
        time: "10:34",
        text: "I just feel like I always like the idea of league but none of the games I lose feel like my fault"
      },
      {
        author: "Nic",
        time: "10:34",
        text: "And that ain't no fun to play"
      },
      {
        author: "Blithe",
        time: "10:36",
        text: "I get that totally, I've had days where I played like 8-10h of league because I wanted a rank and then end up only loosing and feeling terrible. Sometimes it really isn't ones fault"
      },
      {
        author: "Nic",
        time: "10:37",
        text: "How is hold top 25% of the world when people play like this it's infruitating"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Imogen", "Smuck"],
    start: "2022-06-20T18:28:00",
    messages: [
      {
        author: "Imogen",
        time: "18:28",
        text: "Man im poor and need the bank"
      },
      {
        author: "Imogen",
        time: "18:28",
        text: "But also"
      },
      {
        author: "Imogen",
        time: "18:29",
        text: "I have 40 mins till dinner so i doubt we will be done in 40"
      },
      {
        author: "Smuck",
        time: "18:29",
        text: "We will if we put all the good players on one team"
      },
      {
        author: "Imogen",
        time: "18:30",
        text: "Lolll"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Nic", "Sam"],
    start: "2022-07-15T07:47:00",
    messages: [
      {
        author: "Nic",
        time: "07:47",
        text: "It takes a weeb to know a weeb I guess"
      },
      {
        author: "Nic",
        time: "07:48",
        text: "please yes, I usually like the reactions shots if they are in the manga and it's a character's reaction I care about"
      },
      {
        author: "Nic",
        time: "07:48",
        text: "but man having to see every character react to the same thing that isn't even that impressive and them explaining it afterwards"
      },
      {
        author: "Sam",
        time: "07:48",
        text: "listen at least when i am a degen, i go straight to the bottom"
      },
      {
        author: "Nic",
        time: "07:49",
        text: "it feels like they are screaming \"this is for the kids so they'll understand as well\" time"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Jake", "Nic"],
    start: "2022-07-15T07:49:00",
    messages: [
      {
        author: "Nic",
        time: "07:49",
        text: "kids ain't stupid, I remember being annoyed by it when I was a kid aswell"
      },
      {
        author: "Nic",
        time: "07:49",
        text: "but you aren't jakey"
      },
      {
        author: "Jake",
        time: "07:50",
        text: "<:sad:634162978148581416>"
      },
      {
        author: "Nic",
        time: "07:50",
        text: "you're a lil kiddy boy that needs to be kiddy explained"
      },
      {
        author: "Jake",
        time: "07:50",
        text: "where is cinnamon."
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Jake", "Imogen"],
    start: "2022-07-18T18:08:00",
    messages: [
      {
        author: "Imogen",
        time: "18:08",
        text: "The outsides not worth it"
      },
      {
        author: "Imogen",
        time: "18:09",
        text: "I have a fking 40 min bus journey tomorrow in this heat"
      },
      {
        author: "Jake",
        time: "18:10",
        text: "disaster"
      },
      {
        author: "Imogen",
        time: "18:13",
        text: "At least theres a cute dog at the end of the journey"
      },
      {
        author: "Jake",
        time: "18:18",
        text: "okay maybe its worth it.."
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#aww",
    participants: ["Jake", "Imogen"],
    start: "2022-07-19T09:43:00",
    messages: [
      {
        author: "Jake",
        time: "09:43",
        text: "no way"
      },
      {
        author: "Jake",
        time: "09:43",
        text: "ur so lucky"
      },
      {
        author: "Imogen",
        time: "09:44",
        text: "I am i am! Ive put the fan on her too, shes getting so hot in this weather"
      },
      {
        author: "Jake",
        time: "09:45",
        text: "my kitty spends most of her time under the table in the shade downstairs"
      },
      {
        author: "Jake",
        time: "09:45",
        text: "my dad put an ice pack down there that she lay next to"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Charlie", "Nic"],
    start: "2022-07-19T11:33:00",
    messages: [
      {
        author: "Charlie",
        time: "11:33",
        text: "gorilla punches u thats similar force to a car hitting you"
      },
      {
        author: "Charlie",
        time: "11:33",
        text: "u think a car wouldnt kill a bear insta?"
      },
      {
        author: "Nic",
        time: "11:34",
        text: "No? It wouldn't instakill a grizzly bear what are you on about"
      },
      {
        author: "Nic",
        time: "11:34",
        text: "And you think a gorilla is an mma fighter with perfect accuracy?"
      },
      {
        author: "Nic",
        time: "11:34",
        text: "Who just one shots any grizzly that comes near it? It's not really how a fight in nature works"
      },
      {
        author: "Charlie",
        time: "11:34",
        text: "u think it wouldnt incapacitate a bear enough to then wail on it and kill it dead in approximately 2-3 minutes?"
      },
      {
        author: "Nic",
        time: "11:35",
        text: "^"
      },
      {
        author: "Charlie",
        time: "11:35",
        text: "im out i cant watch"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Jake", "Charlie"],
    start: "2022-07-22T14:28:00",
    messages: [
      {
        author: "Jake",
        time: "14:28",
        text: "guyessing they are just gonna have some Got inspired opening ceremony"
      },
      {
        author: "Charlie",
        time: "14:36",
        text: "if veigar didnt have flash that wouldve been such a sick bard play"
      },
      {
        author: "Jake",
        time: "14:37",
        text: "true"
      },
      {
        author: "Jake",
        time: "14:37",
        text: "chad bard"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Fishes", "Jake"],
    start: "2022-07-25T15:55:00",
    messages: [
      {
        author: "Fishes",
        time: "15:55",
        text: "oh no i was just saying hes doing a bit of trolling i get why he was doing it"
      },
      {
        author: "Jake",
        time: "15:55",
        text: "i wonder how well you would do"
      },
      {
        author: "Jake",
        time: "15:55",
        text: "prediciting off draft"
      },
      {
        author: "Jake",
        time: "15:55",
        text: "who wins high elo ranked games"
      },
      {
        author: "Fishes",
        time: "15:55",
        text: "an hr to get into game to then lose to a 15min stomp"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#games-chat",
    participants: ["Fishes", "Smuck"],
    start: "2022-07-28T20:52:00",
    messages: [
      {
        author: "Smuck",
        time: "20:52",
        text: "Wait is there a way to turn on speech bubbles when people type in FFXIV??"
      },
      {
        author: "Smuck",
        time: "20:53",
        text: "That was the biggest thing holding me back from engaging in the community since I had to read everyone's message from the lil chat on the side which didn't feel at all personal"
      },
      {
        author: "Smuck",
        time: "20:53",
        text: "But if they have added WoW style chat bubbles.... I might get back on the horse"
      },
      {
        author: "Fishes",
        time: "20:55",
        text: "not being able to talk to the alliance as horde is kinda funny as well"
      },
      {
        author: "Smuck",
        time: "20:57",
        text: "Yeh, especially since people figured out how to type simple words by typing garbage"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Fishes", "Blithe"],
    start: "2022-07-28T21:01:00",
    messages: [
      {
        author: "Blithe",
        time: "21:01",
        text: "Bold of you to assume that I got the power to do that"
      },
      {
        author: "Fishes",
        time: "21:03",
        text: "smuck has the power"
      },
      {
        author: "Fishes",
        time: "21:03",
        text: "his swedish tongue has skill"
      },
      {
        author: "Fishes",
        time: "21:04",
        text: "maybe u do with your french"
      },
      {
        author: "Blithe",
        time: "21:05",
        text: "Fr*nch ain't gonna do the trick, my german might help. Has a long history when it comes to convincing people"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#aww",
    participants: ["Blithe", "Charlie"],
    start: "2022-08-02T23:31:00",
    messages: [
      {
        author: "Blithe",
        time: "23:31",
        text: "I think it is probably because like it's very fine in terms of fiber and they could get their paws stuck or wrapped around in it smth like that"
      },
      {
        author: "Charlie",
        time: "23:31",
        text: "more concerned about the ball being bad"
      },
      {
        author: "Blithe",
        time: "23:31",
        text: "yeah I mean that's smth I'd never do"
      },
      {
        author: "Blithe",
        time: "23:32",
        text: "They only see like a couple cm ahead of them, bad idea overall"
      },
      {
        author: "Blithe",
        time: "23:32",
        text: "used to have one, great pets imo"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Fishes", "Smuck"],
    start: "2022-08-03T19:05:00",
    messages: [
      {
        author: "Fishes",
        time: "19:05",
        text: "i don't want to put words in jake's mouth but to me its less about him flaming your skill.  hes just trying to say if you're trying to leg it trying to space without using abilities is better"
      },
      {
        author: "Fishes",
        time: "19:05",
        text: "unless they're already on top of u"
      },
      {
        author: "Fishes",
        time: "19:06",
        text: "or their gap closer is on cd so u can cast for free"
      },
      {
        author: "Smuck",
        time: "19:07",
        text: "I will join once I get home from grocery store!"
      },
      {
        author: "Fishes",
        time: "19:07",
        text: "its the same as instead of casting blitz q u run up and e them"
      },
      {
        author: "Fishes",
        time: "19:10",
        text: "in hind sight u were caught anyways cause u were too far up anyways"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Imogen", "Nic"],
    start: "2022-08-05T21:28:00",
    messages: [
      {
        author: "Nic",
        time: "21:28",
        text: "Man if I don't like playing this new udyr I retiring forever from lol"
      },
      {
        author: "Imogen",
        time: "21:28",
        text: "Whats going on"
      },
      {
        author: "Nic",
        time: "21:30",
        text: "Looks wise he doesn't look as cool as the old one did"
      },
      {
        author: "Nic",
        time: "21:31",
        text: "Always looked at him like a shaman not like a beast man"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Imogen", "Blithe"],
    start: "2022-08-12T21:21:00",
    messages: [
      {
        author: "Imogen",
        time: "21:21",
        text: "I live in a village so im hopeing !"
      },
      {
        author: "Imogen",
        time: "21:22",
        text: "We are surrounded by a lot of farm land"
      },
      {
        author: "Blithe",
        time: "21:22",
        text: "oh yeah you should be like 98% fine in that case"
      },
      {
        author: "Imogen",
        time: "21:22",
        text: "I can see a few bright stars already so heres to hoping that they come out later"
      },
      {
        author: "Blithe",
        time: "21:26",
        text: "okay figured out again where the star constellation thingy is, I think if I'm correct frequency should be higher Northeast? Perseus sign in the sky but I can never find it"
      },
      {
        author: "Blithe",
        time: "21:27",
        text: "but ofc it's across the sky, just meant it like orientation wise"
      },
      {
        author: "Imogen",
        time: "21:28",
        text: "Oh reading constellations have always confused me"
      },
      {
        author: "Blithe",
        time: "21:28",
        text: "my internet be trolling"
      },
      {
        author: "Blithe",
        time: "21:29",
        text: "didn't meant to send it twice"
      },
      {
        author: "Blithe",
        time: "21:29",
        text: "oh dw even I can't fking figure it out a most of the time, even with a map"
      },
      {
        author: "Blithe",
        time: "21:29",
        text: "I just go by like North south east and all that"
      },
      {
        author: "Imogen",
        time: "21:30",
        text: "Constellations are so cool but i have no clue how people see the difference in them all"
      },
      {
        author: "Imogen",
        time: "21:30",
        text: "Its insane"
      },
      {
        author: "Blithe",
        time: "21:30",
        text: "some are easier than others to see, some just don't make sense at all"
      },
      {
        author: "Blithe",
        time: "21:31",
        text: "but I love astronomy, it's pretty cool"
      },
      {
        author: "Imogen",
        time: "21:32",
        text: "I\u2019ve only started to take interest in space etc this year, the james webb telescope when it was announced really set it off"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Fishes", "Smuck"],
    start: "2022-08-23T13:35:00",
    messages: [
      {
        author: "Smuck",
        time: "13:35",
        text: "Always up to something? Tomfoolery afoot. I can imagining them running around with lil sound effects just setting up lil booby-traps for the other coworkers to fall into"
      },
      {
        author: "Fishes",
        time: "13:36",
        text: "rp scene sounds a bit intense"
      },
      {
        author: "Smuck",
        time: "13:36",
        text: "Your manager at work when the africans pull up be like"
      },
      {
        author: "Fishes",
        time: "13:41",
        text: "i guess u have to be this kind of person to play nunu"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Jake", "Blithe"],
    start: "2022-09-02T09:17:00",
    messages: [
      {
        author: "Blithe",
        time: "09:17",
        text: "I'm ready for round 2 of my heart attack as a FNC fan"
      },
      {
        author: "Jake",
        time: "09:17",
        text: "man its tough for us"
      },
      {
        author: "Jake",
        time: "09:17",
        text: "if we go down 0-2 i will not be able to take it"
      },
      {
        author: "Blithe",
        time: "09:18",
        text: "another reverse sweep may actually fking kill me"
      },
      {
        author: "Blithe",
        time: "09:19",
        text: "I mean I'm happy they made it but holy fuck, it was sooo close"
      },
      {
        author: "Blithe",
        time: "09:19",
        text: "and if fnc loose to msf my hope for the roster is gone"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Blithe", "Smuck"],
    start: "2022-09-02T10:24:00",
    messages: [
      {
        author: "Smuck",
        time: "10:24",
        text: "The racoon is"
      },
      {
        author: "Blithe",
        time: "10:25",
        text: "I've been on that normal sleep schedule for a couple weeks now and look at me, fine as ever"
      },
      {
        author: "Smuck",
        time: "10:25",
        text: "This!"
      },
      {
        author: "Smuck",
        time: "10:26",
        text: "R3bbid your life is falling apart. First you didn't get into the military, you're a Fnatic fan and you got that 9-5 sleep schedule. Time to accept it's time for a change"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Imogen", "Smuck"],
    start: "2022-09-02T20:25:00",
    messages: [
      {
        author: "Smuck",
        time: "20:25",
        text: "I haven't even read any earlier statements, I just think if you wanna play you should say yes and if not no"
      },
      {
        author: "Smuck",
        time: "20:26",
        text: "But. Is what it is. we'll get customs some other night, I believe"
      },
      {
        author: "Imogen",
        time: "20:27",
        text: "Downloading while eating"
      },
      {
        author: "Smuck",
        time: "20:27",
        text: "For now. It's sleep time cause I've started to live like a retired old man."
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Fishes", "Nic"],
    start: "2022-09-10T17:38:00",
    messages: [
      {
        author: "Nic",
        time: "17:38",
        text: "thank you, was about to say"
      },
      {
        author: "Fishes",
        time: "17:38",
        text: "just cause everyone is doing doesn't mean im automatically gona think its good"
      },
      {
        author: "Nic",
        time: "17:38",
        text: "fair, but I only bought them because we were ahead in the start and then it when dowhill"
      },
      {
        author: "Nic",
        time: "17:39",
        text: "thought If I got tanky items quickly because we were snowballing then it would be fine"
      },
      {
        author: "Nic",
        time: "17:39",
        text: "but then I died 8 times and cried"
      },
      {
        author: "Fishes",
        time: "17:39",
        text: "cdr doesn't sound like a great stat on him"
      },
      {
        author: "Fishes",
        time: "17:39",
        text: "you're getting at most 2 es on zac in a fight"
      },
      {
        author: "Fishes",
        time: "17:39",
        text: "his w doesn't care about cdr"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Charlie", "Smuck"],
    start: "2022-09-22T16:18:00",
    messages: [
      {
        author: "Smuck",
        time: "16:18",
        text: "Song is really good. Video could use some better names to be animated. Like, I dunno. A worlds representative from each of the 4 regions. I mean Corejj isn't even at worlds this year and Humanoid is on the 4th seed from the LEC. Meiko and Chovy makes sense but the people picked for the west I dunno man"
      },
      {
        author: "Smuck",
        time: "16:18",
        text: "(I also could not tell the EU guy was supposed to be humanoid)"
      },
      {
        author: "Charlie",
        time: "16:19",
        text: "meiko such a cringe choice"
      },
      {
        author: "Charlie",
        time: "16:19",
        text: "ask everybody in the world who their favourite pro is not one person says meiko"
      },
      {
        author: "Charlie",
        time: "16:19",
        text: "meiko's parents prefer xiaohu"
      },
      {
        author: "Smuck",
        time: "16:19",
        text: "Haven't watched a lick of lpl this season, so couldn't say myself"
      },
      {
        author: "Smuck",
        time: "16:20",
        text: "One year I want the worlds theme to be heavy metal tho"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Jake", "Nic"],
    start: "2022-10-28T20:13:00",
    messages: [
      {
        author: "Nic",
        time: "20:13",
        text: "Grown men watching an anime harem show about anime girls dating their brother  and are rating who is the best girl"
      },
      {
        author: "Jake",
        time: "20:13",
        text: "ninos confession scene is literally one of the best"
      },
      {
        author: "Nic",
        time: "20:14",
        text: "What's next you gonna talk about who is best girl in oreimo?"
      },
      {
        author: "Nic",
        time: "20:14",
        text: "Dissapointed in you guys"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Jake", "Nic"],
    start: "2022-10-28T21:26:00",
    messages: [
      {
        author: "Jake",
        time: "21:26",
        text: "why"
      },
      {
        author: "Nic",
        time: "21:35",
        text: "Because I just don't get enjoyment from watching an anime about girls wanting one guy or the opposite.  It isn't interesting and quite boring and there are tons of more interesting concepts with better stories that I still need to watch."
      },
      {
        author: "Nic",
        time: "21:37",
        text: "And well I also just feel cringe seeing it. Even if it is okay. It's like when I became 20 my brain started thinking \"I am a grown man watching a romance about underaged girls liking a boring protag who is kind of an asshole or uninteresting\""
      },
      {
        author: "Jake",
        time: "21:37",
        text: "i feel like a lotta of your issues go away if the series has a strong main character"
      },
      {
        author: "Nic",
        time: "21:37",
        text: "And well I feel like even if the show is good the concept of a guy trying to date his quintuplet step sisters is just cringe man"
      },
      {
        author: "Jake",
        time: "21:38",
        text: "mann thats the point"
      },
      {
        author: "Nic",
        time: "21:38",
        text: "Even if the protag is strong there are just better  concepts dude"
      },
      {
        author: "Jake",
        time: "21:38",
        text: "uesugi is a fucking chad who diesbt want to date any of them"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Jake", "Nic"],
    start: "2022-10-28T21:39:00",
    messages: [
      {
        author: "Jake",
        time: "21:39",
        text: "until like 2 seasons and a movie later he decides he likes one of them"
      },
      {
        author: "Jake",
        time: "21:39",
        text: "i mean you have a fair point tbh i also enjoy normal rom coms more then harems"
      },
      {
        author: "Jake",
        time: "21:40",
        text: "but there are still good harem anime that are much better then other rom coms"
      },
      {
        author: "Jake",
        time: "21:40",
        text: "quintuplets being one"
      },
      {
        author: "Nic",
        time: "21:40",
        text: "But it still isn't interesting to me. There are 100s of shows about them and the concept is boring and isn't something I personally like. I wanna see shit like monster, mob psycho, paranoia agent, perfect blue etc."
      },
      {
        author: "Jake",
        time: "21:40",
        text: "okay thats fair"
      },
      {
        author: "Jake",
        time: "21:40",
        text: "so you dont like slice of life"
      },
      {
        author: "Nic",
        time: "21:41",
        text: "And I dunno I don't think there is a world you can convince me that quintuplets is as interesting or even as close as those shows"
      },
      {
        author: "Nic",
        time: "21:41",
        text: "I have a life I don't feel the need to see someone else have it too"
      },
      {
        author: "Jake",
        time: "21:41",
        text: "honestly"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Charlie", "Nic"],
    start: "2022-11-11T16:08:00",
    messages: [
      {
        author: "Charlie",
        time: "16:08",
        text: "its not on this"
      },
      {
        author: "Nic",
        time: "16:09",
        text: "They think that counter jungling is too punishing especially against new jungle players. It also allow the enemy jungler to snowball too hard"
      },
      {
        author: "Nic",
        time: "16:09",
        text: "Yeah as the video states they haven't said anything about it"
      },
      {
        author: "Nic",
        time: "16:09",
        text: "But it is live on the pbe"
      },
      {
        author: "Nic",
        time: "16:09",
        text: "Just haven't mentioned it in an update for some weird reason"
      },
      {
        author: "Charlie",
        time: "16:09",
        text: "oh its like 15% less damage"
      },
      {
        author: "Nic",
        time: "16:10",
        text: "Ye"
      },
      {
        author: "Charlie",
        time: "16:10",
        text: "you can still counter jungle"
      },
      {
        author: "Nic",
        time: "16:10",
        text: "You can"
      },
      {
        author: "Charlie",
        time: "16:10",
        text: "you just cant bend people over as hard any more"
      },
      {
        author: "Nic",
        time: "16:10",
        text: "Exactly"
      },
      {
        author: "Charlie",
        time: "16:10",
        text: "thats good"
      },
      {
        author: "Nic",
        time: "16:10",
        text: "I think that is a good change aswell. It also makes it enemy jungle start even worse because you gain lvls slower and early game in the jungle is very important"
      },
      {
        author: "Nic",
        time: "16:11",
        text: "I think they will need to change kindred up a bit tho. Because she will be hit the hardest"
      },
      {
        author: "Charlie",
        time: "16:11",
        text: "itll be fine"
      },
      {
        author: "Charlie",
        time: "16:12",
        text: "its like when they nerfed scuttle xp"
      },
      {
        author: "Charlie",
        time: "16:12",
        text: "all the xin zhao and j4 mains just complained for ages until they realised it didnt matter"
      },
      {
        author: "Nic",
        time: "16:14",
        text: "Truee, but scuttle still gives vision. I dunno we'd have to see. Atleast it is more discouraging. I think the important part is that you are more able to notice counter jungling and do more about it. The amount of times I see my chickens getting beat and I can't make it because the enemy jungler clears them in 1 second is unfathomable"
      },
      {
        author: "Nic",
        time: "16:14",
        text: "Nice"
      },
      {
        author: "Charlie",
        time: "16:15",
        text: "i think its fine to discourage counter jungling a lil bit"
      },
      {
        author: "Charlie",
        time: "16:16",
        text: "getting gapped in jg removes you from the game so much more than getting gapped anywhere else"
      },
      {
        author: "Nic",
        time: "16:17",
        text: "Yes exactly. Jungle is too punishing so well done riot. Good idea. It seems they are thinking of more stuff aswell to make it harder to counter jungle. Again I think the 15% less damage and one more small thing should be enough"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Jake", "Blithe"],
    start: "2022-11-15T17:00:00",
    messages: [
      {
        author: "Jake",
        time: "17:00",
        text: "a vector parametric equation can be derived from the cartesian equation via the gaussian elimination method"
      },
      {
        author: "Blithe",
        time: "17:01",
        text: "fair, I need to solve a differntial equation of the 2nd order though which I haven't even learned"
      },
      {
        author: "Blithe",
        time: "17:01",
        text: "because physicist are dumb"
      },
      {
        author: "Jake",
        time: "17:02",
        text: "o thats not too bad"
      },
      {
        author: "Jake",
        time: "17:02",
        text: "suprsied they haven't taught you that if you need it"
      },
      {
        author: "Blithe",
        time: "17:02",
        text: "it's how they do it, I talked to multiple people and it's usual that they just \"assume\" that you are able to do them"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Fishes", "Nic"],
    start: "2022-11-30T14:45:00",
    messages: [
      {
        author: "Nic",
        time: "14:45",
        text: "<@&1046193185078136925> yo 1v1'ers\nthis is the brackets for the tournament"
      },
      {
        author: "Fishes",
        time: "14:46",
        text: "???"
      },
      {
        author: "Fishes",
        time: "14:46",
        text: "why is dorse roasting me"
      },
      {
        author: "Nic",
        time: "14:46",
        text: "1v1s\nbest of 5\nfirst kill or first to 100 cs\nr/p/s or whatever the players decide to do to figure who will start\nwhoever starts gets to choose the champion the players are playing in the first round\nthen whoever loses will decide what champion to take next\nThe same champion can not be chosen twice in a match.\nWe will use Summoner's rift, basing will not be allowed and neither will entering the fountain after it has been left\nyou are only allowed to be in the mid lane\njungle camps and rift and dragon are off limits\nBoth players have to choose flash, the second summoner spell is up to the individual player."
      },
      {
        author: "Nic",
        time: "14:47",
        text: "<@&1046193185078136925> you have till next Wednesday to finish your first match, remember to give an update to me  as to who won the match when you are done"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Freddie", "Charlie"],
    start: "2022-12-24T14:03:00",
    messages: [
      {
        author: "Freddie",
        time: "14:03",
        text: "ok its actually very hard"
      },
      {
        author: "Freddie",
        time: "14:03",
        text: "when they are moving"
      },
      {
        author: "Charlie",
        time: "14:12",
        text: "whats the combo here"
      },
      {
        author: "Charlie",
        time: "14:13",
        text: "are you prowlers clawing then flashing backwards?"
      },
      {
        author: "Freddie",
        time: "14:15",
        text: "ye, prowlers then flash away, prowlers still goes through then ult away"
      },
      {
        author: "Freddie",
        time: "14:16",
        text: "but i have to time the flash perfectly or prowlers gets cancelled"
      },
      {
        author: "Freddie",
        time: "14:16",
        text: "and when they are moving its hard"
      },
      {
        author: "Charlie",
        time: "14:19",
        text: "there was one i saw faker doing a lot but i couldnt get it to work in practice tool"
      },
      {
        author: "Charlie",
        time: "14:19",
        text: "same concept but on zed"
      },
      {
        author: "Charlie",
        time: "14:19",
        text: "you prowlers then go to your w but your prowlers still goes off"
      },
      {
        author: "Charlie",
        time: "14:20",
        text: "the only vid i can find is tiktok im so sorry"
      },
      {
        author: "Freddie",
        time: "14:42",
        text: "timing is really hard"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#games-chat",
    participants: ["Jake", "Smuck"],
    start: "2022-12-27T19:16:00",
    messages: [
      {
        author: "Smuck",
        time: "19:16",
        text: "Anyone wanna do Kareoke at some point tonight? Feeling very singy tonight, would love to have a duet with someone \ud83e\udd7a"
      },
      {
        author: "Jake",
        time: "19:17",
        text: "ill join the call if you do but am feeling like pooooop rn"
      },
      {
        author: "Jake",
        time: "19:18",
        text: "too ill :c"
      },
      {
        author: "Smuck",
        time: "19:18",
        text: ": ("
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#games-chat",
    participants: ["Jake", "Smuck"],
    start: "2023-01-03T10:23:00",
    messages: [
      {
        author: "Smuck",
        time: "10:23",
        text: "<@&852249119895322624> How would everyone feel about doing a northgard 1v1 tournament"
      },
      {
        author: "Jake",
        time: "10:23",
        text: "how is the 1v1 meta"
      },
      {
        author: "Smuck",
        time: "10:23",
        text: "Me and Freddie would be able to play whenever, except we should probably not be on the same bracket cause we only have 1 pc"
      },
      {
        author: "Smuck",
        time: "10:24",
        text: "I dunno. I never play it, but would be fun to do I think"
      },
      {
        author: "Jake",
        time: "10:24",
        text: "maybe be"
      },
      {
        author: "Jake",
        time: "10:24",
        text: "i would be down"
      },
      {
        author: "Jake",
        time: "10:24",
        text: "but ngl if we have enough"
      },
      {
        author: "Jake",
        time: "10:24",
        text: "a 2v2 tourney would be fucking amazing"
      },
      {
        author: "Jake",
        time: "10:24",
        text: "maybe save that for when you and freddie are back"
      },
      {
        author: "Smuck",
        time: "10:25",
        text: "Ye? I would be down for that. But it'd have to wait until we back home"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#cannae-talk",
    participants: ["Fishes", "Nic"],
    start: "2023-01-11T10:43:00",
    messages: [
      {
        author: "Fishes",
        time: "10:43",
        text: "i can't remember the name"
      },
      {
        author: "Nic",
        time: "10:43",
        text: "So based after gx it went downhill"
      },
      {
        author: "Fishes",
        time: "10:44",
        text: "there was on on the browser but it always gets taken down"
      },
      {
        author: "Fishes",
        time: "10:44",
        text: "syncro summoners"
      },
      {
        author: "Nic",
        time: "10:44",
        text: "Well depends on the condition and rarity it is easy to search up. But usually it depends on the competitive nature of the card of how old it is"
      },
      {
        author: "Nic",
        time: "10:44",
        text: "No clue how much you can get from relinqusihed a mint con might go for 15-20 bucks"
      },
      {
        author: "Nic",
        time: "10:44",
        text: "But no clue"
      },
      {
        author: "Nic",
        time: "10:45",
        text: "It's up again"
      },
      {
        author: "Nic",
        time: "10:45",
        text: "If it is there is a program"
      },
      {
        author: "Nic",
        time: "10:45",
        text: "Ygopro"
      },
      {
        author: "Fishes",
        time: "10:45",
        text: "ill have a look"
      },
      {
        author: "Nic",
        time: "10:45",
        text: "If you want I'd be down to beat yo ass in a gx battle"
      },
      {
        author: "Fishes",
        time: "10:45",
        text: "cause i tried playing the yu-gi-oh on steam"
      },
      {
        author: "Nic",
        time: "10:45",
        text: "I promise not to go cyber dragon"
      },
      {
        author: "Fishes",
        time: "10:45",
        text: "that shit is solitaire"
      },
      {
        author: "Nic",
        time: "10:46",
        text: "Yep, the back and forth is gone it is 10 minute turns and 1 turn kills"
      },
      {
        author: "Fishes",
        time: "10:46",
        text: "literally lose the whole game from a children's game"
      },
      {
        author: "Fishes",
        time: "10:46",
        text: "any dark magicians"
      },
      {
        author: "Nic",
        time: "10:46",
        text: "Never liked the new mrta that's why I buy cards but I make my secks balanced and able to play with each other so no combo is too long but you are still able to do stuff. I feel like link is where it really fucked up"
      },
      {
        author: "Nic",
        time: "10:47",
        text: "Fucking pendulums when they just came out homy shit"
      },
      {
        author: "Nic",
        time: "10:47",
        text: "Same with links that you had to have links else you couldn't summon more of other cards"
      },
      {
        author: "Fishes",
        time: "10:47",
        text: "ye they pretty much play themselves"
      },
      {
        author: "Nic",
        time: "10:47",
        text: "I am fine with synchro and xyz because it makes the game a lil more mechanical but they got too crazy"
      },
      {
        author: "Fishes",
        time: "10:47",
        text: "a friend was showing me how one of the meta decks workjs"
      },
      {
        author: "Nic",
        time: "10:47",
        text: "Sex"
      },
      {
        author: "Fishes",
        time: "10:47",
        text: "and it sounds so brainless"
      },
      {
        author: "Nic",
        time: "10:47",
        text: "It is man"
      },
      {
        author: "Nic",
        time: "10:48",
        text: "Yugioh is learning your own deck play for 10 min and hope your enemy don't have a handtrap and then when it is his turn he has to have a dark ruler og forbidden droplet else it is vs 30 negates"
      },
      {
        author: "Nic",
        time: "10:49",
        text: "Yugioh was fun when it was a back and forth. Like damn trap cards are unplayable if it can't be played as a hand trap"
      },
      {
        author: "Fishes",
        time: "10:49",
        text: "i feel like thats kinda a perquisite for a card game to be fun"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Jake", "Imogen"],
    start: "2023-01-20T11:51:00",
    messages: [
      {
        author: "Imogen",
        time: "11:51",
        text: "Besties im so embarrassed"
      },
      {
        author: "Imogen",
        time: "11:51",
        text: "I just got hit on and was asked for my wattsapp, then facebook then instagram then teams"
      },
      {
        author: "Imogen",
        time: "11:51",
        text: "And then im like \u201cnah i dont use social media\u201d and turned my phone as im playing pokemon and go \u201ci only have pokemon go:)\u201d"
      },
      {
        author: "Jake",
        time: "11:53",
        text: "lmao"
      },
      {
        author: "Jake",
        time: "11:54",
        text: "pokemon go is the best social media"
      },
      {
        author: "Imogen",
        time: "11:55",
        text: "She kept trying to talk to me after and im looking at eva like help"
      },
      {
        author: "Jake",
        time: "11:56",
        text: "she really didnt get the message after that lol"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Jake", "Blithe"],
    start: "2023-01-23T00:42:00",
    messages: [
      {
        author: "Blithe",
        time: "00:42",
        text: "Insomnia's a fucking bitch. Been trying to sleep for 3h now <:mentalillness:913878203616088094>"
      },
      {
        author: "Jake",
        time: "00:42",
        text: ":c"
      },
      {
        author: "Jake",
        time: "00:43",
        text: "ngl when i cant sleep i literally just dont"
      },
      {
        author: "Jake",
        time: "00:43",
        text: "but that can be tough when you have uni and need to get up for stuff :c"
      },
      {
        author: "Blithe",
        time: "00:44",
        text: "Yeah"
      },
      {
        author: "Blithe",
        time: "00:45",
        text: "At this point I believe going to uni is pointless tomorrow, 4h sleep and maths + physics lectures + I need to learn for smth on Wednesday sounds like a recipe for doom"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#games-chat",
    participants: ["Kaddy", "Smuck"],
    start: "2023-02-19T02:19:00",
    messages: [
      {
        author: "Kaddy",
        time: "02:19",
        text: "died"
      },
      {
        author: "Kaddy",
        time: "02:19",
        text: "RIP"
      },
      {
        author: "Smuck",
        time: "02:19",
        text: "Damn. Well I guess that's as good a reason as any to end the conversation"
      },
      {
        author: "Kaddy",
        time: "02:20",
        text: "smuck thinks making medication is murder so we'll have to go into that some other day but good night for now"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#games-chat",
    participants: ["Kaddy", "Smuck"],
    start: "2023-02-19T13:23:00",
    messages: [
      {
        author: "Smuck",
        time: "13:23",
        text: "That's obviously immoral"
      },
      {
        author: "Kaddy",
        time: "13:24",
        text: "ok so stop making new drugs cause you could accidentally fuck up"
      },
      {
        author: "Kaddy",
        time: "13:25",
        text: "case in point"
      },
      {
        author: "Smuck",
        time: "13:26",
        text: "When you say they you mean the doctors? I thought it was the patient and the doctors are like \"ye this is 50/50 but y'know\""
      },
      {
        author: "Smuck",
        time: "13:28",
        text: "If they thought it was good but then wasn't then it's not immoral. However the person being prescribed medicine should always be informed if the med is experimental. Like as far as I understand it its pretty common practice in medicine to put up flyers asking people to try new medicine in exchange for money"
      },
      {
        author: "Smuck",
        time: "13:29",
        text: "But doing experiments without their knowledge ala CIA is most definitely immoral"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Charlie", "Smuck"],
    start: "2023-04-09T17:18:00",
    messages: [
      {
        author: "Smuck",
        time: "17:18",
        text: "It's fine, Crownie got this"
      },
      {
        author: "Smuck",
        time: "17:18",
        text: "Best AD in LEC. I have faith in him even if Adam has an oopsie game"
      },
      {
        author: "Charlie",
        time: "17:19",
        text: "no galeforce"
      },
      {
        author: "Charlie",
        time: "17:19",
        text: "crownie can play the game i think"
      },
      {
        author: "Smuck",
        time: "17:21",
        text: "YES BABY"
      },
      {
        author: "Smuck",
        time: "17:21",
        text: "Will say tho, don't like cracken in this game. Galeforce would be better"
      },
      {
        author: "Charlie",
        time: "17:23",
        text: "ah i forgot there's only 3 good ahri players in the world"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#games-chat",
    participants: ["Fishes", "Jake"],
    start: "2023-05-27T16:22:00",
    messages: [
      {
        author: "Jake",
        time: "16:22",
        text: "a rivalry as old as time"
      },
      {
        author: "Fishes",
        time: "16:26",
        text: "cd keys is cheaper"
      },
      {
        author: "Fishes",
        time: "16:26",
        text: "its \u00a311"
      },
      {
        author: "Fishes",
        time: "16:28",
        text: "probably not gona beable to start 5 <:peepoGlad:593197937136369675>"
      },
      {
        author: "Fishes",
        time: "16:29",
        text: "i can just sigma it tbh"
      },
      {
        author: "Fishes",
        time: "16:30",
        text: "so dw about me"
      },
      {
        author: "Jake",
        time: "16:30",
        text: "you have a decent amount of progression you need to do solo anyway"
      },
      {
        author: "Jake",
        time: "16:30",
        text: "i dont think its that a big a deal to miss the start"
      },
      {
        author: "Fishes",
        time: "16:30",
        text: "ah ok"
      },
      {
        author: "Fishes",
        time: "16:30",
        text: "also i have the intention of taking my god damn sweet time"
      },
      {
        author: "Fishes",
        time: "16:30",
        text: "so i don't think anyone wants to be subjected to that"
      },
      {
        author: "Jake",
        time: "16:30",
        text: "its not like valheim where you are going to miss a bunch of content just cause others are rushing"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Jake", "Charlie"],
    start: "2023-06-03T01:57:00",
    messages: [
      {
        author: "Charlie",
        time: "01:57",
        text: "na has a different attitude to amateur teams compared to the rest of the world"
      },
      {
        author: "Charlie",
        time: "01:57",
        text: "eu teams arent required to have a tier 2 team but most of them have one in the erls anyway"
      },
      {
        author: "Charlie",
        time: "01:59",
        text: "na (or at least the orgs) for the most part have no interest in developing talent, and if they arent literally forced to theyd rather just get by signing whatever eastern players they can and recycling the same 30 year old lcs veterans"
      },
      {
        author: "Jake",
        time: "02:02",
        text: "if the orgs are not interested then dont force them to do so"
      },
      {
        author: "Jake",
        time: "02:02",
        text: "an amature scene will still exist"
      },
      {
        author: "Jake",
        time: "02:04",
        text: "the main difference will be that paychecks for na amateur scene will go down but like if no one if watching your league in the first place that just kinda sounds like how it should be"
      },
      {
        author: "Charlie",
        time: "02:06",
        text: "\ud83d\udc4ebad take"
      },
      {
        author: "Charlie",
        time: "02:06",
        text: "unlucky"
      },
      {
        author: "Jake",
        time: "02:08",
        text: "sorry forgot we should force na orgs to throw away money its not like the ones struggling for money right now are imploding"
      },
      {
        author: "Charlie",
        time: "02:23",
        text: "guys im losing money can someone whos good at budgeting help me\n- food - 200\n- data - 150\n- rent - 800\n- a single mid-tier eastern player who doesnt speak any english and is 100% using this as an opportunity to make some cash before retirement - 3 million a year\n- utilities - 250"
      },
      {
        author: "Charlie",
        time: "02:25",
        text: "na salaries are so much higher than eu or kr and academy players would happily play for low pay if progression and promotion were reasonable,"
      },
      {
        author: "Jake",
        time: "02:26",
        text: "why does this change any of that"
      },
      {
        author: "Jake",
        time: "02:27",
        text: "the amount of teams who foster straight from their own academy team is really not that high"
      },
      {
        author: "Charlie",
        time: "02:27",
        text: "yeah exactly"
      },
      {
        author: "Charlie",
        time: "02:28",
        text: "now its not a requirement that number is gonna go from not that high to basically nothing"
      },
      {
        author: "Charlie",
        time: "02:30",
        text: "its so rare that an na org is paying close attention to amateur to scout out some fresh talent, theyd all much rather just sign aphromoo again then see which imports they can poach"
      },
      {
        author: "Jake",
        time: "02:31",
        text: "in eu when they dropped the org requirment things didnt change at all if anything erl is bigger now then ever"
      },
      {
        author: "Jake",
        time: "02:32",
        text: "forcing orgs to spend all this money on the theory of maybe there would be a little more pull from the amateur scene then otherwise"
      },
      {
        author: "Jake",
        time: "02:33",
        text: "it just doesnt make financial sense"
      },
      {
        author: "Jake",
        time: "02:33",
        text: "an amateur scene will still exist"
      },
      {
        author: "Jake",
        time: "02:33",
        text: "if anything the orgs that come in are gonna care about their team more then orgs do now"
      },
      {
        author: "Charlie",
        time: "02:35",
        text: "i doubt it but i guess we'll  have to see"
      },
      {
        author: "Jake",
        time: "02:37",
        text: "the real fucking enemy is riot discussing lifting the import cap from 2 to 3"
      },
      {
        author: "Jake",
        time: "02:37",
        text: "thats how you fucking kill an amateur scene"
      },
    ],
  },
  {
    server: "Accountability",
    channel: "#accountabilty-updates",
    participants: ["Freddie", "Charlie"],
    start: "2023-06-07T20:52:00",
    messages: [
      {
        author: "Freddie",
        time: "20:52",
        text: "pushups and situps done, also i ran yesterday but forgot to say"
      },
      {
        author: "Charlie",
        time: "21:00",
        text: "you didnt forget you put it in the other chat like a chump"
      },
      {
        author: "Freddie",
        time: "21:01",
        text: "oh mb"
      },
      {
        author: "Freddie",
        time: "21:01",
        text: "i am a fool"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Blithe", "Smuck"],
    start: "2023-06-22T23:57:00",
    messages: [
      {
        author: "Blithe",
        time: "23:57",
        text: "Well I'll probably be checking out the pride parade in my town that's coming up this weekend, that's cool. Planned on going there for a while but never ended up doing so<:PogU:667035996285829139>"
      },
      {
        author: "Smuck",
        time: "00:00",
        text: "You sure you're not gay? You seem like a bit too excited to be straight"
      },
      {
        author: "Blithe",
        time: "00:04",
        text: "Never said I'm straight"
      },
      {
        author: "Blithe",
        time: "00:04",
        text: "But yes I am also not gay"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Jake", "Blithe"],
    start: "2023-06-23T00:18:00",
    messages: [
      {
        author: "Jake",
        time: "00:18",
        text: "thats epic"
      },
      {
        author: "Blithe",
        time: "00:23",
        text: "Yeee, figured I probably shouldn't study all weekend so a friend of mine hit me up with the suggestion"
      },
      {
        author: "Blithe",
        time: "00:26",
        text: "Still figuring out but I got an idea of what I think it is"
      },
      {
        author: "Jake",
        time: "00:38",
        text: "dr stone spoilers"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#games-chat",
    participants: ["Jake", "Kaddy"],
    start: "2023-07-07T17:51:00",
    messages: [
      {
        author: "Kaddy",
        time: "17:51",
        text: "petition to prioritize teleportation in science so we can visit our cats while abroad"
      },
      {
        author: "Jake",
        time: "17:51",
        text: "i will be signing"
      },
      {
        author: "Kaddy",
        time: "17:51",
        text: "maybe... not sure if I have the energy to learn a big ol new game tho"
      },
      {
        author: "Kaddy",
        time: "18:04",
        text: "dude I love runner ducks"
      },
      {
        author: "Kaddy",
        time: "18:04",
        text: "they're so goofy"
      },
      {
        author: "Kaddy",
        time: "18:05",
        text: "(the best one of ours actually passed away today u.u she was gentle and smart and lovely)"
      },
      {
        author: "Kaddy",
        time: "18:06",
        text: "sorry for bringing down the mood lemme now bring it back up with this exquisite cat I met yesterday"
      },
      {
        author: "Kaddy",
        time: "18:11",
        text: "would anyone be interested in playing some maze rats by chance?\n(is basically DnD but easy and randomized unless you don't want it to)"
      },
      {
        author: "Kaddy",
        time: "18:11",
        text: "I have a few maps that I prepared but never got to run"
      },
      {
        author: "Jake",
        time: "18:33",
        text: "im sorry for your loss, i hope she had a wonderful life"
      },
      {
        author: "Jake",
        time: "18:33",
        text: "that is a great cat"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Nils", "Nic"],
    start: "2023-10-12T12:50:00",
    messages: [
      {
        author: "Nic",
        time: "12:50",
        text: "is the preseason patch released?"
      },
      {
        author: "Nic",
        time: "13:01",
        text: "anyone good at driving on this server?"
      },
      {
        author: "Nic",
        time: "13:01",
        text: "anyone got any tips for reverse parking a big long car next to the road without hitting the curb? I am having trouble"
      },
      {
        author: "Nils",
        time: "13:04",
        text: "Youtube Conquer driving reverse bay parking"
      },
      {
        author: "Nils",
        time: "13:04",
        text: "And then watch it mirrored so you pretend he's driving on the right"
      },
      {
        author: "Nic",
        time: "13:05",
        text: "Nice! thanks nils"
      },
      {
        author: "Nils",
        time: "13:09",
        text: "Having the video guide is way better than any tips I could write out, and the guy that runs the channel is chill"
      },
      {
        author: "Nic",
        time: "13:11",
        text: "yeah watching his vid now, I like him. he doesn't sound annoying"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Charlie", "Smuck"],
    start: "2023-10-19T17:39:00",
    messages: [
      {
        author: "Smuck",
        time: "17:39",
        text: "It just hit me that BDS are probably gonna loose to fucking mad lions because that's their way of making sure I truly despise them..."
      },
      {
        author: "Smuck",
        time: "17:39",
        text: "It'll be the only game mad will win too and if there's a script it'll be a fucking stomp on top of all"
      },
      {
        author: "Charlie",
        time: "17:40",
        text: "ye and then bds smash kt 2-0 in the elimination series"
      },
      {
        author: "Charlie",
        time: "17:40",
        text: "redemption arc"
      },
      {
        author: "Smuck",
        time: "17:40",
        text: "True!!"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Jake", "Charlie"],
    start: "2023-10-20T17:39:00",
    messages: [
      {
        author: "Charlie",
        time: "17:39",
        text: "as long as you dont update the app youll be fine"
      },
      {
        author: "Charlie",
        time: "17:39",
        text: "but at a certain point itll probably stop working unless you update"
      },
      {
        author: "Jake",
        time: "17:41",
        text: "Mine\u2019s fine still\nGrape"
      },
      {
        author: "Charlie",
        time: "17:42",
        text: "grape"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Jamie", "Kasai"],
    start: "2023-11-15T12:50:00",
    messages: [
      {
        author: "Jamie",
        time: "12:50",
        text: "i had this guy in one of my lobbies before lmao"
      },
      {
        author: "Kasai",
        time: "12:51",
        text: "I'm surprised he isnt banned on tw its against TOS to spread hateful behaviour"
      },
      {
        author: "Jamie",
        time: "12:51",
        text: "hes been doing it for a while, at least a month or two"
      },
      {
        author: "Kasai",
        time: "12:52",
        text: "One of the few times I think an IP ban is justified"
      },
      {
        author: "Jamie",
        time: "12:53",
        text: "vpns tho"
      },
      {
        author: "Kasai",
        time: "12:53",
        text: "Yeah I know but it will atleast make it even slightly more inconvenient for him"
      },
      {
        author: "Jamie",
        time: "12:54",
        text: "true, its the fact he can queue on 5 accs at a time"
      },
      {
        author: "Kasai",
        time: "12:55",
        text: "Yeah its v annoying"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#aww",
    participants: ["Jake", "Imogen"],
    start: "2023-11-15T22:11:00",
    messages: [
      {
        author: "Jake",
        time: "22:11",
        text: "penguin?!!"
      },
      {
        author: "Imogen",
        time: "22:11",
        text: "The second penguin that came up with yellow band, name is biscuit"
      },
      {
        author: "Imogen",
        time: "22:11",
        text: "And the turtles name is carrie! Gf is doing a study on them with the aquarium"
      },
      {
        author: "Jake",
        time: "22:14",
        text: "me and the boys on tuesday"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Freddie", "Nic"],
    start: "2024-01-05T22:12:00",
    messages: [
      {
        author: "Freddie",
        time: "22:12",
        text: "me smuck fishes and george atm"
      },
      {
        author: "Freddie",
        time: "22:12",
        text: "we are still in the early stages of planning, but if that is what the people want then WHY NOT!"
      },
      {
        author: "Freddie",
        time: "22:24",
        text: "matches would be short considering the general lack of skill and fitness and it would probably take place in London around the time of worlds"
      },
      {
        author: "Nic",
        time: "22:48",
        text: "I would be interested"
      },
      {
        author: "Freddie",
        time: "22:53",
        text: "nice, u r very welcome"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#aww",
    participants: ["Imogen", "Smuck"],
    start: "2024-01-24T18:06:00",
    messages: [
      {
        author: "Smuck",
        time: "18:06",
        text: "What's the name of that Tortise? Is it Ben? I imagine him being called Ol' Ben"
      },
      {
        author: "Imogen",
        time: "18:06",
        text: "More coming"
      },
      {
        author: "Imogen",
        time: "18:06",
        text: "Ummm we were told, they\u2019re a female. Might of been Priscilla - will confirm with gf when shes awake"
      },
      {
        author: "Smuck",
        time: "18:07",
        text: "Then her name should be something like Magdalen. Like feel like Tortises have to have grandma/grandpa names"
      },
      {
        author: "Imogen",
        time: "18:07",
        text: "More photos coming - train wifi sucky"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#games-chat",
    participants: ["Fishes", "Nic"],
    start: "2024-01-29T21:55:00",
    messages: [
      {
        author: "Fishes",
        time: "21:55",
        text: "ye but t8 is cool"
      },
      {
        author: "Nic",
        time: "22:05",
        text: "you're cool"
      },
      {
        author: "Nic",
        time: "22:05",
        text: "too cool"
      },
      {
        author: "Nic",
        time: "22:05",
        text: "couldn't possible be as cool as you, so why would I bother trying to get t8 if you're already the coolest at it"
      },
      {
        author: "Fishes",
        time: "22:21",
        text: "because u become cool while playing it following the coolest of the cool"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Nic", "Kasai"],
    start: "2024-02-23T12:15:00",
    messages: [
      {
        author: "Nic",
        time: "12:15",
        text: "I see, does he struggling with being the avatar? or is he fine with it?"
      },
      {
        author: "Kasai",
        time: "12:15",
        text: "He struggles but not in the way he does in OG - they took it in a little bit of a different direction which is fine"
      },
      {
        author: "Kasai",
        time: "12:15",
        text: "Character wise the most different way he acts is at the siege of the north"
      },
      {
        author: "Nic",
        time: "12:16",
        text: "alright, I'll have to watch it next month"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Nic", "Kasai"],
    start: "2024-02-23T12:44:00",
    messages: [
      {
        author: "Kasai",
        time: "12:44",
        text: "its a focal point in \"Jet\" that Sokka is too stubborn to listens to others relying on his gut feeling as the leader"
      },
      {
        author: "Kasai",
        time: "12:44",
        text: "Continues in Bato of the water tribe"
      },
      {
        author: "Kasai",
        time: "12:44",
        text: "where he feels he now needs to earn his mark"
      },
      {
        author: "Nic",
        time: "12:45",
        text: "yeah that's what I remember that he has to ease into it, he wanted to be a leader but he wasn't ready for it"
      },
      {
        author: "Kasai",
        time: "12:45",
        text: "Which leads into him helping the mechanist in the northern air temple and establishing a plan of attack against the fire nation"
      },
      {
        author: "Kasai",
        time: "12:45",
        text: "I'd say it is most definitely pre-established into his character arc"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Nic", "Kasai"],
    start: "2024-02-23T13:12:00",
    messages: [
      {
        author: "Kasai",
        time: "13:12",
        text: "I'm just saying it's not a major point of avatar for me, is his relationship to katara important ot the story absolutely - it stops him from being able to go into the avatar state"
      },
      {
        author: "Kasai",
        time: "13:12",
        text: "But I just dont like it - romance between literal children weird"
      },
      {
        author: "Kasai",
        time: "13:13",
        text: "Excellent casting fr"
      },
      {
        author: "Nic",
        time: "13:13",
        text: "it's weird if you make it weird. children have romances all the time"
      },
      {
        author: "Nic",
        time: "13:14",
        text: "but it's fair if you don't like it"
      },
      {
        author: "Kasai",
        time: "13:14",
        text: "Ok you did not need to put that first bit on there"
      },
      {
        author: "Nic",
        time: "13:15",
        text: "gottem"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Nic", "Smuck"],
    start: "2024-02-29T20:24:00",
    messages: [
      {
        author: "Nic",
        time: "20:24",
        text: "I'm edging to this guys, I need customs"
      },
      {
        author: "Smuck",
        time: "20:25",
        text: "Just me, you and Robby left Nic... The last customers. We're a dying breed..."
      },
      {
        author: "Smuck",
        time: "20:26",
        text: "Everyone else have abandoned the past in favour of new games and life outside of discord... It's heartbreaking, but a reality..."
      },
      {
        author: "Nic",
        time: "20:28",
        text: "urgh, but I hate change"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Fishes", "Nic"],
    start: "2024-03-16T20:12:00",
    messages: [
      {
        author: "Nic",
        time: "20:12",
        text: "I'm not in the call because you guys take 12 minutes to get on"
      },
      {
        author: "Nic",
        time: "20:13",
        text: "I'm not gonna sit in silence andaa await for you"
      },
      {
        author: "Fishes",
        time: "20:13",
        text: "\ud83e\udde2"
      },
      {
        author: "Nic",
        time: "20:13",
        text: "why is it korean"
      },
      {
        author: "Fishes",
        time: "20:13",
        text: "why not"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Kaddy", "Nic"],
    start: "2024-04-26T23:14:00",
    messages: [
      {
        author: "Nic",
        time: "23:14",
        text: "This is taking only english into account. In most other languages your partner isn't referred to as boyfriend/girlfriend. Like in danish it is called k\u00e6reste which means dearest. So the saying that it is that because it has friend in the word is wrong."
      },
      {
        author: "Nic",
        time: "23:15",
        text: "Like in latin you would refer to someone as your loved one not as boyfriend/girlfriend"
      },
      {
        author: "Kaddy",
        time: "23:33",
        text: "german does it too and even harder (friend: freund. boyfriend: freund) so idk"
      },
      {
        author: "Kaddy",
        time: "23:33",
        text: "all the languages I need"
      },
      {
        author: "Nic",
        time: "23:36",
        text: "Well both german and english is stupid soooo"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Jake", "Kasai"],
    start: "2024-05-24T16:24:00",
    messages: [
      {
        author: "Kasai",
        time: "16:24",
        text: "We only had a sinners list cause at the time cause on hit champs were a little bit too nuts in the hands of jake and other ADC mains"
      },
      {
        author: "Kasai",
        time: "16:24",
        text: "Senna was just nuts at the time too"
      },
      {
        author: "Jake",
        time: "16:25",
        text: "brother i dont even play those champs"
      },
      {
        author: "Jake",
        time: "16:25",
        text: "vayne and kogmaw were busted and super annoying because they had tank builds"
      },
      {
        author: "Jake",
        time: "16:26",
        text: "that shit was just unfun to play against a 5k hp 150 armor 100 mr vayne who was 3 shotting everyone"
      },
      {
        author: "Kasai",
        time: "16:26",
        text: "Yeah"
      },
      {
        author: "Jake",
        time: "16:26",
        text: "same with kog"
      },
      {
        author: "Kasai",
        time: "16:26",
        text: "I did say at the time"
      },
      {
        author: "Jake",
        time: "16:26",
        text: "senna was and still is a disgusting horrid champion"
      },
      {
        author: "Jake",
        time: "16:26",
        text: "yuumi is yuumi"
      },
      {
        author: "Kasai",
        time: "16:26",
        text: "but I forget to imply that they were really strong at that time"
      },
      {
        author: "Kasai",
        time: "16:26",
        text: "Omg yeah and with old yuumi too"
      },
      {
        author: "Kasai",
        time: "16:27",
        text: "I forgor"
      },
      {
        author: "Jake",
        time: "16:27",
        text: "kayle was just cause games would always go 40min cause we couldnt end for shit"
      },
      {
        author: "Jake",
        time: "16:27",
        text: "the only champ i played a lot that got put on there was swain"
      },
      {
        author: "Jake",
        time: "16:27",
        text: "and that was bullshit"
      },
      {
        author: "Jake",
        time: "16:28",
        text: "he had no right to be on that list but we made it democratic voting and the people turned to the darkside for there own malicious wants instead of whats right."
      },
      {
        author: "Jake",
        time: "16:28",
        text: "this is why democracy always fails."
      },
      {
        author: "Kasai",
        time: "16:29",
        text: "Bro is still mad ITS BEEN LIKE 2 YEARS LET IT GO JAKE"
      },
      {
        author: "Jake",
        time: "16:29",
        text: "NO RIGHT"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Fishes", "Nic"],
    start: "2024-05-28T13:04:00",
    messages: [
      {
        author: "Fishes",
        time: "13:04",
        text: "there was an attempt to explain to him that there was a right and wrong way to call out a mistake"
      },
      {
        author: "Nic",
        time: "13:04",
        text: "many many attempts"
      },
      {
        author: "Fishes",
        time: "13:04",
        text: "screaming at someone and calling them multiple slurs is not the way"
      },
      {
        author: "Nic",
        time: "13:05",
        text: "oh well"
      },
      {
        author: "Nic",
        time: "13:05",
        text: "agree to dissagree fishes"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Fishes", "Kasai"],
    start: "2024-05-28T15:04:00",
    messages: [
      {
        author: "Fishes",
        time: "15:04",
        text: "i was chilling"
      },
      {
        author: "Kasai",
        time: "15:11",
        text: "I am sorry clom but putting me into you was a mistake"
      },
      {
        author: "Kasai",
        time: "15:11",
        text: "I am legit a gold ranked top laner I SUCK at top"
      },
      {
        author: "Fishes",
        time: "15:11",
        text: "u are master player vs lucky plat"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#games-chat",
    participants: ["Fishes", "Nic"],
    start: "2024-06-24T13:59:00",
    messages: [
      {
        author: "Nic",
        time: "13:59",
        text: "smuck should start with a bag full of xen den points"
      },
      {
        author: "Fishes",
        time: "13:59",
        text: "u recently seemed more irritable, so its not a matter of me taking the conversation seriously its just my inference from your most recent actions and how you've reacted to stuff"
      },
      {
        author: "Fishes",
        time: "14:00",
        text: "so im not entirely sure how this makes me a hypocrit"
      },
      {
        author: "Fishes",
        time: "14:00",
        text: "i would like to think most people on the server knows i don't care all that much with \"getting farmed\""
      },
      {
        author: "Nic",
        time: "14:00",
        text: "I'm more irritable because people are saying stuff like \"hit a nerve\" it's like saying \"are you angry, are you angry? are you sure you're not angry?\" it makes a person angry. but I've also for many years been angry as a joke. it isn't something new"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#games-chat",
    participants: ["Fishes", "Nic"],
    start: "2024-06-24T14:02:00",
    messages: [
      {
        author: "Fishes",
        time: "14:02",
        text: "i can only make what i think is an educated assessment from text chat without the use of tone of voice with delivering ajoke"
      },
      {
        author: "Fishes",
        time: "14:02",
        text: "u left the server"
      },
      {
        author: "Fishes",
        time: "14:02",
        text: "from what i saw didn't seem very satire to me"
      },
      {
        author: "Nic",
        time: "14:02",
        text: "my entire first essay was word for word of the breaking bad I'm the one who knocks"
      },
      {
        author: "Fishes",
        time: "14:02",
        text: "i gathered"
      },
      {
        author: "Nic",
        time: "14:02",
        text: "i left the xen den for an hour"
      },
      {
        author: "Nic",
        time: "14:02",
        text: "with jake saying \"come back babes you're hot\" and that's all it took for me to come back"
      },
      {
        author: "Nic",
        time: "14:02",
        text: "it was clearly a joke"
      },
      {
        author: "Fishes",
        time: "14:03",
        text: "?"
      },
      {
        author: "Fishes",
        time: "14:03",
        text: "you're assuming im meant to know he said that"
      },
      {
        author: "Nic",
        time: "14:03",
        text: "if I was angry I'd write multiple long essays in multiple dms"
      },
      {
        author: "Nic",
        time: "14:03",
        text: "no but you should prob assume that I'm joking more than actually being mad"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#games-chat",
    participants: ["Fishes", "Nic"],
    start: "2024-06-24T14:04:00",
    messages: [
      {
        author: "Nic",
        time: "14:04",
        text: "Because I've jokingly been angry many times, and most of what I've said was references hints towards other things as you know jokes are"
      },
      {
        author: "Nic",
        time: "14:05",
        text: "and even so if you thought I was actually angry without feelin' the need to reach out or ask if I'm okay just makes me think of you as a bad friend"
      },
      {
        author: "Fishes",
        time: "14:05",
        text: "i don't think we're that close for that to be the case"
      },
      {
        author: "Nic",
        time: "14:06",
        text: "Fueling to the conversation with the idea that I'm actually mad"
      },
      {
        author: "Nic",
        time: "14:06",
        text: "I don't think it has anything to do with being close"
      },
      {
        author: "Nic",
        time: "14:06",
        text: "it's just about being a good person"
      },
      {
        author: "Fishes",
        time: "14:06",
        text: "?"
      },
      {
        author: "Fishes",
        time: "14:06",
        text: "im responding to this"
      },
      {
        author: "Fishes",
        time: "14:06",
        text: "sure it would make me a good person"
      },
      {
        author: "Fishes",
        time: "14:06",
        text: "i don't appreciate being called a bad friend tho"
      },
      {
        author: "Nic",
        time: "14:07",
        text: "well if you do bad friend behavior then you're a bad friend no?"
      },
      {
        author: "Fishes",
        time: "14:07",
        text: "thats a revelation"
      },
      {
        author: "Fishes",
        time: "14:07",
        text: "if i was good friends with someone and i felt like they wanted me to contact them i would"
      },
      {
        author: "Nic",
        time: "14:08",
        text: "I never thought you were a bad friend, but if you genuinely thought I was angry, and you responded in lol chat as you did and afterwards still bringing it up makes me think \"oh he wasn't jokin' he was just being a dick\""
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#games-chat",
    participants: ["Kaddy", "Ava"],
    start: "2024-07-09T22:15:00",
    messages: [
      {
        author: "Kaddy",
        time: "22:15",
        text: "it was the only year we went to gamescom and perfect timing"
      },
      {
        author: "Kaddy",
        time: "22:16",
        text: "I also got to witness the slightly botched wow expansion announcement in a sea of people"
      },
      {
        author: "Kaddy",
        time: "22:17",
        text: "I collected statues as a kid then dropped some and broke their heads off and said never again"
      },
      {
        author: "Kaddy",
        time: "22:17",
        text: "but go for it"
      },
      {
        author: "Ava",
        time: "22:17",
        text: "<:peepoSad:583305844930773003>"
      },
      {
        author: "Ava",
        time: "22:17",
        text: "i have the katarina statue"
      },
      {
        author: "Kaddy",
        time: "22:19",
        text: "oooh that one's nice"
      },
      {
        author: "Ava",
        time: "22:19",
        text: "v shiny very cool"
      },
      {
        author: "Ava",
        time: "22:19",
        text: "i wanted the eve one too but im running out of space <:peepoCry:852439472837623838>"
      },
      {
        author: "Kaddy",
        time: "22:19",
        text: "you know what I JUST realized. I'm an adult and I could buy myself glass display cases"
      },
      {
        author: "Ava",
        time: "22:19",
        text: "TRUE"
      },
      {
        author: "Kaddy",
        time: "22:19",
        text: "damn!"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Kasai", "Smuck"],
    start: "2024-07-17T00:03:00",
    messages: [
      {
        author: "Smuck",
        time: "00:03",
        text: "If you do please let me know!! Its much appriciated darling!"
      },
      {
        author: "Smuck",
        time: "00:04",
        text: "Ye, one of my moms friends is good with that stuff and helped me build current one"
      },
      {
        author: "Kasai",
        time: "00:04",
        text: "Ok so its not out of the question that you could be able to build a PC"
      },
      {
        author: "Smuck",
        time: "00:04",
        text: "Ye no it could be built"
      },
      {
        author: "Kasai",
        time: "00:04",
        text: "Your storage is ok to bring over right - do you use hard drives or do you have an SSD?"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Charlie", "Kasai"],
    start: "2024-07-17T00:05:00",
    messages: [
      {
        author: "Charlie",
        time: "00:05",
        text: "both"
      },
      {
        author: "Charlie",
        time: "00:05",
        text: "get both"
      },
      {
        author: "Kasai",
        time: "00:07",
        text: "Both is fine but an SSD is a must so if he already has one we can save"
      },
      {
        author: "Charlie",
        time: "00:07",
        text: "ssd isnt a must its a qol thing if you fancy spending a bit extra"
      },
      {
        author: "Kasai",
        time: "00:08",
        text: "SSD's arent as expensive as they used to be you can get a cheap 1 TB nvme for like \u00a350"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#games-chat",
    participants: ["Blithe", "Ava"],
    start: "2024-07-18T16:48:00",
    messages: [
      {
        author: "Blithe",
        time: "16:48",
        text: "I mean I havent been online much either because I dont really just like putting in much effort into my farms if theyre well gonna be a bit redundant"
      },
      {
        author: "Ava",
        time: "16:48",
        text: "im making videogames so i cant distract myself w pretty cubes <:peepoGlad:593197937136369675>"
      },
      {
        author: "Blithe",
        time: "16:53",
        text: "Fuck man why is Celeste such a good game"
      },
      {
        author: "Blithe",
        time: "16:53",
        text: "Haven't shed a tear playing a game in a while"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Clom", "Fishes"],
    start: "2024-07-20T10:23:00",
    messages: [
      {
        author: "Fishes",
        time: "10:23",
        text: "I think this may true in some cases but you should have a good gauge on whether or not you would like something based on past activities"
      },
      {
        author: "Clom",
        time: "10:24",
        text: "imo its just a closed-minded way of thinking"
      },
      {
        author: "Clom",
        time: "10:24",
        text: "people change all the time"
      },
      {
        author: "Fishes",
        time: "10:27",
        text: "It definitely is but there needs to be more of an incentive to try something rather than I just want to Try something new usally"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Clom", "Nic"],
    start: "2024-07-20T10:38:00",
    messages: [
      {
        author: "Clom",
        time: "10:38",
        text: "I'd say most couples dont share their main hobbies though"
      },
      {
        author: "Nic",
        time: "10:39",
        text: "well still, if you like your life chillin' at home playing games and the girl on the app is a very active ironman/marathon runner, wouldn't it be wasting your time to swipe right when you have nothign in common? especially on a dating app where all you know about the person is the person's looks and her bio, shouldn't you swipe right on the girls who have things in common with and not try every? else you might aswell swipe right on every girl you think is mildly attractive"
      },
      {
        author: "Clom",
        time: "10:39",
        text: "as long as you support them through it its fine"
      },
      {
        author: "Nic",
        time: "10:39",
        text: "and those relationships are boring"
      },
      {
        author: "Nic",
        time: "10:39",
        text: "I force my hobbies on my gfs"
      },
      {
        author: "Clom",
        time: "10:39",
        text: "thats toxic af"
      },
      {
        author: "Nic",
        time: "10:39",
        text: "nah"
      },
      {
        author: "Nic",
        time: "10:39",
        text: "they like it"
      },
      {
        author: "Nic",
        time: "10:40",
        text: "you're the one swiping right on every girl because \"you never know if you change your opinion\""
      },
      {
        author: "Nic",
        time: "10:40",
        text: "desperate ahh"
      },
      {
        author: "Clom",
        time: "10:40",
        text: "if you think thats what i said your reading comprehension is fucked"
      },
      {
        author: "Nic",
        time: "10:40",
        text: "well isn't it kinda what you're saying?"
      },
      {
        author: "Clom",
        time: "10:41",
        text: "not at all but you've clearly already made up your mind"
      },
      {
        author: "Nic",
        time: "10:41",
        text: "you're saying that it is close minded to not swipe right on a girl because you don't enjoy her hobbies"
      },
      {
        author: "Clom",
        time: "10:41",
        text: "so theres no reason to talk"
      },
      {
        author: "Nic",
        time: "10:41",
        text: "that's literally what you've been saying"
      },
      {
        author: "Nic",
        time: "10:41",
        text: "so there is no reason not to swipe right on every girl unless it is something you're afraid of or you're unattracted to the girl"
      },
      {
        author: "Nic",
        time: "10:43",
        text: "I'm on a smuck's side here, he ain't closed minded"
      },
      {
        author: "Clom",
        time: "10:48",
        text: "theres a massive amount of nuance to relationships that you are dismissing"
      },
      {
        author: "Nic",
        time: "10:48",
        text: "no"
      },
      {
        author: "Nic",
        time: "10:48",
        text: "I'm not"
      },
      {
        author: "Nic",
        time: "10:48",
        text: "you're on a dating app"
      },
      {
        author: "Nic",
        time: "10:48",
        text: "it's different than already being in a relationship or meeting a girl irl"
      },
      {
        author: "Nic",
        time: "10:49",
        text: "this is literally about choosing a girl from her bio and pics"
      },
      {
        author: "Nic",
        time: "10:51",
        text: "if your point isn't coming across then you need to redo how you're communicating instead of blaming the listener"
      },
      {
        author: "Nic",
        time: "10:54",
        text: "we're talking about smuck not swiping right on girls where he doesn't see their interests aligning with his because they have nothing in common, and he doesn't think attraction is enough of a reason to swipe right. which is the most common thing to do on a dating app. we're talking about the stage of starting to communicate, no previous interaction with the girl. if you think that isn't a reason to swipe left because you never know if you will like the persons interests then I don't see the point of not swiping right on every girl you find mildly attractive"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Nic", "Ava"],
    start: "2024-07-20T11:42:00",
    messages: [
      {
        author: "Nic",
        time: "11:42",
        text: "yeah I got 2 inch slammer"
      },
      {
        author: "Ava",
        time: "11:42",
        text: "I'm at the top"
      },
      {
        author: "Ava",
        time: "11:42",
        text: "Get it before it's gone this cock is reduced to clear"
      },
      {
        author: "Nic",
        time: "11:43",
        text: "he actually tells me how much he hates yugioh as he strokes me"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#aww",
    participants: ["Nic", "Smuck"],
    start: "2024-07-20T13:28:00",
    messages: [
      {
        author: "Smuck",
        time: "13:28",
        text: "Nakey babies"
      },
      {
        author: "Nic",
        time: "13:28",
        text: "I have nothing in common with her"
      },
      {
        author: "Smuck",
        time: "13:33",
        text: "It counts if its something you wouldnt mind either finding out later (bit hard with this one) or something that they got later in the relationship, but you cant stand first glance"
      },
      {
        author: "Smuck",
        time: "13:37",
        text: "That is true. For most other hobbies I usually don't have that reaction. Just climbing that I can't get behind, part of the issue is also my bad health and being afraid of them wanting to do it early on where I physically wouldnt be able to without passing out (just got lightheaded from walking the dog .-.). So its more so being afraid of that and not wanting to start anything with someone where I physically can't take part in a hobby theyre into"
      },
      {
        author: "Smuck",
        time: "13:38",
        text: "But jeez, you guys went off huh?"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Joey", "Ava"],
    start: "2024-08-02T21:59:00",
    messages: [
      {
        author: "Ava",
        time: "21:59",
        text: "Wedges are ok"
      },
      {
        author: "Joey",
        time: "21:59",
        text: "well I wouldn't because I think I'd hate clubs but if I liked clubs I'd like to go to one of those"
      },
      {
        author: "Ava",
        time: "21:59",
        text: "I feel like anything above a 3 inch heel will break my neck"
      },
      {
        author: "Ava",
        time: "21:59",
        text: "<:baseg:1092270255604240456>"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Joey", "Smuck"],
    start: "2024-08-05T14:33:00",
    messages: [
      {
        author: "Smuck",
        time: "14:33",
        text: "Needs some fem clothes and maybe a lil makeup and theyll be there fully, but there they were all in the coccoon stage"
      },
      {
        author: "Smuck",
        time: "14:34",
        text: "RIP in pepperoni on that one"
      },
      {
        author: "Smuck",
        time: "14:35",
        text: "I for one wish we had more jungle enjoyers so I don't have to play it every customs"
      },
      {
        author: "Joey",
        time: "14:43",
        text: "\ud83d\ude28"
      },
      {
        author: "Smuck",
        time: "14:45",
        text: "You got this babes"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#games-chat",
    participants: ["Xal", "Smuck"],
    start: "2024-08-11T00:20:00",
    messages: [
      {
        author: "Smuck",
        time: "00:20",
        text: "So far we got 5 (me, Kaddy, Joe, Jake and Harry) Not sure if we could get more, otherwise I'm down for payday"
      },
      {
        author: "Xal",
        time: "00:20",
        text: "<a:ezgif2c7c6ef03ea:1270785635485089893>"
      },
      {
        author: "Smuck",
        time: "00:21",
        text: "Are those waves of playing jackbox or waves of payday/just to be polite?"
      },
      {
        author: "Xal",
        time: "00:21",
        text: "jackbox"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#games-chat",
    participants: ["Nic", "Smuck"],
    start: "2024-08-11T07:17:00",
    messages: [
      {
        author: "Nic",
        time: "07:17",
        text: "that's crazy. that song haunted me as an 11 year old"
      },
      {
        author: "Smuck",
        time: "07:18",
        text: "Scariest fucking thing you could listen to"
      },
      {
        author: "Nic",
        time: "07:21",
        text: "remember believing in the whole \"Some kid's gameboys played the lavender town theme in a different frequency that would kill them or turn them crazy\""
      },
      {
        author: "Nic",
        time: "07:21",
        text: "pokemon creepypastas were so goated"
      },
      {
        author: "Smuck",
        time: "07:26",
        text: "The cursed pokemon red used to scare me so fucking bad. Even though I had never owned a gameboy."
      },
      {
        author: "Nic",
        time: "07:39",
        text: "that shit scared the fuck outta me too"
      },
      {
        author: "Nic",
        time: "07:42",
        text: "why are you 5 still awake"
      },
      {
        author: "Smuck",
        time: "07:45",
        text: "We've lost touch with reality. Our world has fallen apart"
      },
      {
        author: "Nic",
        time: "07:45",
        text: "you've reached a new stage of consciousness"
      },
      {
        author: "Smuck",
        time: "08:00",
        text: "Fellas. Should I be worried that my cats pee smells like peach yoghurt or should I just be greatful that there's a nice smell while cleaning the liter boxes?"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Nic", "Smuck"],
    start: "2024-08-11T08:06:00",
    messages: [
      {
        author: "Smuck",
        time: "08:06",
        text: "Fuuuck. Lets hope not since theyre so young, but that sadly is a possibility :("
      },
      {
        author: "Nic",
        time: "08:08",
        text: "awh widdle guy :(("
      },
      {
        author: "Nic",
        time: "08:08",
        text: "if it continues maybe take 'em to a vet"
      },
      {
        author: "Smuck",
        time: "08:09",
        text: "Ye, will keep my nose on alert! Thanks for the tip though!"
      },
      {
        author: "Smuck",
        time: "08:09",
        text: "Actually really helpful to know"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#games-chat",
    participants: ["Nic", "Joey"],
    start: "2024-08-17T12:57:00",
    messages: [
      {
        author: "Joey",
        time: "12:57",
        text: "I'm boredom barry"
      },
      {
        author: "Nic",
        time: "12:57",
        text: "and the graphics are shit enough that my pc can handle it"
      },
      {
        author: "Nic",
        time: "12:58",
        text: "ya'll can't speak sitting there playing overwatch on your high horse"
      },
      {
        author: "Joey",
        time: "12:58",
        text: "can't really speak Jake"
      },
      {
        author: "Joey",
        time: "12:59",
        text: "well I tried but it didn't come through"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#lol-chat",
    participants: ["Nic", "Smuck"],
    start: "2024-08-21T15:15:00",
    messages: [
      {
        author: "Smuck",
        time: "15:15",
        text: "Tear is the equivilant of asking for sex by shouting \"PLEASE PLEASE PLEASE PLEASE\""
      },
      {
        author: "Nic",
        time: "15:16",
        text: "That's so funny I was thinking the exact same thing"
      },
      {
        author: "Smuck",
        time: "15:18",
        text: "Dark seal is an awesome ring that shows confidence. It's the goat"
      },
      {
        author: "Nic",
        time: "15:18",
        text: "It shows that one bad choice you fall back to 0 with them"
      },
      {
        author: "Smuck",
        time: "15:19",
        text: "If you show up with Cull she's likely to think she has less than an hour left to live"
      },
      {
        author: "Nic",
        time: "15:21",
        text: "It shows them that I am the back up plan. I am letting them know what I am from the start, the second choice"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#games-chat",
    participants: ["Jake", "Joey"],
    start: "2024-08-22T19:06:00",
    messages: [
      {
        author: "Joey",
        time: "19:06",
        text: "no way this guy just ignored.rhe lethal ping and pinged tabletop instead"
      },
      {
        author: "Joey",
        time: "19:06",
        text: "ASSHOLE"
      },
      {
        author: "Jake",
        time: "19:07",
        text: "\ud83d\ude3f"
      },
      {
        author: "Jake",
        time: "19:07",
        text: "ill prob be down for lethal after lost but idk how long that is"
      },
      {
        author: "Joey",
        time: "19:08",
        text: "isn't Elliot leaving at 11 to play wow forever"
      },
      {
        author: "Jake",
        time: "19:08",
        text: "but im down to do soemthing rn till lost starts but idk how long that would be"
      },
      {
        author: "Jake",
        time: "19:08",
        text: "oh ye he is dieing tonight"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Kaddy", "Nic"],
    start: "2024-08-25T20:04:00",
    messages: [
      {
        author: "Nic",
        time: "20:04",
        text: "tbh the first one sounds just as bad as the second one in my opinion"
      },
      {
        author: "Nic",
        time: "20:04",
        text: "I think murder has been able to be justified, I don't think there has ever been a case of rape being justified"
      },
      {
        author: "Kaddy",
        time: "20:05",
        text: "idk if I agree with justified murder"
      },
      {
        author: "Nic",
        time: "20:05",
        text: "self defense?"
      },
      {
        author: "Kaddy",
        time: "20:06",
        text: "yeah but no\nself defense should aim at stopping/stunning/disabling the attacker not outright murder them"
      },
      {
        author: "Kaddy",
        time: "20:06",
        text: "if you don't have the means to make sure they don't die, that's on them"
      },
      {
        author: "Kaddy",
        time: "20:06",
        text: "but that's more of an accidental killing than murder with intent"
      },
      {
        author: "Kaddy",
        time: "20:07",
        text: "aim for the knee not the heart"
      },
      {
        author: "Kaddy",
        time: "20:07",
        text: "if you can"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Jake", "Smuck"],
    start: "2024-08-31T20:59:00",
    messages: [
      {
        author: "Jake",
        time: "20:59",
        text: "you can get away with not being funny or not being good 1 on 1 conversation"
      },
      {
        author: "Smuck",
        time: "20:59",
        text: "I think I can't get rid of any of my 3, all others tho I can give up easily"
      },
      {
        author: "Jake",
        time: "20:59",
        text: "but usually you need a couple to few things for me to consider you a good friend"
      },
      {
        author: "Jake",
        time: "21:00",
        text: "u can so give up kindness"
      },
      {
        author: "Smuck",
        time: "21:00",
        text: "Hmmm, ye probably"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Nic", "Joey"],
    start: "2024-08-31T21:00:00",
    messages: [
      {
        author: "Nic",
        time: "21:00",
        text: "I think a person can be my friend as long as they are what I consider a good person. I can give up on everything else."
      },
      {
        author: "Nic",
        time: "21:01",
        text: "a person can be unfunny or not good in conversations but as long as I think they are alright then I can consider them a friend"
      },
      {
        author: "Joey",
        time: "21:02",
        text: "wild that they can be none of the above and youll still enjoy hanging out with them"
      },
      {
        author: "Nic",
        time: "21:03",
        text: "I guess mutual affection is all I need. if I don't see a problem with them then they can be considered a friend"
      },
      {
        author: "Nic",
        time: "21:04",
        text: "don't have to be entertaining necessarily or be able to hold themselves. like if a person in a group has a lot of anxiety and isn't good at talking I won't not consider them a friend just because they aren't talkative or funny"
      },
      {
        author: "Joey",
        time: "21:05",
        text: "if a person has a lot of anxiety I could still consider them a friend"
      },
      {
        author: "Joey",
        time: "21:05",
        text: "but I won't enjoy hanging out with them if they don't speak"
      },
      {
        author: "Nic",
        time: "21:05",
        text: "exactly"
      },
      {
        author: "Nic",
        time: "21:05",
        text: "like I'm not going to hang out with them on a daily basis that's what I got my best friends for, but I'm also very open with the word friend"
      },
      {
        author: "Joey",
        time: "21:18",
        text: "oh got it"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#SAUCE",
    participants: ["Fishes", "Kasai"],
    start: "2024-09-06T19:37:00",
    messages: [
      {
        author: "Kasai",
        time: "19:37",
        text: "If you dont want me to play with you guys"
      },
      {
        author: "Kasai",
        time: "19:37",
        text: "just say it"
      },
      {
        author: "Fishes",
        time: "19:38",
        text: "are u fine playing old man pace? cause i've vocalised this to u about you play differently to me is just my main concern"
      },
      {
        author: "Kasai",
        time: "19:38",
        text: "Yes man I want to experience this game"
      },
      {
        author: "Kasai",
        time: "19:38",
        text: "There is so so much stuff to do and I cant do it on my own in my world"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Charlie", "Ava"],
    start: "2024-09-22T03:30:00",
    messages: [
      {
        author: "Charlie",
        time: "03:30",
        text: "theres no way they go through the trouble of actually moulding that shit"
      },
      {
        author: "Ava",
        time: "03:30",
        text: "they do the labia an dat"
      },
      {
        author: "Charlie",
        time: "03:30",
        text: "just make a generic one and slap a name on nobody will know"
      },
      {
        author: "Ava",
        time: "03:30",
        text: "the insane is generic"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Joey", "Ava"],
    start: "2024-09-22T03:51:00",
    messages: [
      {
        author: "Ava",
        time: "03:51",
        text: "child violence is hilarious"
      },
      {
        author: "Ava",
        time: "03:52",
        text: "why isnt that a thing"
      },
      {
        author: "Ava",
        time: "03:52",
        text: "i want to bet on two five year olds fight to the death"
      },
      {
        author: "Joey",
        time: "03:52",
        text: "selena the kind of guy to put every episode of bob's burgers on letterboxd"
      },
      {
        author: "Ava",
        time: "03:52",
        text: "wind them up like dog fights"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Charlie", "Ava"],
    start: "2024-09-22T03:53:00",
    messages: [
      {
        author: "Ava",
        time: "03:53",
        text: "what he do"
      },
      {
        author: "Charlie",
        time: "03:54",
        text: "always sunny is so goated im rewatching it for like the 15th time now"
      },
      {
        author: "Charlie",
        time: "03:54",
        text: "i'd do the same with inbetweeners if it werent so short"
      },
      {
        author: "Ava",
        time: "03:54",
        text: "i believe thats called an autistic hyperfixation"
      },
      {
        author: "Charlie",
        time: "03:54",
        text: "no but in like a cool way"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#games-chat",
    participants: ["Charlie", "Joey"],
    start: "2024-09-23T17:58:00",
    messages: [
      {
        author: "Joey",
        time: "17:58",
        text: "<@91198671168753664> <@119498918835912704> <@91198671168753664> <@134105000442986496> <@319909964997066756>  escape sim?"
      },
      {
        author: "Joey",
        time: "17:58",
        text: "<@357153876098547714>"
      },
      {
        author: "Charlie",
        time: "17:58",
        text: "i could escape"
      },
      {
        author: "Charlie",
        time: "17:58",
        text: "are there new maps or do you guys just play custom ones"
      },
      {
        author: "Joey",
        time: "17:58",
        text: "idk I've only played a couple"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Jake", "Ava"],
    start: "2024-10-02T15:45:00",
    messages: [
      {
        author: "Jake",
        time: "15:45",
        text: "it looks cool but it is like 30 pounds"
      },
      {
        author: "Ava",
        time: "15:45",
        text: "can you not tell xavier to buy it for you"
      },
      {
        author: "Ava",
        time: "15:47",
        text: "i see 21 pounds on g2a"
      },
      {
        author: "Ava",
        time: "15:48",
        text: "i fear i cannot buy it for you this month as i have spent too much on beyblades"
      },
      {
        author: "Jake",
        time: "15:53",
        text: "thats fair but im also tight on moneyz so i prob wont buy anything over a 5er really"
      },
      {
        author: "Jake",
        time: "15:53",
        text: "that all being said would you be interested in civ or nah"
      },
    ],
  },
  {
    server: "Xen Den",
    channel: "#general",
    participants: ["Charlie", "Nic"],
    start: "2024-10-04T05:36:00",
    messages: [
      {
        author: "Nic",
        time: "05:36",
        text: "Noticing liam having some bad takes lately"
      },
      {
        author: "Nic",
        time: "05:36",
        text: "He fell off"
      },
      {
        author: "Nic",
        time: "05:39",
        text: "First joker was great, it was a love letter to old robert deniro movies like the king of comedy and taxi driver"
      },
      {
        author: "Nic",
        time: "05:39",
        text: "Only part I disliked was the imaginary gf part, that was way too obvious"
      },
      {
        author: "Nic",
        time: "05:41",
        text: "Not the best movie ever but calling mid is trying too hard to be different"
      },
      {
        author: "Charlie",
        time: "05:41",
        text: "i didnt see the imaginary girlfriend bit coming but i did fall asleep for 45 minutes"
      },
      {
        author: "Nic",
        time: "05:42",
        text: "Maybe if you were awake you'd have seen it coming too"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#media",
    participants: ["Nic", "Smuck"],
    start: "2024-10-08T08:49:00",
    messages: [
      {
        author: "Smuck",
        time: "08:49",
        text: "They speak to me on a fundamental level"
      },
      {
        author: "Nic",
        time: "08:49",
        text: "Yes way"
      },
      {
        author: "Smuck",
        time: "08:50",
        text: "The voices"
      },
      {
        author: "Nic",
        time: "08:50",
        text: "It's honestly great and the amount of insane mechanics in this game is so awesome along withr the love and care they did to the title"
      },
      {
        author: "Nic",
        time: "08:51",
        text: "Tenkaichi has a bunch of insanely cool and really awesome mechanics a lot of people don't grasp because they will just spam square in campaign and then think it is repetitive. But it has a really deep fighting system that I adore"
      },
      {
        author: "Nic",
        time: "08:53",
        text: "Tenkaichi 2/3 was my entire childhood I would play this game everyday untill my disc was too scrapped to play anymore. And competitive tenkaichi 3 is so fucking cool"
      },
      {
        author: "Nic",
        time: "08:53",
        text: "This is my new main game this is where you guys can find me"
      },
      {
        author: "Nic",
        time: "08:55",
        text: "Dealy premonition is so weird but it's so cool"
      },
      {
        author: "Nic",
        time: "08:56",
        text: "Didn't understand what was going on at all when I played it as a kid, but I loved it"
      },
      {
        author: "Nic",
        time: "08:56",
        text: "Such an odd gem"
      },
      {
        author: "Smuck",
        time: "08:58",
        text: "I love it. Just unabashedly itself. Absolutely minimal care about actual gameplay or making sense. Story I'm sure makes sense to the author even if it's ridiculous. Just true art"
      },
      {
        author: "Nic",
        time: "09:01",
        text: "Dude like the first ghost or whatever you fight in that game you meet in that shack where it bends over it's own back was cool af hell"
      },
      {
        author: "Nic",
        time: "09:02",
        text: "Like it's so odd but actually really like the ghosts or undead or whatever they are again in that gsme"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#other-games",
    participants: ["Jake", "Nic"],
    start: "2024-10-08T12:33:00",
    messages: [
      {
        author: "Jake",
        time: "12:33",
        text: "i think it scratch the mmo itch"
      },
      {
        author: "Jake",
        time: "12:33",
        text: "the progression and grinding dopamine farm"
      },
      {
        author: "Jake",
        time: "12:33",
        text: "but ye i think the combat lookss kinda icky and therefor it wouldnt feel great to play in the long term"
      },
      {
        author: "Jake",
        time: "12:33",
        text: "and new mmos still have the eternal problem if lack of content"
      },
      {
        author: "Nic",
        time: "12:34",
        text: "in 2020 they had 100 members it seems"
      },
      {
        author: "Nic",
        time: "12:34",
        text: "so I think they just doubled their staff for sh2"
      },
      {
        author: "Jake",
        time: "12:34",
        text: "the new world problem"
      },
      {
        author: "Nic",
        time: "12:36",
        text: "people seem to have done a 180 and is behaving like the treatment weren't fair"
      },
      {
        author: "Nic",
        time: "12:37",
        text: "their marketing material was bad so that was the problem. ofc when one of the mostbeloved game titles ever gets this treatment everyone is gonna be wary"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#real-talk",
    participants: ["Charlie", "Nic"],
    start: "2024-10-08T13:39:00",
    messages: [
      {
        author: "Nic",
        time: "13:39",
        text: "@ her in other channels to respond to what she posts in real-talk"
      },
      {
        author: "Charlie",
        time: "13:39",
        text: "anyone have any genuine happiness they'd like to share?"
      },
      {
        author: "Nic",
        time: "13:39",
        text: "yes me"
      },
      {
        author: "Nic",
        time: "13:39",
        text: "my life is going pretty great atm"
      },
      {
        author: "Nic",
        time: "13:40",
        text: "I'm playing dragon ball sparking zero and I feel like everything will be ok"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#other-games",
    participants: ["Fishes", "Freddie"],
    start: "2024-10-09T21:37:00",
    messages: [
      {
        author: "Freddie",
        time: "21:37",
        text: "i think i have it setup but idk if it will work if try to join"
      },
      {
        author: "Fishes",
        time: "21:38",
        text: "do we have the numbers or u just want to try it"
      },
      {
        author: "Freddie",
        time: "21:39",
        text: "im fine with playing hidden with 3 if jake still wants to. or at least trying"
      },
      {
        author: "Fishes",
        time: "21:39",
        text: "ye im down"
      },
      {
        author: "Fishes",
        time: "21:41",
        text: "i owe lost a b05 in tekken then i can"
      },
      {
        author: "Fishes",
        time: "21:41",
        text: "if we're playing"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Nic", "Smuck"],
    start: "2024-10-11T17:00:00",
    messages: [
      {
        author: "Smuck",
        time: "17:00",
        text: "Do sonic with poisonous paint on your skin and just wear blue pants"
      },
      {
        author: "Smuck",
        time: "17:00",
        text: "Wanted to say shadow cause it's funnier but then realised painting your skin black with red highlights might not be such a great idea"
      },
      {
        author: "Nic",
        time: "17:01",
        text: "I fear a sonic costume would be a lil too cringe for me sadly"
      },
      {
        author: "Nic",
        time: "17:01",
        text: "if it was a party for you guys I would"
      },
      {
        author: "Nic",
        time: "17:01",
        text: "in a public party nah"
      },
      {
        author: "Smuck",
        time: "17:01",
        text: "Fine"
      },
      {
        author: "Nic",
        time: "17:01",
        text: "I need something where I can wear regular clothes"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Nic", "Smuck"],
    start: "2024-10-12T07:45:00",
    messages: [
      {
        author: "Nic",
        time: "07:45",
        text: "no worries I will, that's why you're a lil lower on the list because your energy level will make you eepy real quick. teaching you yugioh if you're tired would be sad"
      },
      {
        author: "Nic",
        time: "07:45",
        text: "but also gave me an idea to do the tierlist in reverse, brb"
      },
      {
        author: "Nic",
        time: "07:49",
        text: "how much I would enjoy spending a day with you if you got to choose all the activities"
      },
      {
        author: "Smuck",
        time: "07:50",
        text: "Less go!"
      },
      {
        author: "Nic",
        time: "07:51",
        text: "you sold me with your pitch"
      },
      {
        author: "Smuck",
        time: "07:52",
        text: "Dope"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Jake", "Charlie"],
    start: "2024-10-17T05:03:00",
    messages: [
      {
        author: "Jake",
        time: "05:03",
        text: "thats probably good then"
      },
      {
        author: "Charlie",
        time: "05:03",
        text: "i used to get that thing when i lay on the side of my head in a certain way"
      },
      {
        author: "Charlie",
        time: "05:03",
        text: "are you in bed?"
      },
      {
        author: "Jake",
        time: "05:03",
        text: "umm bad news is i have no fuckin idea what it is"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#league-of-legends",
    participants: ["Jake", "Charlie"],
    start: "2024-10-17T14:03:00",
    messages: [
      {
        author: "Jake",
        time: "14:03",
        text: "I'll join the peeps soon"
      },
      {
        author: "Charlie",
        time: "14:03",
        text: "we're just vibing but it could transition into worlds party at some point"
      },
      {
        author: "Jake",
        time: "14:04",
        text: "I go with the strat of just assuming the best all the time when I can"
      },
      {
        author: "Charlie",
        time: "14:04",
        text: "good idea jake!"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#media",
    participants: ["Jake", "Smuck"],
    start: "2024-10-18T13:58:00",
    messages: [
      {
        author: "Jake",
        time: "13:58",
        text: "the group of people in front of me walking as slow as possible"
      },
      {
        author: "Jake",
        time: "13:58",
        text: "all wearing these boots"
      },
      {
        author: "Smuck",
        time: "14:00",
        text: "In my experience just about no places will take in a wounded pigeon. Hopefully it's different in this case!"
      },
      {
        author: "Jake",
        time: "14:01",
        text: "i think he will get put down"
      },
      {
        author: "Jake",
        time: "14:02",
        text: "poor birbiee"
      },
      {
        author: "Smuck",
        time: "14:02",
        text: "Ye.. Most likely outcome"
      },
      {
        author: "Smuck",
        time: "14:02",
        text: "If it's like a broken leg or wing I think you can reasonably nurse it back to health"
      },
      {
        author: "Smuck",
        time: "14:03",
        text: "But if it just isn't moving at all it's probably bleeding internally or got brain damage"
      },
      {
        author: "Jake",
        time: "14:03",
        text: "i think they are blindd"
      },
      {
        author: "Jake",
        time: "14:03",
        text: "he breathing okay but not oppening eyess"
      },
      {
        author: "Smuck",
        time: "14:04",
        text: "Did you try opening the eyes to see if they're bloody?"
      },
      {
        author: "Jake",
        time: "14:04",
        text: "nuu"
      },
      {
        author: "Jake",
        time: "14:05",
        text: "i think the people will be here in like 5 so ill let them take care of thingss"
      },
      {
        author: "Smuck",
        time: "14:05",
        text: "Well, in any case it won't survive in the wild if it can't see. But I'll hope for the best!"
      },
      {
        author: "Smuck",
        time: "14:06",
        text: "I didn't get to save Harry, but hopefully this guy will make it!"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Nils", "Kaddy"],
    start: "2024-10-18T15:00:00",
    messages: [
      {
        author: "Nils",
        time: "15:00",
        text: "only issue with that is that if you have points available, TV becomes 40% instead of 20% of the available marks, so a team without a TV buff will fall quite far behind (replace TV with whatever the round is)"
      },
      {
        author: "Kaddy",
        time: "15:01",
        text: "yee"
      },
      {
        author: "Kaddy",
        time: "15:01",
        text: "balance is hard"
      },
      {
        author: "Kaddy",
        time: "15:02",
        text: "I think I'll split that category for two quizzes, that way I can give double points and still not throw off everything"
      },
      {
        author: "Nils",
        time: "15:02",
        text: "I can't remember how you scored the music round before (i think it was half mark for 2 different parts), but that ended up with scores being reasonably close (i think 5/6 points in it)?"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Kaddy", "Nic"],
    start: "2024-10-19T19:03:00",
    messages: [
      {
        author: "Kaddy",
        time: "19:03",
        text: "no worries I had the same thought, probably gonna slow down after but I have a long weekend so it's a good opportunity if people wanna do it!"
      },
      {
        author: "Kaddy",
        time: "19:04",
        text: "for now I have many ideas on categories (I feel like the trivia questions are the worst ones already u_u)"
      },
      {
        author: "Kaddy",
        time: "19:04",
        text: "but having it be halloween trivia is gonna help with that I think"
      },
      {
        author: "Nic",
        time: "19:06",
        text: "Yo let the man learn"
      },
      {
        author: "Nic",
        time: "19:07",
        text: "Let him suffer like the rest"
      },
      {
        author: "Kaddy",
        time: "19:12",
        text: "dv\u00e4rgtall"
      },
      {
        author: "Kaddy",
        time: "19:12",
        text: "one tall, the other two dv\u00e4rg"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#media",
    participants: ["Charlie", "Nic"],
    start: "2024-10-19T21:00:00",
    messages: [
      {
        author: "Nic",
        time: "21:00",
        text: "can you play any instruments charlie?"
      },
      {
        author: "Charlie",
        time: "21:00",
        text: "i play guitar"
      },
      {
        author: "Charlie",
        time: "21:01",
        text: "ill shred your little danish nuts off"
      },
      {
        author: "Nic",
        time: "21:01",
        text: "sounds enticing"
      },
      {
        author: "Nic",
        time: "21:02",
        text: "I wish my attention span for interests would be longer. I can in theory play ukelele, guitar, bass, flute and banjo"
      },
      {
        author: "Nic",
        time: "21:03",
        text: "but I like practice them for a year and then it slowely fades out"
      },
      {
        author: "Nic",
        time: "21:03",
        text: "I don't think I remember any ukelele flute or banjo other than very basic stuff"
      },
      {
        author: "Charlie",
        time: "21:04",
        text: "only thing ive ever been able to commit significant time to improving i think"
      },
      {
        author: "Nic",
        time: "21:05",
        text: "Always wanted to learn to play electric guitar only learned acoustic really. And I hate barre chords. So fucking much. finger playing is much more fun"
      },
      {
        author: "Nic",
        time: "21:05",
        text: "would love to hear you shred"
      },
      {
        author: "Charlie",
        time: "21:06",
        text: "listen to that and imagine its me"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#media",
    participants: ["Jake", "Charlie"],
    start: "2024-10-21T17:12:00",
    messages: [
      {
        author: "Jake",
        time: "17:12",
        text: "DAWN"
      },
      {
        author: "Charlie",
        time: "17:12",
        text: "not sure i want to sample any of her mental health advice"
      },
      {
        author: "Jake",
        time: "17:20",
        text: "tbf if you dont personally mind talking to a bot then its a free option for some help"
      },
      {
        author: "Charlie",
        time: "17:24",
        text: "if any of you catch me in ai therapy please shoot me in the brain"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Imogen", "Nic"],
    start: "2024-10-22T07:36:00",
    messages: [
      {
        author: "Nic",
        time: "07:36",
        text: "If I start to get to know someone I always make sure to ask casually what their favorite snacks and drinks are"
      },
      {
        author: "Nic",
        time: "07:37",
        text: "Irl only tho"
      },
      {
        author: "Nic",
        time: "07:37",
        text: "Because I won't be able to buy you guys shit"
      },
      {
        author: "Imogen",
        time: "07:37",
        text: "People are so cute when you randomly get them gifts though"
      },
      {
        author: "Nic",
        time: "07:38",
        text: "I like giving people stuff randomly but I guess I don't view it as a gift before it's wrapped and given for an event"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Blithe", "Charlie"],
    start: "2024-10-22T07:52:00",
    messages: [
      {
        author: "Charlie",
        time: "07:52",
        text: "i think im reasonably nice to strangers"
      },
      {
        author: "Charlie",
        time: "07:52",
        text: "my irl antics would surprise you old man"
      },
      {
        author: "Blithe",
        time: "07:52",
        text: "I just dont like people talking to me on the street about religion"
      },
      {
        author: "Blithe",
        time: "07:52",
        text: "like thats my bottom line of where I decide if Im nice or not"
      },
      {
        author: "Charlie",
        time: "07:53",
        text: "best at screenshotting tierlist"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Imogen", "Nic"],
    start: "2024-10-22T07:56:00",
    messages: [
      {
        author: "Imogen",
        time: "07:56",
        text: "I\u2019m awful at it, I want people to spend their money on themselves"
      },
      {
        author: "Nic",
        time: "07:56",
        text: "That makes you s to me"
      },
      {
        author: "Imogen",
        time: "07:56",
        text: "Huh"
      },
      {
        author: "Nic",
        time: "07:57",
        text: "I think people who doesn't want the present and want people to use money on themselves deserve the gift more than anything"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Nic", "Smuck"],
    start: "2024-10-22T08:28:00",
    messages: [
      {
        author: "Smuck",
        time: "08:28",
        text: "Nah, you two are lead by your elephants too heavily"
      },
      {
        author: "Smuck",
        time: "08:29",
        text: "Logic mfs are the most likely to make my change my mind"
      },
      {
        author: "Smuck",
        time: "08:29",
        text: "If I feel the other person is arguing with emotions I find it hard to take it seriously"
      },
      {
        author: "Smuck",
        time: "08:29",
        text: "Personal issue of mine. But how it is"
      },
      {
        author: "Nic",
        time: "08:30",
        text: "I bet I could change your mind on movie lore"
      },
      {
        author: "Nic",
        time: "08:30",
        text: "or show lore"
      },
      {
        author: "Smuck",
        time: "08:30",
        text: "Hmmm, perchance. That is one arena I think you'd have a clear edge over me"
      },
      {
        author: "Nic",
        time: "08:32",
        text: "I think you've put me in a box after the trolley problem"
      },
      {
        author: "Nic",
        time: "08:32",
        text: "tainted your view of me forever"
      },
      {
        author: "Nic",
        time: "08:32",
        text: "suffocating in my box"
      },
      {
        author: "Smuck",
        time: "08:33",
        text: "It may have. Need to find something else where we can have a heated argument as a pallet cleanser."
      },
      {
        author: "Nic",
        time: "08:33",
        text: "we need a reset"
      },
      {
        author: "Nic",
        time: "08:33",
        text: "problem is, I don't think there is any other thing we would have an actual heated argument over"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Nic", "Smuck"],
    start: "2024-10-22T08:52:00",
    messages: [
      {
        author: "Nic",
        time: "08:52",
        text: "but I think that's my problem is saying that to begin with. Because why do you feel the need to share that opinion to them when that opinion of yours could be what pushes them to do something that is permenent. you can think that ofc, but I don't think you should share it. you should just say \"please see an expert.\" and leave it at that"
      },
      {
        author: "Smuck",
        time: "08:53",
        text: "Well I'm sharing my opinion cause they asked for it. If they asked for it, it's my responsibility as a friend to be honest. Tho I agree, I should and would recommend talking to a professional"
      },
      {
        author: "Nic",
        time: "08:53",
        text: "but I don't think it is your responsibility,   because you're not an expert"
      },
      {
        author: "Nic",
        time: "08:54",
        text: "truth isn't always morally correct"
      },
      {
        author: "Nic",
        time: "08:55",
        text: "if anything if a friend asked me of my opinion I would say \"my opinion is that I don't think I know your situation or your emotional state enough to say whether or not you should you should ask a professional\""
      },
      {
        author: "Nic",
        time: "08:56",
        text: "you taking on that responsibility and being the arbiter of their life is just to me at least a very immoral"
      },
      {
        author: "Smuck",
        time: "08:56",
        text: "While it's true that some people who have tried to kill themselves regret it. But it's also true that a lot of people keep trying cause they still feel like they want to die."
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Nic", "Smuck"],
    start: "2024-10-22T09:12:00",
    messages: [
      {
        author: "Nic",
        time: "09:12",
        text: "but the thing is you don't know if the suicidal person has one or not. but if you tell him \"yeah kill yourself go for it, fine by me\" then it's your subjective opinion you're giving to an emotionally unstable person"
      },
      {
        author: "Nic",
        time: "09:13",
        text: "but you might value his opinion which is exactly why I feel it's wrong for him to say he is for it. Because he can push you towards a certain path. even if he thinks so. It's not his place whether he is a friend to you or not."
      },
      {
        author: "Smuck",
        time: "09:13",
        text: "I wouldn't say go for it. I'd explain my point of view, try to give advice (such as go to a therapist), but also let them know I won't judge them if they do it even if I would miss them. I want to help my friends"
      },
      {
        author: "Nic",
        time: "09:14",
        text: "I just don't think there is a reason to add the I won't judge. because that's giving them the green flag to do so. and every single suicide prevention list would say that's one of the last things you should do. You don't qualify to know enough about a person to give that opinion"
      },
      {
        author: "Nic",
        time: "09:15",
        text: "I know it comes from a good space, but you simply don't know enough about the person, even if you think you do"
      },
      {
        author: "Smuck",
        time: "09:15",
        text: "Also. Don't think you have to be emotionally unstable to be suicidal. It can be a very logical thought. Like \"Oh life is generally worse than good, I should kill myself as that would be the best\"."
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Nic", "Smuck"],
    start: "2024-10-22T09:24:00",
    messages: [
      {
        author: "Smuck",
        time: "09:24",
        text: "Once again think it's wrong to blanket call every suicidal person emotionally vulnerable."
      },
      {
        author: "Smuck",
        time: "09:24",
        text: "It's not inherently good to live"
      },
      {
        author: "Nic",
        time: "09:25",
        text: "I think that if smuck can give me a case of a who has had suicidal thoughts, didn't do it and regrets not kill themselves earlier in their lives. then that might help the case"
      },
      {
        author: "Nic",
        time: "09:25",
        text: "I think that if a person goes to talk to you personally about it then yeah it's usually because they are in an emotionally vulnerable state"
      },
      {
        author: "Smuck",
        time: "09:27",
        text: "I could give you ample examples. Every person who dealt with suicide and depression for years. Decided not to do it and then lived lives they weren't happy with until they died of other causes or until they killed themselves later. In those cases it would have been better to die earlier."
      },
      {
        author: "Nic",
        time: "09:27",
        text: "did they say that themselves?"
      },
      {
        author: "Nic",
        time: "09:27",
        text: "give me the actual example"
      },
      {
        author: "Nic",
        time: "09:27",
        text: "because you're giving your own opinion on their quality of life, it's emotional based"
      },
      {
        author: "Nic",
        time: "09:28",
        text: "And I will say I will always trust the experts on what they say in this situation, they understand this better than we ever could and they would all disagree with what smuck is saying"
      },
      {
        author: "Smuck",
        time: "09:29",
        text: "Obviously I can't do that. But you can't give me an argument of the other without assuming that they're better. Cause when are they gonna say they regret not killing themselves? As they did it? Isn't them killing themselves many many years later them saying it wasn't worth it?"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Blithe", "Xal"],
    start: "2024-10-22T10:13:00",
    messages: [
      {
        author: "Blithe",
        time: "10:13",
        text: "I wasn't against it, they just didn't want me"
      },
      {
        author: "Blithe",
        time: "10:14",
        text: "Odds of you being taken when you have any form of mental health disorder goes down to 1%"
      },
      {
        author: "Xal",
        time: "10:14",
        text: "sadge"
      },
      {
        author: "Xal",
        time: "10:14",
        text: "i would\u2019ve loved to do it"
      },
      {
        author: "Blithe",
        time: "10:14",
        text: "I mean it's also just mandatory for guys too funnily enough, people complain a lot about that too"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Blithe", "Smuck"],
    start: "2024-10-22T10:17:00",
    messages: [
      {
        author: "Blithe",
        time: "10:17",
        text: "Unironically if you do like a technical high school here AND have to do military service you dont get into uni before youre 22 or 23"
      },
      {
        author: "Smuck",
        time: "10:17",
        text: "I'm pretty sure I would have shot myself if I was drawn to join the military. Which probably would have been a good thing so I sorta wish I was drawn too"
      },
      {
        author: "Smuck",
        time: "10:18",
        text: "Well then everyone would've been around that age so that would just be around the age where you'd start"
      },
      {
        author: "Smuck",
        time: "10:18",
        text: "Just feels fucked that some people have to and others don't"
      },
      {
        author: "Blithe",
        time: "10:18",
        text: "I mean yeah but I got rejected so I got into uni with 18"
      },
      {
        author: "Blithe",
        time: "10:19",
        text: "and now Im with a lotta friends that all had to do it that are all like 22"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#real-talk",
    participants: ["Charlie", "Nic"],
    start: "2024-10-23T20:04:00",
    messages: [
      {
        author: "Nic",
        time: "20:04",
        text: "Very specific"
      },
      {
        author: "Charlie",
        time: "20:05",
        text: "looking into it now it also has a psychological definition of inappropriate laughter due to schizophrenia or psychosis"
      },
      {
        author: "Charlie",
        time: "20:05",
        text: "perhaps i shouldn't be cachinnating"
      },
      {
        author: "Nic",
        time: "20:05",
        text: "Charlie can you name every word for laughter you know going from least amount of laughter time to most"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#watch-party",
    participants: ["Jake", "Charlie"],
    start: "2024-10-23T20:45:00",
    messages: [
      {
        author: "Charlie",
        time: "20:45",
        text: "gonna have to watch something that isnt slop to get that ball rolling"
      },
      {
        author: "Jake",
        time: "20:47",
        text: "fma is a banger man"
      },
      {
        author: "Jake",
        time: "20:47",
        text: "even if you dont like anime you should watch the show its great"
      },
      {
        author: "Charlie",
        time: "20:47",
        text: "last time i was told this the anime in question was kiss x sis"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#watch-party",
    participants: ["Charlie", "Nic"],
    start: "2024-10-23T21:00:00",
    messages: [
      {
        author: "Nic",
        time: "21:00",
        text: "Perfect blue is fantastic"
      },
      {
        author: "Charlie",
        time: "21:00",
        text: "i was there i think i got bored and left in the middle"
      },
      {
        author: "Nic",
        time: "21:00",
        text: "If you don't like perfect blue you got ass taste. Imo"
      },
      {
        author: "Nic",
        time: "21:00",
        text: "It's like a must watch for anyone"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#real-talk",
    participants: ["Joey", "Smuck"],
    start: "2024-10-24T04:58:00",
    messages: [
      {
        author: "Joey",
        time: "04:58",
        text: "I just got paid and it's too much"
      },
      {
        author: "Joey",
        time: "04:58",
        text: "\u00a3700 too much, apparently they can claim it back by law anytime in the next 6 years if they realise they made a mistake tho"
      },
      {
        author: "Joey",
        time: "04:58",
        text: "thoughts... what to do"
      },
      {
        author: "Smuck",
        time: "04:59",
        text: "I just splash on food I like when I get too much money"
      },
      {
        author: "Joey",
        time: "04:59",
        text: "tempting but like if I say nothing then they realise they gave me too much that would look realll bad"
      },
      {
        author: "Smuck",
        time: "04:59",
        text: "That or do boring stuff like invest it :/"
      },
      {
        author: "Smuck",
        time: "05:00",
        text: "Oh also you could always get into latex. That's sure to drain it a bit"
      },
      {
        author: "Smuck",
        time: "05:00",
        text: "Oh wait they actually overpayed you"
      },
      {
        author: "Smuck",
        time: "05:00",
        text: "I thought you just meant you got payed more than you feel you need"
      },
      {
        author: "Smuck",
        time: "05:01",
        text: "Well then you should tell them or there's gonna be hell to pay in the future"
      },
      {
        author: "Joey",
        time: "05:01",
        text: "hahahahah no"
      },
      {
        author: "Joey",
        time: "05:01",
        text: "hopped in <#1292950640267493387> just to flex"
      },
      {
        author: "Joey",
        time: "05:01",
        text: "I should have done that"
      },
      {
        author: "Smuck",
        time: "05:02",
        text: "Welp, if it's too late then oh well"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#real-talk",
    participants: ["Joey", "Ava"],
    start: "2024-10-25T21:16:00",
    messages: [
      {
        author: "Ava",
        time: "21:16",
        text: "if u can get the dosage and medication right it rly can help"
      },
      {
        author: "Ava",
        time: "21:16",
        text: "ik im not the best representation but the antidepressants are working <:dracthyr_comfy_sip:1002566612626444428>"
      },
      {
        author: "Joey",
        time: "21:17",
        text: "looool"
      },
      {
        author: "Joey",
        time: "21:17",
        text: "yeah i hope so"
      },
      {
        author: "Joey",
        time: "21:17",
        text: "praying no ssris tho"
      },
      {
        author: "Joey",
        time: "21:17",
        text: "my body did not enjoy those"
      },
      {
        author: "Ava",
        time: "21:18",
        text: "idk much about adhd meds and i think there's a shortage rn"
      },
      {
        author: "Ava",
        time: "21:18",
        text: "are u looking private?"
      },
      {
        author: "Joey",
        time: "21:18",
        text: "yeah, my mum is doing it through nhs and she has to wait 18 months"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#real-talk",
    participants: ["Blithe", "Smuck"],
    start: "2024-10-30T08:28:00",
    messages: [
      {
        author: "Blithe",
        time: "08:28",
        text: "I know it sounds stupid but gaslighting myself into believing I was at least productive makes me feel less shitty about it"
      },
      {
        author: "Blithe",
        time: "08:29",
        text: "+ having a good system for my uni notes by color coding helps in hindsight to learn"
      },
      {
        author: "Smuck",
        time: "08:29",
        text: "From my experience it's the feeling of nothingness mixed with your mind going blank. Being unable to think or hold any coherent thought process. Everything just feels like sand going through your hands to put it poetically"
      },
      {
        author: "Smuck",
        time: "08:30",
        text: "Looks so proud to be chosen by the butterfly"
      },
      {
        author: "Smuck",
        time: "08:30",
        text: "Ye, gonna try to read and takes some notes that later me hopefully can do something with"
      },
      {
        author: "Blithe",
        time: "08:31",
        text: "I mean it doesn't always stick either for me, some days it's just so bad I can't do shit but like sometimes just doing anything is better than nothing, even if you don't retain anything"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#THREAD",
    participants: ["Jake", "Kaddy"],
    start: "2024-11-01T21:52:00",
    messages: [
      {
        author: "Kaddy",
        time: "21:52",
        text: "6.    Your son swears he saw a scary goatman in your garden last night and claims it has been following him. Getting him ready for kindergarten, you find a piece of coal in his boots."
      },
      {
        author: "Jake",
        time: "21:53",
        text: "oh god"
      },
      {
        author: "Kaddy",
        time: "21:54",
        text: "7.    You\u2019ve been feeding deer in the woods for years because winters are harsh here. Ever since your friend lost his wife on a hiking trip, he\u2019s been withdrawn, so you often watch the deer. This year, you buy extra because one looked very thin. When you go to refill it, yesterday\u2019s food has been untouched, but you notice blood and some torn up clothes on the ground."
      },
      {
        author: "Kaddy",
        time: "21:55",
        text: "8.    You\u2019ve met a beautiful woman on holiday, and after some heavy flirting you agree to meet up for a date. You\u2019re not a big fan of fish, but she insists on a seafood restaurant and won\u2019t budge on wanting to take a walk at the beach afterwards either despite the bad weather."
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Charlie", "Smuck"],
    start: "2024-11-06T02:53:00",
    messages: [
      {
        author: "Smuck",
        time: "02:53",
        text: "I think I would come out of it very hurt, but I think I could last long enough to get a check mate"
      },
      {
        author: "Smuck",
        time: "02:54",
        text: "It's not gonna be pretty with any of the animals in yellow"
      },
      {
        author: "Charlie",
        time: "02:58",
        text: "i think the leopard kills you in 9 seconds max"
      },
      {
        author: "Smuck",
        time: "02:58",
        text: "Nah I could wrestle enough to keep me alive. Cause I know he's going for the neck so as long as I wrestle him away from that I can live"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#real-talk",
    participants: ["Charlie", "Nic"],
    start: "2024-11-06T13:36:00",
    messages: [
      {
        author: "Nic",
        time: "13:36",
        text: "Someone do a fishtank smack den tierlist. Who'd be the most entertaining contestants"
      },
      {
        author: "Charlie",
        time: "13:38",
        text: "keep the jacking off in mind when you make it"
      },
      {
        author: "Charlie",
        time: "13:38",
        text: "its essential to my character"
      },
      {
        author: "Nic",
        time: "13:38",
        text: "I can't make it I don't know enough about the fishtank"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Kaddy", "Charlie"],
    start: "2024-11-07T19:36:00",
    messages: [
      {
        author: "Charlie",
        time: "19:36",
        text: "i thought it was racists vs retards but maybe it was about suicidality all along"
      },
      {
        author: "Kaddy",
        time: "19:37",
        text: "I hope you know they will all be christmassified"
      },
      {
        author: "Charlie",
        time: "19:37",
        text: "the family guy christmas double-episode"
      },
      {
        author: "Kaddy",
        time: "19:37",
        text: "genuinely helpful tho, you already gave me a new category thanks team"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#watch-party",
    participants: ["Charlie", "Nic"],
    start: "2024-11-09T17:59:00",
    messages: [
      {
        author: "Nic",
        time: "17:59",
        text: "I miss ill charlie"
      },
      {
        author: "Nic",
        time: "17:59",
        text: "Now that was a cool dude"
      },
      {
        author: "Charlie",
        time: "18:00",
        text: "throwback to when i got tonsilitis and couldn't talk and nic made fun of me for being a baby bitch about my sore throat"
      },
      {
        author: "Nic",
        time: "18:02",
        text: "Boohoo my throat hurts and I can't talk. Lil baby bitch"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Charlie", "Ava"],
    start: "2024-11-09T19:05:00",
    messages: [
      {
        author: "Charlie",
        time: "19:05",
        text: "nic just typed the n word"
      },
      {
        author: "Ava",
        time: "19:05",
        text: "That was the fastest hour ever"
      },
      {
        author: "Charlie",
        time: "19:05",
        text: "btw"
      },
      {
        author: "Charlie",
        time: "19:05",
        text: "hes timed out im not sure im removing that one"
      },
      {
        author: "Ava",
        time: "19:05",
        text: "I collapsed a server but this is what you do in your free time"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#real-talk",
    participants: ["Clom", "Charlie"],
    start: "2024-11-12T12:32:00",
    messages: [
      {
        author: "Charlie",
        time: "12:32",
        text: "im sympathetic to that, genuinely, but i still think its disingenuous to say that consuming alcohol socially is just as worthless an activity as vaping socially"
      },
      {
        author: "Clom",
        time: "12:32",
        text: "its just a terrible line of logic to go down"
      },
      {
        author: "Charlie",
        time: "12:33",
        text: "maybe if you consider the risks of alcoholism compared to the risk of vape addiction sure"
      },
      {
        author: "Clom",
        time: "12:33",
        text: "but smoking has been around for years too"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#real-talk",
    participants: ["Charlie", "Xal"],
    start: "2024-11-12T12:52:00",
    messages: [
      {
        author: "Xal",
        time: "12:52",
        text: "put it in for 30sec"
      },
      {
        author: "Xal",
        time: "12:52",
        text: "ez"
      },
      {
        author: "Charlie",
        time: "12:53",
        text: "tbf i did feel a lil rush for about 45 seconds before i nausea came on"
      },
      {
        author: "Xal",
        time: "12:53",
        text: "ya as soon as u feel it u gotta take that shit out"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#food",
    participants: ["Kaddy", "Smuck"],
    start: "2024-11-15T14:30:00",
    messages: [
      {
        author: "Smuck",
        time: "14:30",
        text: "You can do it! I believe in you! At least once you get more time off from work next year!"
      },
      {
        author: "Smuck",
        time: "14:30",
        text: "Or don't, also an option"
      },
      {
        author: "Kaddy",
        time: "14:32",
        text: "ye, that's what I also said, but I'm already hecking uncomfortable\nI mean he knows german, he just doesn't have great pronunciation and I'm not sure how to even approach that"
      },
      {
        author: "Kaddy",
        time: "14:32",
        text: "but I hate saying no"
      },
      {
        author: "Kaddy",
        time: "14:33",
        text: "but I also can't just never eat there again"
      },
      {
        author: "Smuck",
        time: "14:33",
        text: "Drum go Dum is legit a beat for beat Spain submission to eurovision"
      },
      {
        author: "Smuck",
        time: "14:34",
        text: "I mean you can decline and explain you're not sure how to teach pronunciation. He'd probably get it"
      },
      {
        author: "Kaddy",
        time: "14:46",
        text: "let's hope so"
      },
      {
        author: "Kaddy",
        time: "14:46",
        text: "I cannot live without my fried sushi"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#politics",
    participants: ["Kaddy", "Smuck"],
    start: "2024-11-15T16:21:00",
    messages: [
      {
        author: "Kaddy",
        time: "16:21",
        text: "is elon musk actually gonna work for trump or was german media trolling"
      },
      {
        author: "Kaddy",
        time: "16:21",
        text: "I forgot where I saw it and if it was an actual news source or a version of the onion"
      },
      {
        author: "Kaddy",
        time: "16:22",
        text: "ik I could google it but where's the fun in that"
      },
      {
        author: "Smuck",
        time: "16:23",
        text: "He's just a lil buddy"
      },
      {
        author: "Kaddy",
        time: "16:24",
        text: "ok I hate to laugh at the guy who got blown up buuut"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#league-of-legends",
    participants: ["Joey", "Smuck"],
    start: "2024-11-22T01:48:00",
    messages: [
      {
        author: "Smuck",
        time: "01:48",
        text: "Thanks king"
      },
      {
        author: "Joey",
        time: "01:49",
        text: "we should do a league tournament i bet we could get 3 teams from here"
      },
      {
        author: "Smuck",
        time: "01:49",
        text: "We HAD people. But everyone got mad cause one of the teams was really racist"
      },
      {
        author: "Joey",
        time: "01:49",
        text: "LMFAO"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#politics",
    participants: ["Kaddy", "Charlie"],
    start: "2024-11-23T23:42:00",
    messages: [
      {
        author: "Kaddy",
        time: "23:42",
        text: "is this real"
      },
      {
        author: "Kaddy",
        time: "23:42",
        text: "am I dreaming"
      },
      {
        author: "Kaddy",
        time: "23:42",
        text: "||did I get hex tec'd to a different timeline||"
      },
      {
        author: "Kaddy",
        time: "23:47",
        text: "kinda glad I forgot and missed this discussion or else I'd go down in history as the pedophile defender"
      },
      {
        author: "Charlie",
        time: "23:47",
        text: "still time for that"
      },
      {
        author: "Kaddy",
        time: "23:51",
        text: "well to make it short, if my friend has to have a flaw I'd rather it be, while detrimental to the recipient when it's acted upon, love and/or attraction which they have no control over than massive hatred which is still insanely detrimental when acted upon\nI'm not gonna try to quantify if a scarred for life child is worse than burning people in refugee shelters\nbut I'd rather support my friend in not acting on something they didn't choose and can do nothing about, than accept they're a hateful bastard"
      },
      {
        author: "Kaddy",
        time: "23:52",
        text: "in fact I think if anyone turned out to be a hateful bastard and it wasn't just the way they're raised and they're working towards unlearning it, but they actively try to remain racist, they would just automatically no longer be my friend"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Kaddy", "Nic"],
    start: "2024-11-24T00:01:00",
    messages: [
      {
        author: "Kaddy",
        time: "00:01",
        text: "obviously played up for comedy, it's just a topic I've encountered a few times now and people go so fucking feral over the topic it's kinda disgusting to me"
      },
      {
        author: "Nic",
        time: "00:02",
        text: "Like a person attracted to sa isn't a genuine rapist"
      },
      {
        author: "Kaddy",
        time: "00:02",
        text: "if they're acting on it it really doesn't matter because which is worse would depend on the scale, but either way that friendship is done"
      },
      {
        author: "Nic",
        time: "00:02",
        text: "So I'd say a genuine pedo is one who acts upon it"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Jake", "Kaddy"],
    start: "2024-11-24T00:07:00",
    messages: [
      {
        author: "Jake",
        time: "00:07",
        text: "i get feeling bad for them, i get being wary of them and i get being weirded out by them"
      },
      {
        author: "Jake",
        time: "00:07",
        text: "but hate them nahh"
      },
      {
        author: "Kaddy",
        time: "00:07",
        text: "that's on the same level as preferring racists over gays because you think gay sex is disgusting\nsilly ahh take"
      },
      {
        author: "Jake",
        time: "00:07",
        text: "and i would probaly dislike someone who has racist hatred in there heart even if they didnt act on it"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#food",
    participants: ["Jake", "Charlie"],
    start: "2024-11-26T20:40:00",
    messages: [
      {
        author: "Charlie",
        time: "20:40",
        text: "who's unfamiliar with this"
      },
      {
        author: "Charlie",
        time: "20:40",
        text: "one of gods finest creations"
      },
      {
        author: "Charlie",
        time: "20:40",
        text: "haven't had it in 15 years but im sure it still bangs"
      },
      {
        author: "Jake",
        time: "20:41",
        text: "its a really english thing to call it eggy bread and not ||french toast||"
      },
      {
        author: "Charlie",
        time: "20:41",
        text: "spoilers for arcane s2 ^"
      },
    ],
  },
  {
    server: "Accountability",
    channel: "#general",
    participants: ["Freddie", "Kaddy"],
    start: "2024-11-28T17:50:00",
    messages: [
      {
        author: "Kaddy",
        time: "17:50",
        text: "it's mostly how much time I can afford to spend outside of work, but my initial goal was gym 2 times per week and try to up it to 3 once I get into a stable routine"
      },
      {
        author: "Freddie",
        time: "17:54",
        text: "my advice is to start with as little as possible so that u can build the habit, depending what ur goals are from going to the gym u can even make progress starting at just one day per week"
      },
      {
        author: "Kaddy",
        time: "17:54",
        text: "how do I get the motivation to pick myself up on a saturday"
      },
      {
        author: "Kaddy",
        time: "17:54",
        text: "that's probably the safest day"
      },
      {
        author: "Kaddy",
        time: "17:55",
        text: "but if I'm not already dressed from having to go to work I never manage to leave the house until panic grocery shopping at 9pm"
      },
      {
        author: "Freddie",
        time: "17:58",
        text: "sometimes when i dont feel like going for a run, but i told myself i would all i do is get dressed for a run, put my trainers on and go outside and then i just think 'well i might as well for for a run now'. idk works for me"
      },
      {
        author: "Kaddy",
        time: "17:58",
        text: "that works sometimes, but I don't know what factor is missing when it doesn't"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Joey", "Smuck"],
    start: "2024-12-01T15:12:00",
    messages: [
      {
        author: "Joey",
        time: "15:12",
        text: "it's blue and black but looks white and gold in bright light iirc"
      },
      {
        author: "Joey",
        time: "15:12",
        text: "let me find the pic"
      },
      {
        author: "Smuck",
        time: "15:15",
        text: "Surely that can't be black. The blue I see, but black is fucked"
      },
      {
        author: "Joey",
        time: "15:16",
        text: "that's what I'm sayin"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#other-games",
    participants: ["Nils", "Joey"],
    start: "2024-12-07T14:22:00",
    messages: [
      {
        author: "Nils",
        time: "14:22",
        text: "Clocktowering today <t:1733594400:R> - games will be on stream for my friend's annual extra life charity stream, so as long as you're fine with being on stream (10-20 viewers). Demo running same as previous few times"
      },
      {
        author: "Joey",
        time: "14:32",
        text: "maybe me and her could join for one stream game or something"
      },
      {
        author: "Nils",
        time: "14:38",
        text: "yeah we'll probably play for a couple hours on stream or so, then they're gonna go play pico park, so I'm happy to dip at that point and play xen den only"
      },
      {
        author: "Nils",
        time: "14:39",
        text: "she's also welcome to just join and sit as spectator and just watch games (or watch on stream), whatever works best for you guys"
      },
      {
        author: "Joey",
        time: "14:39",
        text: "perfect ty"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Kaddy", "Joey"],
    start: "2024-12-07T21:06:00",
    messages: [
      {
        author: "Joey",
        time: "21:06",
        text: "with that group yeah, xal is wanting to play games and it would be her first time"
      },
      {
        author: "Joey",
        time: "21:06",
        text: "probs best to do that with ppl we know"
      },
      {
        author: "Kaddy",
        time: "21:06",
        text: "oh ye I'd do clocktower in smol group"
      },
      {
        author: "Joey",
        time: "21:06",
        text: "or jackbox or articulate or whatever"
      },
      {
        author: "Kaddy",
        time: "21:07",
        text: "clocktower first then jockbax/similar feels like the play cause brian power required"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#other-games",
    participants: ["Kaddy", "Xal"],
    start: "2024-12-08T17:17:00",
    messages: [
      {
        author: "Xal",
        time: "17:17",
        text: "might work kaddy, just a bit unfortunate if either of us got a murder role haha"
      },
      {
        author: "Kaddy",
        time: "17:17",
        text: "that's okay I'll just text you instead of voice chatting"
      },
      {
        author: "Kaddy",
        time: "17:17",
        text: "game has all the options"
      },
      {
        author: "Xal",
        time: "17:17",
        text: "oh cool ok"
      },
      {
        author: "Kaddy",
        time: "17:19",
        text: "I've had to run werewolf games for kids at school a lot so I should be okay"
      },
      {
        author: "Kaddy",
        time: "17:19",
        text: "bruhhhh"
      },
      {
        author: "Kaddy",
        time: "17:19",
        text: "what"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#other-games",
    participants: ["Nils", "Joey"],
    start: "2024-12-09T17:12:00",
    messages: [
      {
        author: "Nils",
        time: "17:12",
        text: "Definely getting Demo, he's keen to play and not host for a few, and likely sub too minimum"
      },
      {
        author: "Joey",
        time: "17:13",
        text: "that makes us 8 + host"
      },
      {
        author: "Nils",
        time: "17:13",
        text: "Lovely stuff"
      },
      {
        author: "Joey",
        time: "17:13",
        text: "9 with Freddie 10 with Jake"
      },
      {
        author: "Nils",
        time: "17:14",
        text: "Might get q couple more trickle in from the other group too, should have decent numbers *hopefully*"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#other-games",
    participants: ["Nils", "Xal"],
    start: "2024-12-10T22:41:00",
    messages: [
      {
        author: "Xal",
        time: "22:41",
        text: "ngl i would not ever give cooked bones despite how your cats eat them"
      },
      {
        author: "Nils",
        time: "22:42",
        text: "Assume yours in python though so can't just shove them together easily"
      },
      {
        author: "Nils",
        time: "22:42",
        text: "He's american"
      },
      {
        author: "Xal",
        time: "22:42",
        text: "dogs have stronger jaws which is why it\u2019s more common for them to have issues"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Blithe", "Ava"],
    start: "2024-12-12T14:07:00",
    messages: [
      {
        author: "Ava",
        time: "14:07",
        text: "that lady had the thickest african accent and at the end goes \"if u gave me wrong info u may be prosecuted\""
      },
      {
        author: "Blithe",
        time: "14:07",
        text: "All good"
      },
      {
        author: "Blithe",
        time: "14:07",
        text: "Love me a good chuckle"
      },
      {
        author: "Ava",
        time: "14:08",
        text: "basically to know if i have money in bonds or shares so they know if im yoinking their money and investing it"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#league-of-legends",
    participants: ["Jake", "Ava"],
    start: "2024-12-13T17:47:00",
    messages: [
      {
        author: "Jake",
        time: "17:47",
        text: "To me this situation is clearly something that was the smallest issue blown out of proportion because 2 groups of people don't get along"
      },
      {
        author: "Ava",
        time: "17:47",
        text: "(an example where a derogatory insult is meant as a sign of affection)"
      },
      {
        author: "Jake",
        time: "17:47",
        text: "And I really think that everyone outside the 2 groups of people see it that way"
      },
      {
        author: "Ava",
        time: "17:48",
        text: "i think we should give them foam hammers and a platform"
      },
      {
        author: "Ava",
        time: "17:48",
        text: "gladiator style"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#botc",
    participants: ["Kaddy", "Joey"],
    start: "2024-12-18T16:40:00",
    messages: [
      {
        author: "Kaddy",
        time: "16:40",
        text: "I have one when it's looking bad for the good team"
      },
      {
        author: "Kaddy",
        time: "16:41",
        text: "probably never gonna be that unbalanced but maybe... maybe one day"
      },
      {
        author: "Joey",
        time: "16:41",
        text: "\ud83d\ude28"
      },
      {
        author: "Kaddy",
        time: "16:41",
        text: "I can't resist giving them all cool names"
      },
      {
        author: "Kaddy",
        time: "16:42",
        text: "||garlic necklace - when the demon tries to kill you someone else dies instead||"
      },
      {
        author: "Kaddy",
        time: "16:42",
        text: "||emetics - when chosen, shabaloth regurgitates all its victims of last and this night at once||"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#botc",
    participants: ["Nils", "Kaddy"],
    start: "2024-12-18T16:48:00",
    messages: [
      {
        author: "Kaddy",
        time: "16:48",
        text: "I was just trying to bullshit dumb names but that one sounds fun yeah"
      },
      {
        author: "Kaddy",
        time: "16:48",
        text: "soft confirms or denies roles, but not fully"
      },
      {
        author: "Kaddy",
        time: "16:48",
        text: "maybe, since it's a 1/5 chance, maybe even know the wake up order so you can *maybe* guess"
      },
      {
        author: "Kaddy",
        time: "16:49",
        text: "would have to ponder that"
      },
      {
        author: "Nils",
        time: "16:50",
        text: "how would you run that in game though? ask them for a room each night and then tell them \"You find nothing\" or \"you find a torch\" then they have to guess what to do with it?"
      },
      {
        author: "Kaddy",
        time: "16:50",
        text: "probably"
      },
      {
        author: "Kaddy",
        time: "16:50",
        text: "I think I'd be the kind to play with the amnesiac idea and give them vague flashbacks of their lost memory"
      },
      {
        author: "Kaddy",
        time: "16:51",
        text: "\"when you chose a person nothing happened, but a memory of you frantically feeling around in the grass in the dark flashes before you\""
      },
      {
        author: "Nils",
        time: "16:52",
        text: "||\"Each night you get a clue to the location of a hidden object. If you guess the location, gain that object and the ability to ask the order people awoke tonight\"||"
      },
      {
        author: "Nils",
        time: "16:52",
        text: "Then each night you can wake them, say something cryptic, and they'll be confused"
      },
      {
        author: "Kaddy",
        time: "16:52",
        text: "||it would be pretty funny if they figured out to guess places, but not what the power does, and just got a random ass list of names one night||"
      },
      {
        author: "Nils",
        time: "16:52",
        text: "Until they work out what your cryptic messages actually mean"
      },
      {
        author: "Kaddy",
        time: "16:53",
        text: "||\"nils, charlie, freddie\"\nwhat does it meeeean\nthey assume evil people and start throwing accusations for no reason||"
      },
      {
        author: "Kaddy",
        time: "16:54",
        text: "I shall ruminate upon it"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#HERE",
    participants: ["Jamie", "Kaddy"],
    start: "2024-12-23T22:46:00",
    messages: [
      {
        author: "Kaddy",
        time: "22:46",
        text: "glad I was able to put that in all your brains"
      },
      {
        author: "Jamie",
        time: "22:47",
        text: "LET IT GO"
      },
      {
        author: "Kaddy",
        time: "22:51",
        text: "1.    This candidate possesses a commendable amount of patience, along with a unique skill set in hair styling. However, they are afraid of heights. (Rapunzel)"
      },
      {
        author: "Kaddy",
        time: "22:53",
        text: "2.    This candidate has experience in food delivery and wildlife, but has stated they aren\u2019t ready to work in any heavily wooded area. (Little Red Riding Hood)"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#HERE",
    participants: ["Kaddy", "Hanne"],
    start: "2024-12-23T22:59:00",
    messages: [
      {
        author: "Kaddy",
        time: "22:59",
        text: "6.    This candidate brings practical experience in demolition and construction safety, although they will need some training for interpersonal skills and respecting boundaries. (Big Bad Wolf)"
      },
      {
        author: "Kaddy",
        time: "23:00",
        text: "7."
      },
      {
        author: "Hanne",
        time: "23:00",
        text: "Belle"
      },
      {
        author: "Kaddy",
        time: "23:00",
        text: "7.    This candidate has a passion for literature, curating book collections and libraries, as well as fighting prejudice and discrimination in society. (Belle / Beauty and the beast)"
      },
      {
        author: "Kaddy",
        time: "23:00",
        text: "8. ---"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#other-games",
    participants: ["Joey", "Kasai"],
    start: "2024-12-29T12:52:00",
    messages: [
      {
        author: "Kasai",
        time: "12:52",
        text: "Holy crap super cool"
      },
      {
        author: "Joey",
        time: "12:53",
        text: "guy in the shop said it's at least a PSA 9"
      },
      {
        author: "Joey",
        time: "12:53",
        text: "and if it's a 10 it goes to like \u00a3400"
      },
      {
        author: "Kasai",
        time: "13:22",
        text: "If you hold on to it and keep it safe I'd imagine it'll probs appreciate in value"
      },
      {
        author: "Kasai",
        time: "13:22",
        text: "Cause that other moonbreon goes for a lot too"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#botc",
    participants: ["Kaddy", "Joey"],
    start: "2025-01-04T17:08:00",
    messages: [
      {
        author: "Kaddy",
        time: "17:08",
        text: "against my expectations I got busy so I won't be coming up with a cool new script"
      },
      {
        author: "Kaddy",
        time: "17:09",
        text: "I will run something we have already, but if you want to and got cool ideas I think that'd be better"
      },
      {
        author: "Kaddy",
        time: "17:09",
        text: "sorry I was gonna tell you that sooner but then got real busy"
      },
      {
        author: "Joey",
        time: "17:10",
        text: "should be funny though"
      },
      {
        author: "Kaddy",
        time: "17:10",
        text: "sounds amazing"
      },
    ],
  },
  {
    server: "Accountability",
    channel: "#general",
    participants: ["Fishes", "Kaddy"],
    start: "2025-01-07T17:54:00",
    messages: [
      {
        author: "Fishes",
        time: "17:54",
        text: "I fear it\u2019s get a new pt"
      },
      {
        author: "Fishes",
        time: "17:55",
        text: "Gona track my caloric intake and increase gym attendance to 5 or 6 to add cardio days"
      },
      {
        author: "Kaddy",
        time: "17:57",
        text: "JAMIIIEEEE"
      },
      {
        author: "Kaddy",
        time: "17:58",
        text: "I fear you may be onto something there yea"
      },
      {
        author: "Fishes",
        time: "18:08",
        text: "If they quit in u once fair enough but not 2 3 times"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#real-talk",
    participants: ["Joey", "Smuck"],
    start: "2025-01-13T15:56:00",
    messages: [
      {
        author: "Joey",
        time: "15:56",
        text: "someone gets me"
      },
      {
        author: "Smuck",
        time: "15:56",
        text: "You and me Joe"
      },
      {
        author: "Smuck",
        time: "15:57",
        text: "Forgetful gang"
      },
      {
        author: "Joey",
        time: "15:57",
        text: "i know two birthdays in this server and one of them is my partner so that doesn't count"
      },
      {
        author: "Joey",
        time: "15:57",
        text: "I don't even know Charlie's and he's been one of my closest friends for like 10 years"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#media",
    participants: ["Kaddy", "Xal"],
    start: "2025-01-13T20:14:00",
    messages: [
      {
        author: "Kaddy",
        time: "20:14",
        text: "living that destroyed cochlea life"
      },
      {
        author: "Xal",
        time: "20:14",
        text: "airpods on max for 6h a day will do that"
      },
      {
        author: "Kaddy",
        time: "20:20",
        text: "me every single time I forget a friend's birthday birthday\nthen also me again the next year\nnever do it"
      },
      {
        author: "Kaddy",
        time: "20:20",
        text: "unrelated question how do you apologize to a friend for forgetting their birthday three years in a row? just asking for a friend"
      },
      {
        author: "Kaddy",
        time: "20:22",
        text: "this man is lying btw. unless he actively calendars my tiny life events like a stalker"
      },
      {
        author: "Kaddy",
        time: "20:22",
        text: "I have wondered how he does it"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#real-talk",
    participants: ["Nic", "Smuck"],
    start: "2025-01-16T13:03:00",
    messages: [
      {
        author: "Smuck",
        time: "13:03",
        text: "Not this weekend cause gotta celebrate my sisters uni graduation but maybe next week"
      },
      {
        author: "Smuck",
        time: "13:03",
        text: "Can't get blood checked without a doctors note. Next doctor they had was in april"
      },
      {
        author: "Smuck",
        time: "13:03",
        text: "So might have to go to emergency again where they locked me up for 3 days last time :/"
      },
      {
        author: "Nic",
        time: "13:04",
        text: "Can't wait to be there"
      },
      {
        author: "Smuck",
        time: "13:05",
        text: "I'll throw a cake at you"
      },
      {
        author: "Nic",
        time: "13:10",
        text: "I'd open my mouth"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#real-talk",
    participants: ["Kaddy", "Smuck"],
    start: "2025-01-16T13:13:00",
    messages: [
      {
        author: "Kaddy",
        time: "13:13",
        text: "what the heck"
      },
      {
        author: "Kaddy",
        time: "13:14",
        text: "can't they speed it up on account of MULTIPLE PASSING OUTS A DAY"
      },
      {
        author: "Kaddy",
        time: "13:14",
        text: "gonna come get you and drag you to my doctor here and throw hands with sweden on the way"
      },
      {
        author: "Smuck",
        time: "13:16",
        text: "I mean probably can get checked on emergency. But my doctor has quit, so need to get a new doctor before they can give me a thing to get blood tests"
      },
      {
        author: "Smuck",
        time: "13:17",
        text: "Don't think it's an emergency. This has been the only really bad day for 2 years"
      },
      {
        author: "Smuck",
        time: "13:17",
        text: "So I'm probably good"
      },
      {
        author: "Kaddy",
        time: "13:21",
        text: "ah dang it"
      },
      {
        author: "Kaddy",
        time: "13:21",
        text: "fair enough but you better get it checked eventually"
      },
      {
        author: "Smuck",
        time: "13:24",
        text: "I will (probably)"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#real-talk",
    participants: ["Clom", "Smuck"],
    start: "2025-01-16T13:51:00",
    messages: [
      {
        author: "Clom",
        time: "13:51",
        text: "Surely you can get a referral based on your previous doctor quitting"
      },
      {
        author: "Smuck",
        time: "13:52",
        text: "Honestly no idea. I'll get it sorted, it's no rush I don't think"
      },
      {
        author: "Clom",
        time: "13:55",
        text: "I used to get a similar thing due to low blood pressure"
      },
      {
        author: "Clom",
        time: "13:55",
        text: "Make sure you have your vitamins and iron"
      },
      {
        author: "Smuck",
        time: "13:57",
        text: "Just got refilled on iron, so hopefully that'll put me right as rain <:SayoriSunglasses:626797609973055489>"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#real-talk",
    participants: ["Kaddy", "Blithe"],
    start: "2025-01-18T13:36:00",
    messages: [
      {
        author: "Kaddy",
        time: "13:36",
        text: "just once?"
      },
      {
        author: "Blithe",
        time: "13:37",
        text: "I'm a very cautious and careful driver"
      },
      {
        author: "Blithe",
        time: "13:37",
        text: "so when I rained like a motherfucker, I couldn't see shit on the highway at 1 am and the truck in front of me slammed his breaks I fucking almost hit the side rail lmao"
      },
      {
        author: "Kaddy",
        time: "13:38",
        text: "ohh yea that'll do it"
      },
      {
        author: "Kaddy",
        time: "13:38",
        text: "I try to drive careful, but I've had some pretty unfortunate encounters with ice and mud"
      },
      {
        author: "Blithe",
        time: "13:39",
        text: "yeah same but usually nothing more than some accidental sliding"
      },
      {
        author: "Blithe",
        time: "13:42",
        text: "there was also a guy some time ago that kept on fucking breakchecking me on the highway, also at like 2 am lmao"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#league-of-legends",
    participants: ["Charlie", "Ava"],
    start: "2025-01-21T14:26:00",
    messages: [
      {
        author: "Charlie",
        time: "14:26",
        text: "the surface of the pool is lined with a sheen of suncream and piss"
      },
      {
        author: "Ava",
        time: "14:27",
        text: "<:blobsweats:1292965401746997248>"
      },
      {
        author: "Charlie",
        time: "14:27",
        text: "and they hired me as a lifeguard which speaks volumes to their safety standards"
      },
      {
        author: "Ava",
        time: "14:27",
        text: "It sounds like this location should be a biohazard"
      },
      {
        author: "Ava",
        time: "14:27",
        text: "Mainly bc you were there"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#league-of-legends",
    participants: ["Charlie", "Ava"],
    start: "2025-01-21T14:31:00",
    messages: [
      {
        author: "Ava",
        time: "14:31",
        text: "Not hearing a minimum of 2 people in your head at all times is crazy"
      },
      {
        author: "Charlie",
        time: "14:31",
        text: "you have no idea what kinds of whimsy i conjure, unfettered by the voices"
      },
      {
        author: "Ava",
        time: "14:31",
        text: "It must be so quiet for you guys"
      },
      {
        author: "Charlie",
        time: "14:31",
        text: "its really really loud actually but its not voices"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#media",
    participants: ["Ava", "Smuck"],
    start: "2025-01-21T15:26:00",
    messages: [
      {
        author: "Ava",
        time: "15:26",
        text: "No one lets me talk about my blood fixation <a:PensiveAF:869955456737636402>"
      },
      {
        author: "Smuck",
        time: "15:26",
        text: "I be shakin the ones on my neck. Never any other tho"
      },
      {
        author: "Ava",
        time: "15:27",
        text: "I be fondling my veins fr"
      },
      {
        author: "Smuck",
        time: "15:27",
        text: "I have a blood fixation too! Mine is just medical"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Fishes", "Xal"],
    start: "2025-01-23T11:17:00",
    messages: [
      {
        author: "Xal",
        time: "11:17",
        text: "it\u2019s healthy as long as u don\u2019t cut too much"
      },
      {
        author: "Fishes",
        time: "11:17",
        text: "in the poast month"
      },
      {
        author: "Fishes",
        time: "11:17",
        text: "true"
      },
      {
        author: "Xal",
        time: "11:18",
        text: "you need to make sure you\u2019re on at least your minimum calories e.g. 2500"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#botc",
    participants: ["Kaddy", "Xal"],
    start: "2025-01-27T23:03:00",
    messages: [
      {
        author: "Xal",
        time: "23:03",
        text: "can we get demo in this server i swear bro is always around"
      },
      {
        author: "Kaddy",
        time: "23:03",
        text: "<@119557959440269314>  can we"
      },
      {
        author: "Xal",
        time: "23:03",
        text: "guys sorry i cant invite you im shitting and i just realised i have no toilet roll"
      },
      {
        author: "Xal",
        time: "23:03",
        text: "disaster"
      },
    ],
  },
  {
    server: "Accountability",
    channel: "#weekly-plan",
    participants: ["Jamie", "Fishes"],
    start: "2025-02-04T07:53:00",
    messages: [
      {
        author: "Fishes",
        time: "07:53",
        text: "if i find the channel theres a guy who is insanely flexible and he does simple tutorials to follow"
      },
      {
        author: "Fishes",
        time: "07:57",
        text: "fair enough i was tihnking if u did a single arm preacher curl"
      },
      {
        author: "Fishes",
        time: "07:57",
        text: "but not sure how much that does for the wrist"
      },
      {
        author: "Jamie",
        time: "08:05",
        text: "I found it\u2019s like if I have one I hold weirdly it just fucks it"
      },
      {
        author: "Jamie",
        time: "08:05",
        text: "I\u2019m doing a mixture of hammer curl styles so some outward facing etc"
      },
      {
        author: "Fishes",
        time: "08:31",
        text: "ah ok makes sense"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#shit",
    participants: ["Freddie", "Jake"],
    start: "2025-02-09T16:21:00",
    messages: [
      {
        author: "Jake",
        time: "16:21",
        text: "the machines are not getting powered fully"
      },
      {
        author: "Jake",
        time: "16:22",
        text: "i think the limiting factor atleast for the 2 drill ones are the solar panels"
      },
      {
        author: "Jake",
        time: "16:22",
        text: "the batteries at the gold iron dont get filled up enough by sunset"
      },
      {
        author: "Jake",
        time: "16:22",
        text: "and at that point they empty out really fast"
      },
      {
        author: "Freddie",
        time: "16:24",
        text: "u think we need more solar or better solar placement?"
      },
      {
        author: "Jake",
        time: "16:35",
        text: "just more i think"
      },
      {
        author: "Freddie",
        time: "17:03",
        text: "i dont think this is right"
      },
      {
        author: "Freddie",
        time: "17:04",
        text: "1 solar panel fills all the batteries and there in no change in the rate of drilling with one solar compared to 2 solar"
      },
      {
        author: "Jake",
        time: "17:04",
        text: "fair enough"
      },
      {
        author: "Jake",
        time: "17:04",
        text: "i did move the solar panels into what i thought was a better spot"
      },
      {
        author: "Jake",
        time: "17:04",
        text: "that might have been effective then i realised"
      },
      {
        author: "Freddie",
        time: "17:05",
        text: "ye i saw, ill have a look at the gold/silica now and test if 2 solar makes a difference or if moving it makes a difference"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#other-games",
    participants: ["Buppy", "Charlie"],
    start: "2025-02-25T17:38:00",
    messages: [
      {
        author: "Charlie",
        time: "17:38",
        text: "joe you're the networker of the server can you find some femdoms please"
      },
      {
        author: "Charlie",
        time: "17:38",
        text: "we're lacking in that demographic"
      },
      {
        author: "Buppy",
        time: "17:38",
        text: "Im that but for the ladies idk what to tell you"
      },
      {
        author: "Charlie",
        time: "17:39",
        text: "its so hard being a man"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#other-games",
    participants: ["Charlie", "Ava"],
    start: "2025-02-26T01:29:00",
    messages: [
      {
        author: "Charlie",
        time: "01:29",
        text: "im bricked up"
      },
      {
        author: "Ava",
        time: "01:29",
        text: "ill give it a spin"
      },
      {
        author: "Ava",
        time: "01:29",
        text: "im ngl the combat doesnt look like it has much depth tho"
      },
      {
        author: "Charlie",
        time: "01:30",
        text: "when does it release"
      },
      {
        author: "Ava",
        time: "01:31",
        text: "well the playtest is out but it doesnt seem to have a scheduled release date"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#food",
    participants: ["Buppy", "Blithe"],
    start: "2025-02-26T16:21:00",
    messages: [
      {
        author: "Blithe",
        time: "16:21",
        text: "I don't like peanutbutter"
      },
      {
        author: "Blithe",
        time: "16:21",
        text: "Burn me on the stakes for that, I just don't wanna eat it anymore"
      },
      {
        author: "Buppy",
        time: "16:22",
        text: "Well im writing that on YOUR file!!!!!"
      },
      {
        author: "Blithe",
        time: "16:23",
        text: "I can forward you my therapist and you can add that in there"
      },
      {
        author: "Blithe",
        time: "16:23",
        text: "Might be some space somewhere in there for that"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#real-talk",
    participants: ["Charlie", "Ava"],
    start: "2025-02-27T08:41:00",
    messages: [
      {
        author: "Ava",
        time: "08:41",
        text: "Oh I won't be attending in person"
      },
      {
        author: "Ava",
        time: "08:42",
        text: "And yea it's a victim impact and he is guaranteed to be guilty, even if it just passes as negligence"
      },
      {
        author: "Charlie",
        time: "08:57",
        text: "eu server was a lil goofy last night but down to play more today"
      },
      {
        author: "Ava",
        time: "08:57",
        text: "<a:nodding:913082173257564230>"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#botc",
    participants: ["Kaddy", "Joey"],
    start: "2025-03-01T20:11:00",
    messages: [
      {
        author: "Joey",
        time: "20:11",
        text: "thats fine we can explain it"
      },
      {
        author: "Joey",
        time: "20:12",
        text: "or if you want to wait for redd thats fine as well"
      },
      {
        author: "Kaddy",
        time: "20:13",
        text: "no worries I'll give you a rundown"
      },
      {
        author: "Joey",
        time: "20:14",
        text: "are we expecting you guys tonight <@148495666002395136> <@91198671168753664> ?"
      },
      {
        author: "Joey",
        time: "20:14",
        text: "what time is dnd over"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Joey", "Smuck"],
    start: "2025-03-01T20:23:00",
    messages: [
      {
        author: "Smuck",
        time: "20:23",
        text: "Call them what they are"
      },
      {
        author: "Joey",
        time: "20:24",
        text: "2-3.5kg"
      },
      {
        author: "Smuck",
        time: "20:24",
        text: "4 hour session. With people that wouldn't even invite Fishes no less :/"
      },
      {
        author: "Joey",
        time: "20:25",
        text: "i assume you could do mroe but thats probably what they consider the healthy amount"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#real-talk",
    participants: ["Charlie", "Nic"],
    start: "2025-03-03T16:21:00",
    messages: [
      {
        author: "Nic",
        time: "16:21",
        text: "I think that's mostly when they are in their teens and growing, I think it's highly irregular to sleep over 10 hours in your adult years"
      },
      {
        author: "Nic",
        time: "16:21",
        text: "not a cause of concern but is if done consistently can be unhealthy"
      },
      {
        author: "Nic",
        time: "16:22",
        text: "but 9 hours is still fine, 11 is a lot"
      },
      {
        author: "Charlie",
        time: "16:24",
        text: "i dont think its the oversleeping that's bad in itself, but if you regularly need more than 8ish then it can be a sign of an underlying condition"
      },
      {
        author: "Nic",
        time: "16:25",
        text: "but usually sleeping habits are well habits, I've had a period of time of oversleeping but just got used to other sleeping patterns, you can train yourself if it's not a medical issue"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#league-of-legends",
    participants: ["Robbe", "Smuck"],
    start: "2025-03-03T18:44:00",
    messages: [
      {
        author: "Smuck",
        time: "18:44",
        text: "I'm awake, we do not need this sorta language in these trying times!"
      },
      {
        author: "Smuck",
        time: "18:48",
        text: "<@&1292957864993755229> Only 3 spots left :3 teehee"
      },
      {
        author: "Robbe",
        time: "18:50",
        text: "ready whenever too"
      },
      {
        author: "Smuck",
        time: "18:53",
        text: "12 hour minimum lifestyle. Some of us just built that way. I'll admit it, not everyone can handle it like me. But this is what peak performance looks like"
      },
      {
        author: "Smuck",
        time: "18:57",
        text: "Used to have a Pavlok electric wristband that I synced with my alarm clock on mornings it was important I woke up and was awake on time. Worked pretty well for a year until it broke :("
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#league-of-legends",
    participants: ["Fishes", "Smuck"],
    start: "2025-03-03T19:08:00",
    messages: [
      {
        author: "Smuck",
        time: "19:08",
        text: "Don't wanna dm people man.."
      },
      {
        author: "Fishes",
        time: "19:09",
        text: "you'll be the champion"
      },
      {
        author: "Fishes",
        time: "19:09",
        text: "that guy"
      },
      {
        author: "Smuck",
        time: "19:09",
        text: "Why do we not have 10 cool people on the server? <:sobwhy:613337878939959336>"
      },
      {
        author: "Smuck",
        time: "19:16",
        text: "<@91198671168753664> Thoughts on me adding a bunch of random league players to fill the last spots and also to future proof us? <:think_owo:857726454594797568>"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#real-talk",
    participants: ["Nils", "Ava"],
    start: "2025-03-04T11:42:00",
    messages: [
      {
        author: "Ava",
        time: "11:42",
        text: "Is this saying I need to renew my contract or what"
      },
      {
        author: "Nils",
        time: "11:44",
        text: "Na, it'll just keep rolling over each month until you cancel it, but you are now able to cancel it"
      },
      {
        author: "Ava",
        time: "11:45",
        text: "Why is it increasing every april"
      },
      {
        author: "Nils",
        time: "11:45",
        text: "Because the poor poor cooperations are so poor and need more money!"
      },
      {
        author: "Ava",
        time: "11:45",
        text: "<:wyd:1292965298395418815>"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Joey", "Xal"],
    start: "2025-03-05T19:53:00",
    messages: [
      {
        author: "Xal",
        time: "19:53",
        text: "reddit is crazy pedo land"
      },
      {
        author: "Xal",
        time: "19:53",
        text: "i get afraid when people i know use reddit to an extreme degree"
      },
      {
        author: "Joey",
        time: "19:54",
        text: "using reddit does not make you a pedo \ud83d\ude2d"
      },
      {
        author: "Joey",
        time: "19:54",
        text: "a virgin loser sure"
      },
      {
        author: "Xal",
        time: "19:54",
        text: "no it makes u so much more inclined to be a pedophile"
      },
      {
        author: "Xal",
        time: "19:55",
        text: "probably statistically true that if u use reddit u have a higher likelihood of pedophelia"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Nils", "Xal"],
    start: "2025-03-06T15:42:00",
    messages: [
      {
        author: "Xal",
        time: "15:42",
        text: "so the story is that\ni named it array bc i thought thats what i was doing (i thought thats what a separated list was called and thats what i thought i knew how to do) but when i re-read the brief it said list"
      },
      {
        author: "Nils",
        time: "15:42",
        text: "it'll be fine"
      },
      {
        author: "Nils",
        time: "15:42",
        text: "p much what charlie said, they're both basically the same thing"
      },
      {
        author: "Xal",
        time: "15:42",
        text: "okok"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Buppy", "Joey"],
    start: "2025-03-12T17:34:00",
    messages: [
      {
        author: "Buppy",
        time: "17:34",
        text: "Im afraid to say redds empathy is on par with mine bros"
      },
      {
        author: "Buppy",
        time: "17:34",
        text: "And mine rocks..."
      },
      {
        author: "Joey",
        time: "17:34",
        text: "no shot"
      },
      {
        author: "Buppy",
        time: "17:34",
        text: "Yes shot fr fr"
      },
      {
        author: "Joey",
        time: "17:34",
        text: "Redd is the kind of guy to go to the cinema 3 times a week"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#shooter-games",
    participants: ["Buppy", "Joey"],
    start: "2025-03-12T18:23:00",
    messages: [
      {
        author: "Joey",
        time: "18:23",
        text: "my main hasn't got an email so i imagine its because you played with an account that got banned"
      },
      {
        author: "Buppy",
        time: "18:23",
        text: "Yeah i played with djmoira as well"
      },
      {
        author: "Buppy",
        time: "18:23",
        text: "Checks out"
      },
      {
        author: "Joey",
        time: "18:23",
        text: "DM me if you want an account to play on, idc if you get em banned so do whatever on it"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#real-talk",
    participants: ["Nils", "Robbe"],
    start: "2025-03-14T10:52:00",
    messages: [
      {
        author: "Robbe",
        time: "10:52",
        text: "I know I should pull the lever but idk if I could"
      },
      {
        author: "Nils",
        time: "10:52",
        text: "Should you? Is that one person, although you care greatly about them, worth saving at the expense of 100 other lives"
      },
      {
        author: "Nils",
        time: "10:53",
        text: "I'm probably the opposite of that, I know I shouldn't pull the lever, 100 lives vs 1, no matter how important this person to me"
      },
      {
        author: "Nils",
        time: "10:53",
        text: "But I am absolutely pulling it"
      },
      {
        author: "Nils",
        time: "10:53",
        text: "Because I'm a selfish bastard for me and those I'm close to"
      },
      {
        author: "Robbe",
        time: "10:53",
        text: "Oh wait I have the problem wrong"
      },
      {
        author: "Nils",
        time: "10:54",
        text: "If you do nothing, the one person you care about dies"
      },
      {
        author: "Robbe",
        time: "10:54",
        text: "I thought pulling = killing your loved one"
      },
      {
        author: "Nils",
        time: "10:54",
        text: "You have to interact to save that person and kill ohters"
      },
      {
        author: "Robbe",
        time: "10:54",
        text: "I do nothing"
      },
      {
        author: "Robbe",
        time: "10:56",
        text: "I don't think I could live with the guilt either way"
      },
      {
        author: "Robbe",
        time: "10:57",
        text: "I think your scenario is easier than mine tbh"
      },
      {
        author: "Robbe",
        time: "10:57",
        text: "If I had to pull to save the others and kill my loved one I think it would me a much harder decision"
      },
      {
        author: "Nils",
        time: "10:59",
        text: "Huh, really? I considered it the opposite"
      },
      {
        author: "Nils",
        time: "10:59",
        text: "I suppose considering we have answers, that'll influence what we think is the easier thing to do"
      },
      {
        author: "Robbe",
        time: "11:01",
        text: "Yes absolutely, I'd be much more likely to make the morality right decision if I didn't have to do anything for it"
      },
      {
        author: "Nils",
        time: "11:03",
        text: "If I have to do nothing, and it means my loved one lives and 100 (e.g.) random people die"
      },
      {
        author: "Nils",
        time: "11:04",
        text: "That's an incredibly easy do nothing decision"
      },
      {
        author: "Nils",
        time: "11:04",
        text: "Imo"
      },
      {
        author: "Nils",
        time: "11:04",
        text: "Sure I could've saved them"
      },
      {
        author: "Nils",
        time: "11:04",
        text: "But I've done no active actions to contribute to their deaths"
      },
      {
        author: "Robbe",
        time: "11:06",
        text: "Ah yes I agree"
      },
      {
        author: "Robbe",
        time: "11:07",
        text: "Do nothing is always the easier decision imo, I just meant easier as in easier to do the 'right' thing"
      },
      {
        author: "Robbe",
        time: "11:09",
        text: "In my situation I'd need more randoms on the line than in yours"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#real-talk",
    participants: ["Buppy", "Robbe"],
    start: "2025-03-14T12:15:00",
    messages: [
      {
        author: "Robbe",
        time: "12:15",
        text: "Buppy if there was an empty track and one with you on it I'd connect the tracks in a loop so you get hit multiple times"
      },
      {
        author: "Buppy",
        time: "12:15",
        text: "Wait this is the real talk channel i was joking..."
      },
      {
        author: "Buppy",
        time: "12:15",
        text: "Not abt robbe tho"
      },
      {
        author: "Buppy",
        time: "12:16",
        text: "Knowing you youd fuck up the connection so bad the train would start questioning your mental fortitude"
      },
      {
        author: "Robbe",
        time: "12:16",
        text: "I wouldn't be mad at anyone for making any decision in the trolley problem I think"
      },
      {
        author: "Buppy",
        time: "12:17",
        text: "I would be"
      },
      {
        author: "Buppy",
        time: "12:17",
        text: "If any of you pricks choose people over cats in that one specific problem"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#real-talk",
    participants: ["Nic", "Smuck"],
    start: "2025-03-14T13:02:00",
    messages: [
      {
        author: "Nic",
        time: "13:02",
        text: "11 makes me angry"
      },
      {
        author: "Nic",
        time: "13:04",
        text: "And 3.  you clearly have an easy way to stop the death not doing anything is crazy"
      },
      {
        author: "Nic",
        time: "13:04",
        text: "Psycho stuff"
      },
      {
        author: "Nic",
        time: "13:04",
        text: "Monk looking at the side \"sorry son but I don't have to help you\""
      },
      {
        author: "Nic",
        time: "13:04",
        text: "Not getting into this"
      },
      {
        author: "Nic",
        time: "13:04",
        text: "I can't help it"
      },
      {
        author: "Smuck",
        time: "13:05",
        text: "I know it seems crazy. But that's a moral code rather than having vibes."
      },
      {
        author: "Nic",
        time: "13:05",
        text: "If a moral code makes people suffer then the moral code isn't working"
      },
      {
        author: "Smuck",
        time: "13:05",
        text: "Afraid there is no such thing as a working moral code then"
      },
      {
        author: "Nic",
        time: "13:05",
        text: "Then your moral code doesn't work either"
      },
      {
        author: "Smuck",
        time: "13:06",
        text: "Or at least not one I've encountered"
      },
      {
        author: "Smuck",
        time: "13:06",
        text: "If that's your definition of a working moral code. No it does not"
      },
      {
        author: "Nic",
        time: "13:06",
        text: "And then it just suffering for the sake of your non working code"
      },
      {
        author: "Nic",
        time: "13:06",
        text: "If a person dies because it's up to whether or not you wanna help then it's not working"
      },
      {
        author: "Smuck",
        time: "13:07",
        text: "**Points at homeless person on the streets**"
      },
      {
        author: "Nic",
        time: "13:07",
        text: "If you are the only one who can prevent an imediate death that has no consequences for you doing  then not pulling the lever is crazy"
      },
      {
        author: "Nic",
        time: "13:07",
        text: "I don't have a way to imediately help a homeless man"
      },
      {
        author: "Nic",
        time: "13:07",
        text: "Not in a way that doesn't make me do anything illegal"
      },
      {
        author: "Nic",
        time: "13:08",
        text: "While  aperson who I can just do an arm motion and saved should just be saved every time"
      },
      {
        author: "Nic",
        time: "13:08",
        text: "It's barely an inconvience to you"
      },
      {
        author: "Smuck",
        time: "13:09",
        text: "The idea of it being an immediate or slow death should have no bearing on weather or not an action is moral or not. End result is the same. You could have helped, you didn't. Now they're dead. Yet we all make that choice every day yet I don't think everyone around me is a monster like I should if all I truly cared about was the end result."
      },
      {
        author: "Smuck",
        time: "13:09",
        text: "Immidiate death simply feels harder. Cause it's right in your face."
      },
      {
        author: "Smuck",
        time: "13:09",
        text: "Once again, vibes based"
      },
      {
        author: "Smuck",
        time: "13:10",
        text: "Driven by emotion rather than logic"
      },
      {
        author: "Nic",
        time: "13:10",
        text: "But two different factors at state ihere is the simplyfication of how you can save them. It's not just vibes. If I have to save a homeless man I would have to go out set my life on break for the long term and maybe work multiple jobs, I vote that is my way of trying to save homeless. If there was a button that could save all homeless I would"
      },
      {
        author: "Nic",
        time: "13:11",
        text: "It's illogical to say that saving a person at the pull of a lever with no consquences is up to you is illogical"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#real-talk",
    participants: ["Nic", "Smuck"],
    start: "2025-03-14T13:15:00",
    messages: [
      {
        author: "Nic",
        time: "13:15",
        text: "But isn't morality the way you decide on whether or not something is bad or good in a society"
      },
      {
        author: "Nic",
        time: "13:15",
        text: "Society"
      },
      {
        author: "Smuck",
        time: "13:15",
        text: "Since from what I've seen of morality which goes into what one should do. It always ends in some dystopian nightmare where the starting position was lost a long way back in the name of goodness"
      },
      {
        author: "Smuck",
        time: "13:16",
        text: "Nope. It's what makes you be worthy of your own life. It's merely the extent to which you earn your breath. At least from my systems standpoint."
      },
      {
        author: "Nic",
        time: "13:17",
        text: "So it's your own way of viewing what morality is?"
      },
      {
        author: "Smuck",
        time: "13:18",
        text: "Eh, sorta. It's what I expect from the people around me and what others should expect of me. It's the baseline. I don't think most people will be good, just moral."
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#real-talk",
    participants: ["Nic", "Smuck"],
    start: "2025-03-14T13:19:00",
    messages: [
      {
        author: "Smuck",
        time: "13:19",
        text: "Probably shot myself in the foot by calling it morality, good and bad. Since people go in with preestablished ideas of what I mean"
      },
      {
        author: "Smuck",
        time: "13:19",
        text: "Crazy thing is you can be both. And everyone should strive to be both"
      },
      {
        author: "Nic",
        time: "13:19",
        text: "The moral basis is what most people would consider a good act"
      },
      {
        author: "Nic",
        time: "13:20",
        text: "But a bad act can also be a good act. It's not just one or the other. The morality is how you balance it out"
      },
      {
        author: "Smuck",
        time: "13:20",
        text: "I know, think that definition is completely misguided as it's the basis for far too many atrocities throughout history."
      },
      {
        author: "Nic",
        time: "13:20",
        text: "Like the kill one person or everyone else dies"
      },
      {
        author: "Nic",
        time: "13:21",
        text: "But your viewpoint would lead to an atrocity if you depend on people to just be good"
      },
      {
        author: "Nic",
        time: "13:21",
        text: "I gave you an atrocity scenario where everyone dies"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#other-games",
    participants: ["Fishes", "Xal"],
    start: "2025-03-14T18:36:00",
    messages: [
      {
        author: "Xal",
        time: "18:36",
        text: "now compare the way you play your the way i play"
      },
      {
        author: "Fishes",
        time: "18:36",
        text: "rather than being decent at it"
      },
      {
        author: "Xal",
        time: "18:36",
        text: "if you played the way i do there is no chance you would enjoy it"
      },
      {
        author: "Xal",
        time: "18:36",
        text: "like"
      },
      {
        author: "Xal",
        time: "18:37",
        text: "if you can hold your own in a game, you are decent"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#other-games",
    participants: ["Kaddy", "Smuck"],
    start: "2025-03-14T18:40:00",
    messages: [
      {
        author: "Smuck",
        time: "18:40",
        text: "Wat da hell"
      },
      {
        author: "Kaddy",
        time: "18:41",
        text: "I honestly play games to relax and/or hang out with friends\nmost of the time I want something to do and talk about that doesn't require too much brain power"
      },
      {
        author: "Kaddy",
        time: "18:41",
        text: "bonus points if funny moments"
      },
      {
        author: "Kaddy",
        time: "18:42",
        text: "or squirrel behaviour"
      },
      {
        author: "Smuck",
        time: "18:42",
        text: "Role play or competitive for me. As long as I get one of the two I'll be happy"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#other-games",
    participants: ["Robbe", "Xal"],
    start: "2025-03-14T18:42:00",
    messages: [
      {
        author: "Robbe",
        time: "18:42",
        text: "Only competitive game I enjoy is overwatch just because I'm somewhat decent at it"
      },
      {
        author: "Xal",
        time: "18:42",
        text: "that is where we differ"
      },
      {
        author: "Xal",
        time: "18:43",
        text: "idc how good i get at the game if im playing with someone better than me its just miserable"
      },
      {
        author: "Robbe",
        time: "18:43",
        text: "That's fair"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#other-games",
    participants: ["Fishes", "Jake"],
    start: "2025-03-14T18:46:00",
    messages: [
      {
        author: "Fishes",
        time: "18:46",
        text: "ye thats makes sense games are more relaxing when you aren't on the perma grind but just enjoying the journey"
      },
      {
        author: "Jake",
        time: "18:52",
        text: "its stressful but god damn nothing"
      },
      {
        author: "Fishes",
        time: "18:53",
        text: "its so nice reaching a milestone"
      },
      {
        author: "Jake",
        time: "18:53",
        text: "and i mean nothing compared to the damn high of a group competitive experiance that is so intense and you come away with the win"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#other-games",
    participants: ["Nils", "Joey"],
    start: "2025-03-14T20:41:00",
    messages: [
      {
        author: "Nils",
        time: "20:41",
        text: "This is why I never took league seriously, I just liked fucking around on arams... If I tried I lost anyway and it was much less fun"
      },
      {
        author: "Nils",
        time: "20:41",
        text: "And I cannot be bothered to put in the time to get good at it"
      },
      {
        author: "Joey",
        time: "20:43",
        text: "im around, we can run one of the custom rule scripts to keep it interesting"
      },
      {
        author: "Nils",
        time: "20:47",
        text: "Damn, absolutely brilliant site back in the day"
      },
      {
        author: "Nils",
        time: "20:47",
        text: "Turned to complete shit in the last 10 years"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Buppy", "Charlie"],
    start: "2025-03-15T17:59:00",
    messages: [
      {
        author: "Buppy",
        time: "17:59",
        text: "Very nice finally one i agree with as i am the nicest person ive ever met"
      },
      {
        author: "Buppy",
        time: "18:00",
        text: "<:Copege:1182750063265579079>"
      },
      {
        author: "Charlie",
        time: "18:00",
        text: "moving you more racist \ud83d\udc4d"
      },
      {
        author: "Buppy",
        time: "18:00",
        text: "NO!!!!"
      },
      {
        author: "Buppy",
        time: "18:01",
        text: "U wouldnt get it charlie i only hate based off of vibe"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Nic", "Xal"],
    start: "2025-03-18T10:47:00",
    messages: [
      {
        author: "Xal",
        time: "10:47",
        text: "whatttt"
      },
      {
        author: "Nic",
        time: "10:47",
        text: "Feel like you'd get paranoid and confrontational"
      },
      {
        author: "Xal",
        time: "10:49",
        text: "noooo"
      },
      {
        author: "Xal",
        time: "10:49",
        text: "ok i did get paranoid once but if we inside im chillin"
      },
      {
        author: "Nic",
        time: "10:50",
        text: "I think the blunt rotation does depends on the place we smokin"
      },
      {
        author: "Xal",
        time: "10:50",
        text: "i\u2019m more a fall asleep on the stairs type mf"
      },
      {
        author: "Nic",
        time: "10:50",
        text: "I could see you inside smoking be chill af"
      },
      {
        author: "Nic",
        time: "10:50",
        text: "If you're like me then outside is spooky"
      },
      {
        author: "Xal",
        time: "10:50",
        text: "i used to smoke outside but then i got paranoia so bad i never did it again"
      },
      {
        author: "Xal",
        time: "10:51",
        text: "bro i thought there was ppl waiting behind cars to jump us"
      },
      {
        author: "Nic",
        time: "10:51",
        text: "I feel you, if it's smoking outside in a forest then it's fine, anywherr near a city, especially a city where people know me I get scared"
      },
      {
        author: "Nic",
        time: "10:52",
        text: "Everyone's watching me and everyone is a cop"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Charlie", "Xal"],
    start: "2025-03-18T13:55:00",
    messages: [
      {
        author: "Xal",
        time: "13:55",
        text: "some people don\u2019t like it but there\u2019s a lot of women doing drag"
      },
      {
        author: "Xal",
        time: "13:55",
        text: "a lot of trans women too"
      },
      {
        author: "Charlie",
        time: "13:55",
        text: "drag queens are just over the top flamboyant, dramatic characters, and those characters can be played by anyone, but usually its gay men"
      },
      {
        author: "Xal",
        time: "13:55",
        text: "ye"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#real-talk",
    participants: ["Charlie", "Joey"],
    start: "2025-03-18T14:00:00",
    messages: [
      {
        author: "Charlie",
        time: "14:00",
        text: "if we're going original even i will conceded that red bull wins"
      },
      {
        author: "Charlie",
        time: "14:00",
        text: "original monster tastes like drain cleaner"
      },
      {
        author: "Joey",
        time: "14:00",
        text: "they both taste like chemicals but at least red bull hasn't got hydrochloric acid in it"
      },
      {
        author: "Charlie",
        time: "14:00",
        text: "diana's e and r were swapped"
      },
      {
        author: "Charlie",
        time: "14:00",
        text: "i want this guy beaten"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#media",
    participants: ["Joey", "Kasai"],
    start: "2025-03-19T17:19:00",
    messages: [
      {
        author: "Joey",
        time: "17:19",
        text: "we're so back"
      },
      {
        author: "Joey",
        time: "17:19",
        text: "this sounds really nice"
      },
      {
        author: "Kasai",
        time: "17:28",
        text: "Personal experience with Deepcool is that the quality of their products is shit"
      },
      {
        author: "Kasai",
        time: "17:28",
        text: "I've had 6 fans from them and all of them broke"
      },
      {
        author: "Joey",
        time: "17:31",
        text: "awesome"
      },
    ],
  },
  {
    server: "Accountability",
    channel: "#general",
    participants: ["Jamie", "Kaddy"],
    start: "2025-03-20T17:30:00",
    messages: [
      {
        author: "Jamie",
        time: "17:30",
        text: "hahaha"
      },
      {
        author: "Jamie",
        time: "17:35",
        text: "i may or may not be using snus to help the cravings"
      },
      {
        author: "Jamie",
        time: "17:35",
        text: "but the first goal is not wanting to vape"
      },
      {
        author: "Kaddy",
        time: "17:37",
        text: "<:yourcu1Hmmm:633295881147252747>"
      },
      {
        author: "Kaddy",
        time: "17:38",
        text: "feels worse but I have no clue how much nic you actually absorb from snus so I shall not speak"
      },
      {
        author: "Jamie",
        time: "17:38",
        text: "same strength as my vape but i do it a lot less often"
      },
      {
        author: "Jamie",
        time: "17:38",
        text: "imo still isnt good but will stop me getting a vape"
      },
      {
        author: "Kaddy",
        time: "17:38",
        text: "true"
      },
      {
        author: "Kaddy",
        time: "17:38",
        text: "one step at a time"
      },
      {
        author: "Jamie",
        time: "17:38",
        text: "exactly\n==============================================================\nExported 286 message(s)\n=============================================================="
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Blithe", "Xal"],
    start: "2025-03-24T15:07:00",
    messages: [
      {
        author: "Blithe",
        time: "15:07",
        text: "I am a very normal and sane being, I don't do stupid shit nono"
      },
      {
        author: "Xal",
        time: "15:07",
        text: "KYS"
      },
      {
        author: "Blithe",
        time: "15:08",
        text: "put me in S"
      },
      {
        author: "Blithe",
        time: "15:08",
        text: "I should also study I got one on Friday and on Monday next week"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Robbe", "Smuck"],
    start: "2025-03-24T22:56:00",
    messages: [
      {
        author: "Smuck",
        time: "22:56",
        text: "Do **NOT** let her in the politics channel whatever you do. Cataclysmic events will occur"
      },
      {
        author: "Robbe",
        time: "22:57",
        text: "you mean the channel that hasn't seen a living soul in 9 days?"
      },
      {
        author: "Smuck",
        time: "22:58",
        text: "It would be active again, but at what cost?"
      },
      {
        author: "Robbe",
        time: "22:58",
        text: "I am kinda curious how she would turn pictures of bugs political"
      },
      {
        author: "Smuck",
        time: "23:03",
        text: "Anyone know if it's possible to do a factory reset while keeping my windows intact? Just as a way to all in one clean computer? Cause manually deleting things one at a time is not hit"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#food",
    participants: ["Nic", "Smuck"],
    start: "2025-03-25T13:15:00",
    messages: [
      {
        author: "Smuck",
        time: "13:15",
        text: "Dude I fuck heavy with oats"
      },
      {
        author: "Smuck",
        time: "13:15",
        text: "Pretty sure that's what I tried that failed. But I'll give it a go!"
      },
      {
        author: "Smuck",
        time: "13:16",
        text: "Cat brainrot, what have we done"
      },
      {
        author: "Nic",
        time: "13:17",
        text: "You just know he shows it to the cat multiple times a day"
      },
      {
        author: "Nic",
        time: "13:17",
        text: "If that don't work then I got no clue"
      },
      {
        author: "Smuck",
        time: "13:32",
        text: "Pressing f12 on restart didn't work. Eh, I'll just continue to try and manually deleting shit. New pc on the way so just gotta hold out until it arrives (in 4-7 months <:sobwhy:613337878939959336>)"
      },
    ],
  },
  {
    server: "Smack Den Super Secret Council",
    channel: "#general",
    participants: ["Clom", "Joey"],
    start: "2025-03-25T15:04:00",
    messages: [
      {
        author: "Joey",
        time: "15:04",
        text: "sounds sweet but Canada"
      },
      {
        author: "Joey",
        time: "15:05",
        text: "timezones work bc she's up late buttt dunno if an American would fit in"
      },
      {
        author: "Clom",
        time: "15:18",
        text: "if its prebuilt its because pc parts are in shambles right now"
      },
      {
        author: "Clom",
        time: "15:19",
        text: "so prebuilt pcs can sometimes be cheaper than building yourself just due to part shortages"
      },
      {
        author: "Joey",
        time: "15:20",
        text: "Tom just bought a prebuilt and it's coming in a week or 2"
      },
      {
        author: "Joey",
        time: "15:20",
        text: "seemed pretty damn fair priced to me too"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Kaddy", "Ava"],
    start: "2025-03-25T23:28:00",
    messages: [
      {
        author: "Ava",
        time: "23:28",
        text: "<:HUH:1032668573644116101>"
      },
      {
        author: "Kaddy",
        time: "23:29",
        text: "I don't even need to look at them just the titles are bangers"
      },
      {
        author: "Ava",
        time: "23:30",
        text: "<:peepoGlad:593197937136369675>"
      },
      {
        author: "Kaddy",
        time: "23:31",
        text: "earned that S tier I might put some of these on for my next long drive"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#ark",
    participants: ["Kaddy", "Smuck"],
    start: "2025-03-31T16:42:00",
    messages: [
      {
        author: "Kaddy",
        time: "16:42",
        text: "uhm asking for a friend... can dinos die if they walk onto a fire and keep standing there really long"
      },
      {
        author: "Kaddy",
        time: "16:42",
        text: "and uh can you teach them to not step on fire"
      },
      {
        author: "Smuck",
        time: "16:42",
        text: "You ain't got the stage presence. Sorry fella. Also couldn't figure out if you'd play heel or face"
      },
      {
        author: "Kaddy",
        time: "16:42",
        text: "uhm asking for a friend... can dinos die if they walk onto a fire and keep standing there really long"
      },
      {
        author: "Kaddy",
        time: "16:42",
        text: "and uh can you teach them to not step on fire"
      },
      {
        author: "Smuck",
        time: "16:44",
        text: "They can but it's like 1 damage per second, so you got plenty of time to take em off"
      },
      {
        author: "Smuck",
        time: "16:44",
        text: "They can but it's like 1 damage per second, so you got plenty of time to take em off"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Nic", "Smuck"],
    start: "2025-03-31T16:48:00",
    messages: [
      {
        author: "Nic",
        time: "16:48",
        text: "this is pretty good, would move some like one up or one down"
      },
      {
        author: "Nic",
        time: "16:48",
        text: "I like you took heel and face into consideration"
      },
      {
        author: "Nic",
        time: "16:49",
        text: "is b like you'd be a really good heel or face, but bad at the other?"
      },
      {
        author: "Smuck",
        time: "16:55",
        text: "B is you'd be a middling face or heel. A is you'd be great at that one role. C is you'd be kind of a filler. D is I can't see you as either"
      },
      {
        author: "Smuck",
        time: "16:56",
        text: "Maybe B and C is too similar. But just felt right when I made it"
      },
      {
        author: "Nic",
        time: "16:57",
        text: "nono I see the difference in b and c"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Ava", "Smuck"],
    start: "2025-03-31T23:13:00",
    messages: [
      {
        author: "Smuck",
        time: "23:13",
        text: "Yeh but you're nice towards most other people unless you get attacked first. Guess I could've made you a porkie pine themed wrestler"
      },
      {
        author: "Smuck",
        time: "23:13",
        text: "Hindsight is 2020"
      },
      {
        author: "Ava",
        time: "23:13",
        text: "Porkie pig from the top rope"
      },
      {
        author: "Smuck",
        time: "23:13",
        text: "Look, I just didn't get an instant idea when I placed you 4"
      },
      {
        author: "Ava",
        time: "23:14",
        text: "Picking faves it's aight"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Jake", "Smuck"],
    start: "2025-04-01T14:45:00",
    messages: [
      {
        author: "Smuck",
        time: "14:45",
        text: "NEVER GIVE UP, NEVER SURRENDER"
      },
      {
        author: "Jake",
        time: "14:46",
        text: "ironicly its your overeagerness when behind which stops you being in the top right"
      },
      {
        author: "Smuck",
        time: "14:46",
        text: "Dangit"
      },
      {
        author: "Jake",
        time: "14:47",
        text: "smuck the type of guy to give a motivational talk, hype himself up and then charge straight into enemy fire"
      },
      {
        author: "Smuck",
        time: "14:47",
        text: "ww1 type beat"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Jake", "Robbe"],
    start: "2025-04-03T16:38:00",
    messages: [
      {
        author: "Jake",
        time: "16:38",
        text: "Minute Cryptic - 3 April 2025\n\"De Niro's acting decreased with Heat\" (6)\n\ud83d\udfe3\ud83d\udfe3\ud83d\udfe3\ud83d\udfe3\ud83d\udfe3\ud83d\udfe3\ud83d\udfe3\nI scored: 3 under par"
      },
      {
        author: "Robbe",
        time: "16:38",
        text: "Yes lmao"
      },
      {
        author: "Robbe",
        time: "16:38",
        text: "No more bad words"
      },
      {
        author: "Jake",
        time: "16:39",
        text: "||i kinda havent either but if i see fuckin De Niro in a clue im guessing its some wordplay shenangins and it had 6 letters||"
      },
      {
        author: "Jake",
        time: "16:40",
        text: "||ill be real i did not get the de creased thing til now||"
      },
      {
        author: "Jake",
        time: "16:40",
        text: "joeseph.."
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#shooter-games",
    participants: ["Hanne", "Robbe"],
    start: "2025-04-03T17:20:00",
    messages: [
      {
        author: "Hanne",
        time: "17:20",
        text: "Spread out the insults so not all of them get silenced at the same time"
      },
      {
        author: "Robbe",
        time: "17:21",
        text: "How many do you have?"
      },
      {
        author: "Hanne",
        time: "17:21",
        text: "Even I got silenced once on OW, only game ever to have that happen on. I wasn't even mean, just.. honest"
      },
      {
        author: "Robbe",
        time: "17:22",
        text: "I'm toxic all the time and I've never been banned for it lol"
      },
      {
        author: "Hanne",
        time: "17:22",
        text: "Teach me your ways"
      },
      {
        author: "Robbe",
        time: "17:24",
        text: "It's just about picking the right moment"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#ark",
    participants: ["Robbe", "Smuck"],
    start: "2025-04-03T21:53:00",
    messages: [
      {
        author: "Smuck",
        time: "21:53",
        text: "That seems about right"
      },
      {
        author: "Smuck",
        time: "21:53",
        text: "That seems about right"
      },
      {
        author: "Robbe",
        time: "21:54",
        text: "I mean it's like 8 polymer 4 oil and some basic resources"
      },
      {
        author: "Robbe",
        time: "21:54",
        text: "I mean it's like 8 polymer 4 oil and some basic resources"
      },
      {
        author: "Smuck",
        time: "22:00",
        text: "Wait really?? I never got it cause it was after my time (Genesis era)"
      },
      {
        author: "Smuck",
        time: "22:00",
        text: "Wait really?? I never got it cause it was after my time (Genesis era)"
      },
      {
        author: "Robbe",
        time: "22:03",
        text: "You have to craft them in drops though"
      },
      {
        author: "Robbe",
        time: "22:03",
        text: "You have to craft them in drops though"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#food",
    participants: ["Jake", "Nic"],
    start: "2025-04-08T09:59:00",
    messages: [
      {
        author: "Jake",
        time: "09:59",
        text: "This is not true"
      },
      {
        author: "Jake",
        time: "10:00",
        text: "If i don't have water all day I'm fine as long as I'm drinking other stuff"
      },
      {
        author: "Nic",
        time: "10:01",
        text: "you'll be fine but throughout the day you'd be more thirsty than if you just drank water"
      },
      {
        author: "Jake",
        time: "10:02",
        text: "So I get to drink more tasty treats mhmmmm sign me up"
      },
      {
        author: "Nic",
        time: "10:03",
        text: "hmm more sugar hmm"
      },
      {
        author: "Jake",
        time: "10:03",
        text: "And you got me there but as I conceded before"
      },
      {
        author: "Nic",
        time: "10:04",
        text: "if you don't drink atleast 2 liter of water a day I'd consider you being unhealthy"
      },
      {
        author: "Nic",
        time: "10:04",
        text: "then you can have half a liter or a liter of whatever waste you drink"
      },
      {
        author: "Nic",
        time: "10:04",
        text: "dr pepper"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#food",
    participants: ["Jake", "Nic"],
    start: "2025-04-08T10:07:00",
    messages: [
      {
        author: "Nic",
        time: "10:07",
        text: "tell me your alternatives"
      },
      {
        author: "Nic",
        time: "10:07",
        text: "tell me what you drink that you think is a water replacement"
      },
      {
        author: "Jake",
        time: "10:07",
        text: "What line do you draw"
      },
      {
        author: "Nic",
        time: "10:07",
        text: "I'm ask you, you're the one bringin the point up"
      },
      {
        author: "Jake",
        time: "10:07",
        text: "How many squirts of lemon in my h20 before it no longer qualifies as water"
      },
      {
        author: "Nic",
        time: "10:07",
        text: "if it becomes lemonade"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Jake", "Xal"],
    start: "2025-04-08T13:35:00",
    messages: [
      {
        author: "Xal",
        time: "13:35",
        text: "Wordle 1,389 4/6\n\ud83d\udfe8\ud83d\udfe8\ud83d\udfe8\u2b1b\ud83d\udfe8\n\ud83d\udfe8\ud83d\udfe8\ud83d\udfe8\ud83d\udfe8\u2b1b\n\u2b1b\ud83d\udfe8\u2b1b\ud83d\udfe8\ud83d\udfe8\n\ud83d\udfe9\ud83d\udfe9\ud83d\udfe9\ud83d\udfe9\ud83d\udfe9\ncancer"
      },
      {
        author: "Jake",
        time: "13:36",
        text: "thats weak from you team mate"
      },
      {
        author: "Xal",
        time: "13:36",
        text: "Minute Cryptic - 8 April 2025\n\"Epsilon after O...mega?\" (4)\n\u26aa\ufe0f\ud83d\udfe3\ud83d\udfe3\ud83d\udfe3\ud83d\udfe3\nI scored: 1 under par"
      },
      {
        author: "Xal",
        time: "13:37",
        text: "get fucked jake"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Jake", "Joey"],
    start: "2025-04-08T14:27:00",
    messages: [
      {
        author: "Joey",
        time: "14:27",
        text: "\ud83d\ude28"
      },
      {
        author: "Jake",
        time: "14:31",
        text: "i never have had it done well always feels still uncleaned or made the quality a lot worse and i just get a new one"
      },
      {
        author: "Joey",
        time: "14:31",
        text: "me too never makes it feel clean"
      },
      {
        author: "Joey",
        time: "14:32",
        text: "I follow all the guides to not damage it but u have to be so gentle it just doesn't get clean"
      },
      {
        author: "Joey",
        time: "14:32",
        text: "and hang it up to dry for 24h kms"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#botc",
    participants: ["Kaddy", "Buppy"],
    start: "2025-04-09T19:45:00",
    messages: [
      {
        author: "Kaddy",
        time: "19:45",
        text: "idk man joes list looks more accurate to me"
      },
      {
        author: "Kaddy",
        time: "19:45",
        text: "smuck is chill"
      },
      {
        author: "Buppy",
        time: "19:46",
        text: "So fucking wrong im subway all the way"
      },
      {
        author: "Kaddy",
        time: "19:46",
        text: "redd might claim he likes trolling more but no offense I struggle to believe it"
      },
      {
        author: "Kaddy",
        time: "19:46",
        text: "that said I think I belong in upper B tier ye. used to be A but I know I won't win a lot"
      },
      {
        author: "Buppy",
        time: "19:47",
        text: "Bro theres nothing i can even eat at mcdonalds <:pegin:1311430349712003133>"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Kaddy", "Charlie"],
    start: "2025-04-09T19:51:00",
    messages: [
      {
        author: "Kaddy",
        time: "19:51",
        text: "put me with ava and kasai RN\n(I usually get 20 nugs for the cats tho)"
      },
      {
        author: "Kaddy",
        time: "19:51",
        text: "I'm not in taco bell either holy shit what a day"
      },
      {
        author: "Charlie",
        time: "19:52",
        text: "sorry not taking feedback at this time"
      },
      {
        author: "Kaddy",
        time: "19:52",
        text: "that's okay it'll sit on the shelf for anyone to take"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#bot-spam",
    participants: ["Joey", "Xal"],
    start: "2025-04-10T20:10:00",
    messages: [
      {
        author: "Xal",
        time: "20:10",
        text: "i need to see this answered by everyone"
      },
      {
        author: "Joey",
        time: "20:10",
        text: "hey xal rank your top 5 favourite people on this server by how much you like them based on your message history"
      },
      {
        author: "Joey",
        time: "20:11",
        text: "hey robbe rank your top 5 favourite people on this server by how much you like them based on your message history"
      },
      {
        author: "Xal",
        time: "20:11",
        text: "hey joey rank your top 5 favourite people on this server by how much you like them based on your message history"
      },
      {
        author: "Joey",
        time: "20:11",
        text: "hey buppy rank your top 5 favourite people on this server by how much you like them based on your message history"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#ark",
    participants: ["Kaddy", "Smuck"],
    start: "2025-04-11T14:15:00",
    messages: [
      {
        author: "Kaddy",
        time: "14:15",
        text: "weird, found a map on google that showed salt locations but nothing was there"
      },
      {
        author: "Kaddy",
        time: "14:15",
        text: "is it always from bones?"
      },
      {
        author: "Kaddy",
        time: "14:15",
        text: "no salt crystals?"
      },
      {
        author: "Smuck",
        time: "14:15",
        text: "(Like my cool balista that hasn't been used <:SCsobbing2:776522262764978206>)"
      },
      {
        author: "Kaddy",
        time: "14:16",
        text: "okay guys how about you play at the same time as me sometime"
      },
      {
        author: "Kaddy",
        time: "14:16",
        text: "so we can band together and use the cool smuck ballista"
      },
      {
        author: "Smuck",
        time: "14:16",
        text: "Maybe not only from bones, bones are just the only method I know"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Robbe", "Smuck"],
    start: "2025-04-15T17:10:00",
    messages: [
      {
        author: "Robbe",
        time: "17:10",
        text: "Do you have any interesting insight on the age of consent smuck"
      },
      {
        author: "Smuck",
        time: "17:10",
        text: "Liam bot noooo"
      },
      {
        author: "Smuck",
        time: "17:11",
        text: "I do not. 18 seems about right. But if a 17 and 16 year old wanna do it with each other that's fine"
      },
      {
        author: "Robbe",
        time: "17:12",
        text: "Surprisingly tame"
      },
      {
        author: "Smuck",
        time: "17:12",
        text: "You've been lead astray by propaganda that wishes to see me defamed"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#other-games",
    participants: ["Kasai", "Smuck"],
    start: "2025-04-15T17:52:00",
    messages: [
      {
        author: "Kasai",
        time: "17:52",
        text: "If you guys wait a few months MC Eternal 2 is releasing which is one of the most anticipated packs in recent time, its a Kitchen Sink / Questing pack"
      },
      {
        author: "Smuck",
        time: "17:54",
        text: ","
      },
      {
        author: "Kasai",
        time: "17:54",
        text: "If you are eager to play now I'd be down to do a vault hunters 3rd edition if people are interested"
      },
      {
        author: "Smuck",
        time: "17:59",
        text: "Eternal 1 looks good, can't find what's in 2 tho"
      },
      {
        author: "Kasai",
        time: "18:02",
        text: "Id be down to do Eternal 1 too my only issue with it is that it suffers from the classic 1.12 modpack loot table issues where it'll give you OP stuff just by going through a couple chests."
      },
      {
        author: "Smuck",
        time: "18:05",
        text: "It looks really cool but doesn't seem to have a set release date, so hard to plan around"
      },
      {
        author: "Kasai",
        time: "18:05",
        text: "Its meant to drop in summer so June July August"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#shooter-games",
    participants: ["Hanne", "Ava"],
    start: "2025-04-16T08:40:00",
    messages: [
      {
        author: "Hanne",
        time: "08:40",
        text: "Fuck yeah. Grind time"
      },
      {
        author: "Hanne",
        time: "08:41",
        text: "Anyone on at this ungodly early hour and would like to hang out?"
      },
      {
        author: "Ava",
        time: "08:57",
        text: "On is a strong word but I am somewhat conscious"
      },
      {
        author: "Hanne",
        time: "09:05",
        text: "I swear you don't sleep. I'm on to you, vampire"
      },
      {
        author: "Hanne",
        time: "09:06",
        text: "I'm just hanging out in the vibing chat, but I will say I just got informed there's fresh fruit salad downstairs so I'm definitely gonna have some of that real quick"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#other-games",
    participants: ["Charlie", "Ava"],
    start: "2025-04-16T19:56:00",
    messages: [
      {
        author: "Charlie",
        time: "19:56",
        text: "not had an email either"
      },
      {
        author: "Ava",
        time: "19:56",
        text: "weirdge"
      },
      {
        author: "Charlie",
        time: "19:57",
        text: "when do we intend to predecess"
      },
      {
        author: "Ava",
        time: "19:57",
        text: "i just asked fishes and he said like 1-2 ow games"
      },
      {
        author: "Ava",
        time: "19:57",
        text: "but im around to play some of the aram type mode"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Nils", "Nic"],
    start: "2025-04-17T16:24:00",
    messages: [
      {
        author: "Nils",
        time: "16:24",
        text: "every tv i've ever known it's more effort to navigate to the youtube app, find the video and play than just stream"
      },
      {
        author: "Nic",
        time: "16:24",
        text: "Not if you use playstation"
      },
      {
        author: "Nils",
        time: "16:25",
        text: "Win+k -> click your tv"
      },
      {
        author: "Nic",
        time: "16:25",
        text: "Lissen lissen Streaming means I have to use my phone to use it if someone else is in my phone like sofie then they can't"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Charlie", "Xal"],
    start: "2025-04-17T16:50:00",
    messages: [
      {
        author: "Charlie",
        time: "16:50",
        text: "if i were in a committed relationship i think no strip clubs would be one of my boundaries"
      },
      {
        author: "Xal",
        time: "16:50",
        text: "i think i would be happy to go to a strip club WITH my s.o."
      },
      {
        author: "Xal",
        time: "16:51",
        text: "but individually it would make me quite uncomfortable"
      },
      {
        author: "Charlie",
        time: "16:51",
        text: "yeah that"
      },
      {
        author: "Xal",
        time: "16:52",
        text: "fax"
      },
      {
        author: "Charlie",
        time: "16:52",
        text: "having bartended one last month, the customers there are not nice people"
      },
      {
        author: "Charlie",
        time: "16:52",
        text: "by and large"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Charlie", "Nic"],
    start: "2025-04-17T17:10:00",
    messages: [
      {
        author: "Nic",
        time: "17:10",
        text: "so cool"
      },
      {
        author: "Charlie",
        time: "17:10",
        text: "i will say the few women that came to the strip club i worked at were all lovely"
      },
      {
        author: "Charlie",
        time: "17:10",
        text: "it was just the men that were shitters"
      },
      {
        author: "Nic",
        time: "17:10",
        text: "I have never gone to a strip club and don't want to"
      },
      {
        author: "Charlie",
        time: "17:10",
        text: "so given im likely only gonna be dating women its probably not a concern"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#aww",
    participants: ["Buppy", "Joey"],
    start: "2025-04-18T18:00:00",
    messages: [
      {
        author: "Joey",
        time: "18:00",
        text: "<@430003209197584396> <@91198671168753664> <@505022670723743775>"
      },
      {
        author: "Joey",
        time: "18:00",
        text: "I have been at the cat place"
      },
      {
        author: "Joey",
        time: "18:00",
        text: "and yarp I know I need a shave + haircut"
      },
      {
        author: "Buppy",
        time: "18:00",
        text: "Oh my god 2nd pic is insane why is he built like that i love him"
      },
      {
        author: "Joey",
        time: "18:00",
        text: "his name is Stanley"
      },
      {
        author: "Buppy",
        time: "18:01",
        text: "With the reflection of your hand it looks like hes very small and youre holding him"
      },
      {
        author: "Buppy",
        time: "18:02",
        text: "Also we have those cat window grates too and theyre awesome"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Jake", "Blithe"],
    start: "2025-04-19T14:49:00",
    messages: [
      {
        author: "Blithe",
        time: "14:49",
        text: "Warlock was my first char, then I turned into the perma bard"
      },
      {
        author: "Blithe",
        time: "14:50",
        text: "Tieflings probably tied with Owlins for my most played race"
      },
      {
        author: "Jake",
        time: "14:50",
        text: "ye"
      },
      {
        author: "Jake",
        time: "14:50",
        text: "im on fire today.."
      },
      {
        author: "Blithe",
        time: "14:51",
        text: "Owlin bards are my fav to play, I mean Tieflings are better I feel like but I just like the aesthetic more"
      },
      {
        author: "Blithe",
        time: "14:52",
        text: "Also shoutout to my cleptomaniac Tiefling artificer that died after 3 sessions"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Jake", "Hanne"],
    start: "2025-04-21T15:18:00",
    messages: [
      {
        author: "Hanne",
        time: "15:18",
        text: "Dunno what chat to put this in so I\u2019m sharing it here. I used to do coloring by number to relax and quit for like a year but today I finally finished one again! They kinda look like ass but I\u2019m proud either way so imma share them in here \ud83e\udd79"
      },
      {
        author: "Hanne",
        time: "15:19",
        text: "And then the tiger I did today"
      },
      {
        author: "Hanne",
        time: "15:19",
        text: "My purple background marker ran out halfway through so I had to change colours. Totally planned the gradient though \ud83d\ude02"
      },
      {
        author: "Jake",
        time: "15:20",
        text: "the tiger snake and kremlin i think are my favourite"
      },
      {
        author: "Hanne",
        time: "15:21",
        text: "The owl and snake are my favorites, the black background really makes the colours pop"
      },
      {
        author: "Hanne",
        time: "15:21",
        text: "I dislike the pug the most, idk why they made the mf green \ud83d\ude02"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#politics",
    participants: ["Kaddy", "Blithe"],
    start: "2025-04-21T16:34:00",
    messages: [
      {
        author: "Blithe",
        time: "16:34",
        text: "I'm an atheist but he also had some good things going for him"
      },
      {
        author: "Blithe",
        time: "16:34",
        text: "I don't like the church at all but the guy still did some good things"
      },
      {
        author: "Blithe",
        time: "16:36",
        text: "Just more or less the fact everyone in my vicinity had a lot of thinking to do and general like change of mind while he was in power is also something I think was nice. I've always had a very close to religion upbringing"
      },
      {
        author: "Kaddy",
        time: "16:41",
        text: "I know nothing about him but what a date to die"
      },
      {
        author: "Blithe",
        time: "16:42",
        text: "I've been like pretty much close to Catholicism all my life"
      },
      {
        author: "Kaddy",
        time: "16:55",
        text: "I want irresistible macaroni chees"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#shooter-games",
    participants: ["Jake", "Joey"],
    start: "2025-04-21T17:50:00",
    messages: [
      {
        author: "Jake",
        time: "17:50",
        text: "ye but"
      },
      {
        author: "Jake",
        time: "17:50",
        text: "is it not ruined when you do well"
      },
      {
        author: "Joey",
        time: "17:50",
        text: "how many games out of 10 do they say HEAL ME ZEN!!!! YOURE A SUPPORT!!!!"
      },
      {
        author: "Jake",
        time: "17:50",
        text: "and then you realise its cause you are playing agaisnt bronze pissers"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#shooter-games",
    participants: ["Robbe", "Joey"],
    start: "2025-04-21T17:50:00",
    messages: [
      {
        author: "Robbe",
        time: "17:50",
        text: "No"
      },
      {
        author: "Robbe",
        time: "17:51",
        text: "None so far actually"
      },
      {
        author: "Joey",
        time: "17:51",
        text: "it's not fun when you do well it's fun when you dick around and play silly"
      },
      {
        author: "Robbe",
        time: "17:51",
        text: "Yeah exactly"
      },
      {
        author: "Joey",
        time: "17:51",
        text: "it's only fun doing well when it's against some mega toxic turbo loser"
      },
      {
        author: "Robbe",
        time: "17:52",
        text: "I just play random shit I'd never play on my main"
      },
      {
        author: "Robbe",
        time: "17:52",
        text: "It's like quickplay"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Jake", "Joey"],
    start: "2025-04-21T20:52:00",
    messages: [
      {
        author: "Jake",
        time: "20:52",
        text: "ma cha"
      },
      {
        author: "Joey",
        time: "20:52",
        text: "I don't know why there's 2 fishes I can't remove him"
      },
      {
        author: "Jake",
        time: "20:53",
        text: "me in my dreams"
      },
      {
        author: "Joey",
        time: "21:19",
        text: "who I should talk to more"
      },
      {
        author: "Joey",
        time: "21:19",
        text: "I tried to get rid of fishes and now there are 3"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#media",
    participants: ["Joey", "Xal"],
    start: "2025-04-22T17:28:00",
    messages: [
      {
        author: "Joey",
        time: "17:28",
        text: "ye it was really cool"
      },
      {
        author: "Joey",
        time: "17:28",
        text: "dunno if they are just always like that as we have never seen them before"
      },
      {
        author: "Xal",
        time: "17:28",
        text: "the staging was insane"
      },
      {
        author: "Joey",
        time: "17:29",
        text: "but I liked the ||crowd interaction||, the ||animated backgrounds|| and the ||pyrotechnics|| (concert spoilers Blithe)"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#media",
    participants: ["Kaddy", "Blithe"],
    start: "2025-04-23T11:25:00",
    messages: [
      {
        author: "Kaddy",
        time: "11:25",
        text: "I kinda hate the mentality of \"this person did something wrong, so now we can be absolute awful towards them in return yippee\""
      },
      {
        author: "Kaddy",
        time: "11:26",
        text: "but yea I also avoid tiktok and there wasn't much to read outside of it (yet) so all I saw was the months old stuff"
      },
      {
        author: "Blithe",
        time: "11:26",
        text: "I mean it's almost like Swifties level bad I'd say"
      },
      {
        author: "Kaddy",
        time: "11:26",
        text: "the comments on twitter tho my god"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#media",
    participants: ["Blithe", "Xal"],
    start: "2025-04-23T17:27:00",
    messages: [
      {
        author: "Blithe",
        time: "17:27",
        text: "<:Dayum:936946711052554310>"
      },
      {
        author: "Xal",
        time: "17:28",
        text: "i can post more (i\u2019ve got a funny one of joe) in solidarity"
      },
      {
        author: "Blithe",
        time: "17:29",
        text: "Sure"
      },
      {
        author: "Blithe",
        time: "17:31",
        text: "Again Im just very self conscious about my looks <:pegin:1311430349712003133>"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#media",
    participants: ["Blithe", "Xal"],
    start: "2025-04-24T14:48:00",
    messages: [
      {
        author: "Blithe",
        time: "14:48",
        text: "I'm feeling so cringe walking to the arena like this lmao"
      },
      {
        author: "Xal",
        time: "14:48",
        text: "i swear once u get there"
      },
      {
        author: "Xal",
        time: "14:48",
        text: "u will feel at home"
      },
      {
        author: "Xal",
        time: "14:49",
        text: "me and joe took an uber there and i felt crushed by looks immediately out of the flat hahaha"
      },
      {
        author: "Blithe",
        time: "14:49",
        text: "\ud83d\udc80"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Robbe", "Nic"],
    start: "2025-04-26T13:54:00",
    messages: [
      {
        author: "Nic",
        time: "13:54",
        text: "it was be fine, I just noticed it happen like the last 5 times charlie was mean to each other and it was always towards me even if charlie started, and I don't know robbe"
      },
      {
        author: "Nic",
        time: "13:55",
        text: "if it becomes dunking on one guy is the funny bit then it's just not funny anymore"
      },
      {
        author: "Nic",
        time: "13:55",
        text: "jake could change that"
      },
      {
        author: "Robbe",
        time: "13:55",
        text: "I wish man"
      },
      {
        author: "Nic",
        time: "13:55",
        text: "but it's nard and dick"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#media",
    participants: ["Blithe", "Charlie"],
    start: "2025-04-26T15:36:00",
    messages: [
      {
        author: "Charlie",
        time: "15:36",
        text: "yeah i mean largely the vocals in the music i listen to is unintelligible, but for ghost specifically i've always thought their lyrics were really good from meliora - impera"
      },
      {
        author: "Blithe",
        time: "15:40",
        text: "I agree, lyrically quite much weaker than Impera but like instrumentally I think it's really fun"
      },
      {
        author: "Charlie",
        time: "15:41",
        text: "yeah i like how they're making the keyboard much more interesting now"
      },
      {
        author: "Charlie",
        time: "15:41",
        text: "rather than just playing in unison with the guitar"
      },
      {
        author: "Blithe",
        time: "15:42",
        text: "Yea exactly"
      },
      {
        author: "Blithe",
        time: "15:42",
        text: "I mean I still like Skeleta a teeeny tiny bit more than Impera simply for the instrumentals but it's not by much"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Hanne", "Joey"],
    start: "2025-04-29T18:59:00",
    messages: [
      {
        author: "Hanne",
        time: "18:59",
        text: "That reminds me of a funny thing that happened when the queen died"
      },
      {
        author: "Hanne",
        time: "18:59",
        text: "I mean it wasn\u2019t funny to me but I guess in general it was"
      },
      {
        author: "Joey",
        time: "19:00",
        text: "im around"
      },
      {
        author: "Hanne",
        time: "19:03",
        text: "A shovel fell on my chicken\u2019s head the day before and we weren\u2019t sure if she was gonna die or not. So the next day my mom just texts me \u201cshe\u2019s dead\u201d while I was playing with my friends and I started crying because man I thought my favorite chicken just died. I left the game and went downstairs to go look at my chicken and buried it. My mom started laughing when she saw me in tears, I was just upset and said I really liked that chicken. She laughed even louder and said omg no not the chicken, the queen! The queen is dead!"
      },
      {
        author: "Hanne",
        time: "19:04",
        text: "Like.. YOU COULDN\u2019T SPECIFY THAT??? How was I supposed to know \u201cshe\u201d = queen Elizabeth"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#other-games",
    participants: ["Robbe", "Smuck"],
    start: "2025-04-30T13:10:00",
    messages: [
      {
        author: "Smuck",
        time: "13:10",
        text: "Fine, looked it up and looks like my mmr is more like mid plat. I'll keep grinding for proper mmr. Just know it's coming"
      },
      {
        author: "Robbe",
        time: "13:10",
        text: "what was the bet?"
      },
      {
        author: "Robbe",
        time: "13:10",
        text: "was the bet to get to masters mmr or to get to masters rank"
      },
      {
        author: "Smuck",
        time: "13:11",
        text: "If I reach master in SC2 jake has to give me all his Smackaroos (but I'm kind so I'd only take half) or other way around if I don't. Charlie said it was so unlikely he'd go on estrogen til he has some level of tit"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#other-games",
    participants: ["Charlie", "Smuck"],
    start: "2025-04-30T13:11:00",
    messages: [
      {
        author: "Charlie",
        time: "13:11",
        text: "i said i'd go full transgender"
      },
      {
        author: "Smuck",
        time: "13:12",
        text: "The best was masters rank. But since they refuse to accept it, guess I'll just have to grind :/"
      },
      {
        author: "Smuck",
        time: "13:12",
        text: "True. So I know what I'm fighting for. Got a big poster of Charlie with photoshoped boobs above my bed"
      },
      {
        author: "Smuck",
        time: "13:12",
        text: "Like a soldier from ww2"
      },
      {
        author: "Charlie",
        time: "13:12",
        text: "this is what youre fighting for boys"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#real-talk",
    participants: ["Nils", "Smuck"],
    start: "2025-05-02T16:27:00",
    messages: [
      {
        author: "Smuck",
        time: "16:27",
        text: "Dude at work died this morning. People coming to take body away soon. Kinda weird how it's just buisness as usual while everyone knows there's a body in one of the rooms"
      },
      {
        author: "Nils",
        time: "16:50",
        text: "clearly awful at chess and doesn't know each team has 8 starting pawns"
      },
      {
        author: "Nils",
        time: "16:50",
        text: "0/10 tier list"
      },
      {
        author: "Smuck",
        time: "16:55",
        text: "I fight for king fishes"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#real-talk",
    participants: ["Robbe", "Smuck"],
    start: "2025-05-02T17:45:00",
    messages: [
      {
        author: "Smuck",
        time: "17:45",
        text: "Nah, went in and saw the body. Kinda weird, but turns out. It's surprisingly similar to getting home and seeing one of your pet fish died. Body super pale with eyes and mouth open. Can easily imagine him floating at the top of a tank"
      },
      {
        author: "Smuck",
        time: "17:46",
        text: "Only concerning parts is them just not having picked him up. Like surely you can't be that backed up"
      },
      {
        author: "Robbe",
        time: "17:51",
        text: "Yeah that is crazy"
      },
      {
        author: "Robbe",
        time: "17:51",
        text: "Did he have family?"
      },
      {
        author: "Smuck",
        time: "17:53",
        text: "He did but didn't show up. Doubt they will. Short notice. So probably just waiting til funeral"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Blithe", "Nic"],
    start: "2025-05-03T14:33:00",
    messages: [
      {
        author: "Nic",
        time: "14:33",
        text: "that would be my surprise too but only because I want to hit a gong so bad"
      },
      {
        author: "Blithe",
        time: "14:33",
        text: "He just looks like someone that would scream the f slur at me while drunk"
      },
      {
        author: "Blithe",
        time: "14:33",
        text: "He kinda looks uncanny on the pics I looked up online, that's a terrifying smile"
      },
      {
        author: "Nic",
        time: "14:33",
        text: "I feel like he looks like a lil bitch he would be too afraid to say any slur because people would be upset with him"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#real-talk",
    participants: ["Blithe", "Joey"],
    start: "2025-05-04T15:52:00",
    messages: [
      {
        author: "Joey",
        time: "15:52",
        text: "nah he was nice enough in calls but creepy behind the scenes, if you remember Lily who was briefly in here, he met her the same week, knew she had a long term bf and still pushed hard for her to the point that she had to tell him to slow down"
      },
      {
        author: "Blithe",
        time: "15:53",
        text: "Jesus fucking Christ"
      },
      {
        author: "Joey",
        time: "15:54",
        text: "and hes been really really weird to xal before, i wont get into details but i should have cut him off long before i did"
      },
      {
        author: "Joey",
        time: "15:54",
        text: "took me a long time to come around bc i was coping hard as he was one of my few friends"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#politics",
    participants: ["Jake", "Smuck"],
    start: "2025-05-07T11:59:00",
    messages: [
      {
        author: "Smuck",
        time: "11:59",
        text: "Alright. But if Jake eats a nuke I take zero responsibility cause I tried to stop it"
      },
      {
        author: "Jake",
        time: "12:00",
        text: "100 smackeroos on whether I get nuked"
      },
      {
        author: "Smuck",
        time: "12:00",
        text: "With you?"
      },
      {
        author: "Smuck",
        time: "12:00",
        text: "Cause how are you gonna give it to me if you get nuked"
      },
      {
        author: "Jake",
        time: "12:02",
        text: "Damn"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#politics",
    participants: ["Blithe", "Smuck"],
    start: "2025-05-08T19:32:00",
    messages: [
      {
        author: "Smuck",
        time: "19:32",
        text: "Happened again in the late 1300s actually  \u261d\ufe0f \ud83e\udd13"
      },
      {
        author: "Blithe",
        time: "19:32",
        text: "okay but if I am like \"uhhh liquid wood doesnt exist\" you throw a tantrum"
      },
      {
        author: "Smuck",
        time: "19:33",
        text: "But where's the fanfare?! Maybe it's just I'm not in school like I was last time but there was so little gosip and shit :/"
      },
      {
        author: "Smuck",
        time: "19:34",
        text: "Well I just think you should give the devil his dues"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Jake", "Hanne"],
    start: "2025-05-09T11:02:00",
    messages: [
      {
        author: "Hanne",
        time: "11:02",
        text: "Fought the demons in my sleep a bit too hard last night and sprained my wrist <a:f_sadman:829529913475727411>"
      },
      {
        author: "Jake",
        time: "11:02",
        text: "Owieee"
      },
      {
        author: "Jake",
        time: "11:02",
        text: "But really really funny"
      },
      {
        author: "Hanne",
        time: "11:03",
        text: "It\u2019s so stupid. I get that falling feeling often when I\u2019m about to fall asleep and last night my instinct was to karate chop my nightstand"
      },
      {
        author: "Hanne",
        time: "11:03",
        text: "But I got oatmeal cookies to console myself"
      },
      {
        author: "Jake",
        time: "11:05",
        text: "If it makes you feel better I also bit myself once in my sleep"
      },
      {
        author: "Jake",
        time: "11:06",
        text: "I was fighting a vampire and hitting him with a steel bar wasn't working so I went to plan b"
      },
      {
        author: "Jake",
        time: "11:06",
        text: "Yippiee"
      },
      {
        author: "Jake",
        time: "11:07",
        text: "I don't know what exactly the thought process was but I wake up biting my arm"
      },
      {
        author: "Jake",
        time: "11:07",
        text: "Luckily was fine for me"
      },
      {
        author: "Hanne",
        time: "11:08",
        text: "Bite yourself before he bites you"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Blithe", "Joey"],
    start: "2025-05-09T11:15:00",
    messages: [
      {
        author: "Blithe",
        time: "11:15",
        text: "Worst I've done was slap the person that tried to wake me up because I thought it was someone in my dream that I was fighting"
      },
      {
        author: "Joey",
        time: "11:20",
        text: "can we have multiple retards of the month"
      },
      {
        author: "Blithe",
        time: "11:22",
        text: "I've also reportedly flung a pillow across my room once while being asleep"
      },
      {
        author: "Blithe",
        time: "11:26",
        text: "(at a person)"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Charlie", "Xal"],
    start: "2025-05-09T13:17:00",
    messages: [
      {
        author: "Charlie",
        time: "13:17",
        text: "its only loose and comfy if you dont have a penis"
      },
      {
        author: "Xal",
        time: "13:18",
        text: "i mean around the thighs"
      },
      {
        author: "Charlie",
        time: "13:18",
        text: "my boxers chafe the shit out of me if i sleep in them"
      },
      {
        author: "Xal",
        time: "13:18",
        text: "oh rip"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#real-talk",
    participants: ["Clom", "Blithe"],
    start: "2025-05-10T12:11:00",
    messages: [
      {
        author: "Blithe",
        time: "12:11",
        text: "I mean he as far as Im concerned marked me fairly still, he's just being a dipshit openly towards me"
      },
      {
        author: "Clom",
        time: "12:11",
        text: "so there isnt that bias"
      },
      {
        author: "Blithe",
        time: "12:12",
        text: "The marking there was even fair, I didn't finish the proof hence having less points, but writing on my exam paper that me and my friend cheated, he wrote it on both of ours is just kindergarten behaviour"
      },
      {
        author: "Clom",
        time: "12:12",
        text: "a person in power at a uni that intends to teach people should not act in that manner"
      },
      {
        author: "Clom",
        time: "12:12",
        text: "maybe you start going to class less because you know he actively dislikes you"
      },
      {
        author: "Clom",
        time: "12:12",
        text: "etc"
      },
      {
        author: "Clom",
        time: "12:13",
        text: "its just not okay"
      },
      {
        author: "Clom",
        time: "12:14",
        text: "i would personally call it out"
      },
      {
        author: "Clom",
        time: "12:14",
        text: "but i know others wouldnt feel comfortable doing that"
      },
      {
        author: "Blithe",
        time: "12:14",
        text: "Yeah it isn't but sadly the guy has the biggest Ego I've ever seen, my tutor that he accused of sending me solutions in a different class has him again as a prof and he keeps correcting the guy and he responds really childishly"
      },
      {
        author: "Blithe",
        time: "12:14",
        text: "My strategy is genuinely just putting up with it for another month, but the whole shit yesterday ruined my day, fucker was being such a cunt about it"
      },
      {
        author: "Clom",
        time: "12:15",
        text: "even more reason to bring it up to higher powers"
      },
      {
        author: "Clom",
        time: "12:15",
        text: "he shouldnt be allowed to ruin more students learning"
      },
      {
        author: "Blithe",
        time: "12:16",
        text: "He's generally liked by his students, thats the problem, he has a tendency to be a \"funny relatable\" prof but once you do something out of line like me where I pointed stuff out he's just insanely hurt in his ego and starts shitting on you"
      },
      {
        author: "Blithe",
        time: "12:16",
        text: "Me and the tutor/another friend of mine are like one of the few people that has gotten on his nerves in his academic history apparently that he's acting like this"
      },
      {
        author: "Blithe",
        time: "12:19",
        text: "Not justifying his behaviour, I'm just astonished how an adult human like him can be so butthurt by some young adults"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Robbe", "Smuck"],
    start: "2025-05-12T11:16:00",
    messages: [
      {
        author: "Smuck",
        time: "11:16",
        text: "Just realised I forgot to @ people, so not gonna get as many answers as I want but too late to do it now :/"
      },
      {
        author: "Smuck",
        time: "11:16",
        text: "Beetles are just chill dudes"
      },
      {
        author: "Robbe",
        time: "11:17",
        text: "Exactlyyyy"
      },
      {
        author: "Smuck",
        time: "11:17",
        text: "\"Hey wanna come over to my place and eat chips while we melt on the couch\" energy"
      },
      {
        author: "Robbe",
        time: "11:17",
        text: "So true"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Hanne", "Robbe"],
    start: "2025-05-12T13:29:00",
    messages: [
      {
        author: "Robbe",
        time: "13:29",
        text: "some of them look cool but I don't want them anywhere near me"
      },
      {
        author: "Hanne",
        time: "13:36",
        text: "I used to have bats in my garden at night. I always thought they were scary but I kinda like them now, they were pretty chill"
      },
      {
        author: "Hanne",
        time: "13:36",
        text: "You just gotta meet the right moth for you to appreciate them too"
      },
      {
        author: "Robbe",
        time: "13:37",
        text: "I dont wanna meet any moths"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#politics",
    participants: ["Jake", "Kaddy"],
    start: "2025-05-12T22:14:00",
    messages: [
      {
        author: "Jake",
        time: "22:14",
        text: "like near biggest party in the country high"
      },
      {
        author: "Jake",
        time: "22:14",
        text: "fucking scary"
      },
      {
        author: "Kaddy",
        time: "22:14",
        text: "yup second highest.\nlast government fell apart over essentially adults acting childish, then almost 30% of the country voted for a party that was classified right wing extremist weeks after, now the newly formed government couldn't agree on who should be chancellor during the vote so it had to be repeated"
      },
      {
        author: "Kaddy",
        time: "22:16",
        text: "so after holding early re-elections because of \"irreconcilable differences\" we are continuing with a new coalition that can't agree on the most basic shit from the get go"
      },
      {
        author: "Kaddy",
        time: "22:16",
        text: "I'm sure that's gonna go much better than the last one"
      },
      {
        author: "Kaddy",
        time: "22:17",
        text: "and I'm sure when we have the next early election because they're unable to function the AfD isn't gonna be even stronger at all"
      },
      {
        author: "Kaddy",
        time: "22:18",
        text: "no worries that wasn't meant to be passive aggressive if it came across like that at all! I figured he was but hell yeah"
      },
      {
        author: "Kaddy",
        time: "22:18",
        text: "gotta advertise my cars tho it's a rough business these days"
      },
      {
        author: "Jake",
        time: "22:18",
        text: "i was watching something that bassicly said they best thing for extremist parties is just incompetence from the other parties"
      },
      {
        author: "Kaddy",
        time: "22:20",
        text: "very good point, if he ends up with otto I will refuse to acknowledge that and call him mayo instead"
      },
      {
        author: "Jake",
        time: "22:20",
        text: "you can do the classic for black and white kitties of oreoo"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#food",
    participants: ["Global", "Nils"],
    start: "2025-05-13T21:41:00",
    messages: [
      {
        author: "Global",
        time: "21:41",
        text: "coffee soo good but has to be espresso based, filter stuff is gross"
      },
      {
        author: "Nils",
        time: "21:51",
        text: "Sarah swears by McDonald's coffee"
      },
      {
        author: "Nils",
        time: "21:53",
        text: "I've never really drank it though so cannot pass my own judgement"
      },
      {
        author: "Global",
        time: "21:53",
        text: "tbh alot of the time it is better than costa"
      },
      {
        author: "Nils",
        time: "21:55",
        text: "And has the distinct advantage of coming with a McDonald's"
      },
      {
        author: "Global",
        time: "22:05",
        text: "Also the maccy frapp\u00e9s are soo good. And cheap compared to everywhere else"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Robbe", "Nic"],
    start: "2025-05-16T21:44:00",
    messages: [
      {
        author: "Nic",
        time: "21:44",
        text: "you guys can't be fr."
      },
      {
        author: "Robbe",
        time: "21:45",
        text: "Put a turd in a tuxedo it's still gonna be a turd"
      },
      {
        author: "Nic",
        time: "21:45",
        text: "you don't think a person who is unkempt with bad hair and clothes can't look better with better make up, hair style, clothes and how they hold themselves?"
      },
      {
        author: "Nic",
        time: "21:45",
        text: "you guys haven't seen before and after images of people before and after they got style changes?"
      },
      {
        author: "Robbe",
        time: "21:46",
        text: "there's a difference between having bad style and being unkempt though"
      },
      {
        author: "Nic",
        time: "21:46",
        text: "I disagree being unkempt is part of a style"
      },
      {
        author: "Nic",
        time: "21:46",
        text: "any thing you do and wear and display yourself is your style"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Nic", "Smuck"],
    start: "2025-05-16T21:52:00",
    messages: [
      {
        author: "Nic",
        time: "21:52",
        text: "no I don't think so, hair is how like natural it looks is it thin thick like stuff that's out of your control mostly. and eyes can look beautiful while you still hold yourself back with your style"
      },
      {
        author: "Smuck",
        time: "21:52",
        text: "Maybe it telling you something isn't needed for you. But I don't match with a lotta people. So I need to have a vauge idea who the kinksters are, and style usually tells me that"
      },
      {
        author: "Nic",
        time: "21:52",
        text: "I guess I think more people who have lived their lifes thinking their are ugly have a hard time removing that part of their brain"
      },
      {
        author: "Nic",
        time: "21:52",
        text: "same with people who used to be fat still have a problem when they look at themselves"
      },
      {
        author: "Nic",
        time: "21:53",
        text: "in the end like I think what truly makes a person more attractive is their smile and behavior.(I'm a feminist) a lot of people I haven't cared about looks wise has become really good looking after you get to know them"
      },
      {
        author: "Nic",
        time: "21:53",
        text: "but out of these options I think it's style"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Xal", "Smuck"],
    start: "2025-05-16T23:05:00",
    messages: [
      {
        author: "Smuck",
        time: "23:05",
        text: "I could see it. Though belly would look a bit bland without"
      },
      {
        author: "Xal",
        time: "23:05",
        text: "if a man has wide shoulders he will hug better"
      },
      {
        author: "Smuck",
        time: "23:05",
        text: "Just ain't that for the eyes now is it"
      },
      {
        author: "Smuck",
        time: "23:05",
        text: "MAYBE they can give better hugs. But as far as eye candy goes, i dunno man"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#shooter-games",
    participants: ["Fishes", "Joey"],
    start: "2025-05-20T23:10:00",
    messages: [
      {
        author: "Fishes",
        time: "23:10",
        text: "ah"
      },
      {
        author: "Fishes",
        time: "23:10",
        text: "was down to clown for one or 2 stadium games before bed"
      },
      {
        author: "Joey",
        time: "23:10",
        text: "others hopped off im still around but would prefer 1 more person"
      },
      {
        author: "Fishes",
        time: "23:11",
        text: "ah"
      },
      {
        author: "Fishes",
        time: "23:11",
        text: "might be a bed angle then"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Robbe", "Joey"],
    start: "2025-05-21T22:41:00",
    messages: [
      {
        author: "Joey",
        time: "22:41",
        text: "i gave everyone 3 songs that remind me of their personality from my playlist"
      },
      {
        author: "Joey",
        time: "22:42",
        text: "this is the ranking of how much i like those 3 songs"
      },
      {
        author: "Robbe",
        time: "22:42",
        text: "we need the songs"
      },
      {
        author: "Joey",
        time: "22:42",
        text: "ive come prepared"
      },
      {
        author: "Robbe",
        time: "22:42",
        text: "My bad"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Charlie", "Joey"],
    start: "2025-05-21T22:58:00",
    messages: [
      {
        author: "Charlie",
        time: "22:58",
        text: "if i had tits like those you guys would not see me again"
      },
      {
        author: "Charlie",
        time: "22:58",
        text: "im busy"
      },
      {
        author: "Joey",
        time: "22:58",
        text: "yeah youd be human trafficked dude"
      },
      {
        author: "Charlie",
        time: "22:58",
        text: "rush hour"
      },
      {
        author: "Joey",
        time: "22:58",
        text: "if i was born as a lady with huge boobs i think id do a couple years of onlyfans, get a breast reduction, live in peace"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#aww",
    participants: ["Jake", "Ava"],
    start: "2025-05-22T15:21:00",
    messages: [
      {
        author: "Jake",
        time: "15:21",
        text: "thats very high up you should tell them to come down"
      },
      {
        author: "Ava",
        time: "15:21",
        text: "<:wyd:1292965298395418815>"
      },
      {
        author: "Ava",
        time: "15:21",
        text: "I'll post pictures of my dead cat one sec"
      },
      {
        author: "Jake",
        time: "15:26",
        text: "I know that sunlight must have been so comfy and warm for them"
      },
      {
        author: "Jake",
        time: "15:27",
        text: "u are both so zoned out"
      },
      {
        author: "Jake",
        time: "15:28",
        text: "day 1 mum introduced me to this guy im meant to be friends with type shit"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Nic", "Smuck"],
    start: "2025-05-23T12:17:00",
    messages: [
      {
        author: "Nic",
        time: "12:17",
        text: "I got atleast 7 peeps I call best friends an atleast 30 I call close friends"
      },
      {
        author: "Smuck",
        time: "12:17",
        text: "holy fucking shit"
      },
      {
        author: "Nic",
        time: "12:17",
        text: "And then there are just off set friends you meet and such"
      },
      {
        author: "Nic",
        time: "12:17",
        text: "It's annoying because I love them all"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Nils", "Charlie"],
    start: "2025-05-24T19:22:00",
    messages: [
      {
        author: "Charlie",
        time: "19:22",
        text: "i had an idea for a weird round"
      },
      {
        author: "Nils",
        time: "19:23",
        text: "I'll happily give it a go, unless you wanna hold on to it in case you ever host?"
      },
      {
        author: "Charlie",
        time: "19:24",
        text: "a series of questions about hyperspecific niche interests of different people in the quiz (e.g. children of bodom for me, planes for xal)\nthe team with said player just gets the question, but all other teams get multiple choice options"
      },
      {
        author: "Charlie",
        time: "19:25",
        text: "ive thought about cooking one up but honestly the idea of being in a call with 15 people all speaking at once is really offputting"
      },
      {
        author: "Nils",
        time: "19:29",
        text: "I guess the alternative is electing team captains and you mute everyone but each captain"
      },
      {
        author: "Charlie",
        time: "19:29",
        text: "oh yeah i remember that"
      },
      {
        author: "Nils",
        time: "19:29",
        text: "A ton of people all speaking is pretty difficult to keep up with"
      },
      {
        author: "Charlie",
        time: "19:29",
        text: "maybe one day if i ever come up with enough rounds i think are interesting but im in no rush"
      },
      {
        author: "Nils",
        time: "19:30",
        text: "Cool, i'll run with the idea then"
      },
      {
        author: "Nils",
        time: "19:32",
        text: "<@&1293007063441477716> If you reckon you'll come to the next quiz (date tbd) can you DM me a particularly specific niche - think your mastermind topic - and I'll give this idea a go"
      },
      {
        author: "Nils",
        time: "19:33",
        text: "Banned topics included but not limited to: League of Legends"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Robbe", "Charlie"],
    start: "2025-05-25T17:45:00",
    messages: [
      {
        author: "Robbe",
        time: "17:45",
        text: "<a:mooning:1356728529404035233>"
      },
      {
        author: "Charlie",
        time: "17:45",
        text: "if it were 4 years ago and my life was just playing league 10 hours a day maybe i'd think differently"
      },
      {
        author: "Charlie",
        time: "17:46",
        text: "but i did play a lot with james and ben so who knows"
      },
      {
        author: "Charlie",
        time: "17:46",
        text: "im also terrible at more or less every game so i have to assume my boys are lending me some leeway"
      },
      {
        author: "Robbe",
        time: "17:47",
        text: "It's okay you have your appearance"
      },
      {
        author: "Charlie",
        time: "17:47",
        text: "\ud83d\ude14"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#food",
    participants: ["Kaddy", "Smuck"],
    start: "2025-05-26T11:36:00",
    messages: [
      {
        author: "Smuck",
        time: "11:36",
        text: "Sugar Lemon > Syrup > Just not having pancakes > Everything else you can have on"
      },
      {
        author: "Kaddy",
        time: "11:37",
        text: "sounds like overkill but delicious"
      },
      {
        author: "Smuck",
        time: "11:37",
        text: "Nahh, the lemon makes it so so nice"
      },
      {
        author: "Kaddy",
        time: "11:37",
        text: "this is why you mix in cinnamon\nlook at me, eating tree bark like a true adult"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#food",
    participants: ["Kaddy", "Nic"],
    start: "2025-05-26T11:37:00",
    messages: [
      {
        author: "Nic",
        time: "11:37",
        text: "crazy take you can put so much on pancakes"
      },
      {
        author: "Nic",
        time: "11:37",
        text: "banana chocolate? fuck yeah"
      },
      {
        author: "Kaddy",
        time: "11:37",
        text: "pancakes are just extremely neutral"
      },
      {
        author: "Nic",
        time: "11:37",
        text: "I can only eat like 2-3 if I have thaton because it is heavy"
      },
      {
        author: "Kaddy",
        time: "11:38",
        text: "only?? good sir I never eat more than three pancakes no matter what's on them"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Buppy", "Kasai"],
    start: "2025-05-26T17:43:00",
    messages: [
      {
        author: "Kasai",
        time: "17:43",
        text: "I fuck with mine heavy"
      },
      {
        author: "Buppy",
        time: "17:44",
        text: "okay kinda fucking based king..."
      },
      {
        author: "Kasai",
        time: "17:44",
        text: "Thank you"
      },
      {
        author: "Kasai",
        time: "17:46",
        text: "When you used to type \"Future Funk\" into google images my art at the time would be what showed up but I took down all my redbubble stuff so it no longer appears :P"
      },
      {
        author: "Buppy",
        time: "18:11",
        text: "after romanias presidential election the crazies are cutting up their id cards..."
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Nic", "Smuck"],
    start: "2025-05-27T09:01:00",
    messages: [
      {
        author: "Smuck",
        time: "09:01",
        text: "Honestly true. Don't think it had one in the tierlist but that does fit your vibe"
      },
      {
        author: "Nic",
        time: "09:02",
        text: "I didn't even know cream soda was a thing"
      },
      {
        author: "Smuck",
        time: "09:04",
        text: "It's nasty but people keep drinking it for some reason"
      },
      {
        author: "Nic",
        time: "09:06",
        text: "if I see a cream soda I'll get it. it sounds awful but willing to try"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Jake", "Hanne"],
    start: "2025-05-27T18:49:00",
    messages: [
      {
        author: "Hanne",
        time: "18:49",
        text: "Worst part is I can\u2019t even take them now to stop feeling this way because then I won\u2019t be able to sleep"
      },
      {
        author: "Hanne",
        time: "18:49",
        text: "So I\u2019m just fucked for the evening <:Memesteroji_catokay:1046043497263792189>"
      },
      {
        author: "Jake",
        time: "18:49",
        text: "how often do you forget to take em"
      },
      {
        author: "Hanne",
        time: "18:50",
        text: "It\u2019s the first time this month it\u2019s happened luckily. But like once or twice a month usually \ud83d\ude02"
      },
      {
        author: "Jake",
        time: "18:50",
        text: "somethin happened that made you forgor?"
      },
      {
        author: "Hanne",
        time: "18:50",
        text: "I don\u2019t realize it all day and then it\u2019s evening and the room is spinning and I\u2019m like ohhh\u2026."
      },
      {
        author: "Hanne",
        time: "18:50",
        text: "I spent too much time thinking what I should wear for work and then I had to rush because I took too long <:Memesteroji_beluga:1046059358481563668>"
      },
      {
        author: "Hanne",
        time: "18:51",
        text: "Also almost crashed into a tree because my skirt got stuck in my wheel. Awesome day guys"
      },
      {
        author: "Hanne",
        time: "18:51",
        text: "(No Hanne\u2019s were injured though)"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#aww",
    participants: ["Nic", "Kasai"],
    start: "2025-05-28T13:04:00",
    messages: [
      {
        author: "Nic",
        time: "13:04",
        text: "armed dragon is so cool, mostly because it works with ojamas and is a chazz card"
      },
      {
        author: "Nic",
        time: "13:04",
        text: "I'm going to be playing this when it comes out"
      },
      {
        author: "Nic",
        time: "13:04",
        text: "made by the same team who made sifu"
      },
      {
        author: "Kasai",
        time: "13:05",
        text: "Sick, I think the price is the thing that's gating me, ill see how I feel post playtest too"
      },
      {
        author: "Nic",
        time: "13:05",
        text: "that's understandable, it looks like a rocket league typa thing, and rocket league is free"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Blithe", "Smuck"],
    start: "2025-06-05T14:31:00",
    messages: [
      {
        author: "Smuck",
        time: "14:31",
        text: "Oh god no"
      },
      {
        author: "Blithe",
        time: "14:50",
        text: "No Smuck do it"
      },
      {
        author: "Blithe",
        time: "14:50",
        text: "I want to know the reasonings"
      },
      {
        author: "Smuck",
        time: "15:09",
        text: "Fine, but only for you and Nic. For you it's the artsy aesthetic and the lyrics about struggling with finding an identity you can feel okay with that makes it fit for me. Not super fitting cause of the colour but that's what made me choose that"
      },
      {
        author: "Smuck",
        time: "15:11",
        text: "Video fits, music feels very nic like for me (at least out of Will's covers), lyrics about \"Fuck dem expectations, I'm gonna have a good time\"."
      },
      {
        author: "Smuck",
        time: "15:15",
        text: "Not sure I like it. Seems a bit too samey for me. Feels a bit like the loading menu of a beach game"
      },
      {
        author: "Smuck",
        time: "15:15",
        text: "HEll yeh"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Jake", "Kasai"],
    start: "2025-06-05T15:21:00",
    messages: [
      {
        author: "Kasai",
        time: "15:21",
        text: "It was my 2021 song I used to sing it all the time"
      },
      {
        author: "Kasai",
        time: "15:22",
        text: "Thats my playlist for this kind of music"
      },
      {
        author: "Kasai",
        time: "15:24",
        text: "A long time ago now I used to be friends with Amanda from LeeandLie her cover of simple and clean is my favourite rendition :)"
      },
      {
        author: "Jake",
        time: "15:24",
        text: "friends of leeandlie and cdawg ur friend group fell off SMHH"
      },
      {
        author: "Kasai",
        time: "15:24",
        text: "Don't forget Kovox"
      },
      {
        author: "Kasai",
        time: "15:27",
        text: "I mean I am only really friends with one person from that time in my life and shes a hella busy person so I don't think I'd have managed to stay in touch with them anyway"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#minecraft",
    participants: ["Global", "Charlie"],
    start: "2025-06-06T13:55:00",
    messages: [
      {
        author: "Global",
        time: "13:55",
        text: "I believe so"
      },
      {
        author: "Charlie",
        time: "13:55",
        text: "wither"
      },
      {
        author: "Global",
        time: "13:56",
        text: "\ud83e\udd37\u200d\u2642\ufe0f maybe. But I bet it would break the spawner"
      },
      {
        author: "Charlie",
        time: "14:15",
        text: "creeper one could be useful, unless theres another way to farm gunpowder"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Nic", "Smuck"],
    start: "2025-06-09T11:34:00",
    messages: [
      {
        author: "Smuck",
        time: "11:34",
        text: "Well yeh if you have to live with it it'd suck"
      },
      {
        author: "Smuck",
        time: "11:35",
        text: "But like if they keep swinging I think I'd croak before I had to suffer the consequences"
      },
      {
        author: "Nic",
        time: "11:36",
        text: "you genuinely think that if you got hit in the head with like a bat 3 times you would not feel it?"
      },
      {
        author: "Nic",
        time: "11:36",
        text: "because I promise you, you most definitely will"
      },
      {
        author: "Smuck",
        time: "11:36",
        text: "I think I'd get brain damage after like the second swing and would barely be able to register it"
      },
      {
        author: "Nic",
        time: "11:37",
        text: "I don't think that's how it works smuck"
      },
      {
        author: "Nic",
        time: "11:37",
        text: "I think you will feel almost the entire pain, while your brain is bouncing around in your head"
      },
      {
        author: "Nic",
        time: "11:37",
        text: "especially if you get hit any facial area, nose, eyes, eyebrows, lips"
      },
      {
        author: "Smuck",
        time: "11:37",
        text: "Could be wrong. In which case being beheaded is the second best option. Cause like, you'd bleed out real quick"
      },
      {
        author: "Nic",
        time: "11:37",
        text: "the face is full of very sensitive nerves that your body most definitely will register"
      },
      {
        author: "Nic",
        time: "11:37",
        text: "how is the beheading?"
      },
      {
        author: "Nic",
        time: "11:37",
        text: "is it like instant?"
      },
      {
        author: "Nic",
        time: "11:38",
        text: "guillotine?"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Nic", "Smuck"],
    start: "2025-06-09T11:39:00",
    messages: [
      {
        author: "Nic",
        time: "11:39",
        text: "seen some of the beheading videos. you stay alive... for a while"
      },
      {
        author: "Smuck",
        time: "11:39",
        text: "Probably one of if not the scariest. But could be the fastest, which is a big factor for me"
      },
      {
        author: "Nic",
        time: "11:40",
        text: "that one mexican cartel lady has half her throat ripped up and was alive for 5-10 minutes while it was happening because the knife had trouble cutting through bone and nerve"
      },
      {
        author: "Smuck",
        time: "11:40",
        text: "The ones I've seen they went limp like right away"
      },
      {
        author: "Smuck",
        time: "11:40",
        text: "Damm. Just gotta hope my guy knows what he's doing then"
      },
      {
        author: "Nic",
        time: "11:40",
        text: "pray that you get the good executioner"
      },
      {
        author: "Nic",
        time: "11:41",
        text: "you get it. starving is honestly the best one"
      },
      {
        author: "Nic",
        time: "11:41",
        text: "again starving is also most of the time serviceable, even the high points of pain isn't as terrible has being cut, bludgeoned or beheaded"
      },
      {
        author: "Smuck",
        time: "11:41",
        text: "No, but middle school that was the thing to do for recess"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Robbe", "Nic"],
    start: "2025-06-09T11:41:00",
    messages: [
      {
        author: "Robbe",
        time: "11:41",
        text: "Well if you're gonna make the beheading as slow and painful as possible I'd go starving yeah"
      },
      {
        author: "Nic",
        time: "11:41",
        text: "you just suffer longer, but you faint out and when you start to get off you just as charlie say slowly fade and start not feeling things"
      },
      {
        author: "Nic",
        time: "11:42",
        text: "beheading if guillotine, if not then starving"
      },
      {
        author: "Robbe",
        time: "11:42",
        text: "Yup yup"
      },
      {
        author: "Robbe",
        time: "11:42",
        text: "Firm handshake"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Clom", "Nic"],
    start: "2025-06-09T12:42:00",
    messages: [
      {
        author: "Nic",
        time: "12:42",
        text: "as a person who has been hit in the head with a baseball bat at full speed. both accidentally and fully you will not RAPIDLY die"
      },
      {
        author: "Nic",
        time: "12:43",
        text: "if you continue to be head in the head with a baseball bad over and over yes you will die in a min or 2"
      },
      {
        author: "Clom",
        time: "12:43",
        text: "you have not been hit hard with a baseball bat in the head bro"
      },
      {
        author: "Nic",
        time: "12:43",
        text: "it's crazy how much more about my life you know than I do clom"
      },
      {
        author: "Nic",
        time: "12:43",
        text: "i don't think I can mention a simple thing without yo dumb ahh neglecting it because it doesn't suite your scenario"
      },
      {
        author: "Nic",
        time: "12:43",
        text: "this is just a fucking crazy statement what"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Nic", "Ava"],
    start: "2025-06-09T12:43:00",
    messages: [
      {
        author: "Ava",
        time: "12:43",
        text: "Nic"
      },
      {
        author: "Ava",
        time: "12:44",
        text: "Be so for real"
      },
      {
        author: "Nic",
        time: "12:44",
        text: "I'm being fucking fr, ask jake and fishes they know about it"
      },
      {
        author: "Ava",
        time: "12:44",
        text: "You got donked with a bat u didn't get fucking belted"
      },
      {
        author: "Nic",
        time: "12:44",
        text: "i even still have a scar from it and on the top of my head"
      },
      {
        author: "Nic",
        time: "12:44",
        text: "I went to the hospital"
      },
      {
        author: "Nic",
        time: "12:44",
        text: "and got fucking jumped by a bunch of kids and it gave me a concussion"
      },
      {
        author: "Nic",
        time: "12:44",
        text: "I'm saying it will hurt like fuck"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Clom", "Xal"],
    start: "2025-06-09T12:45:00",
    messages: [
      {
        author: "Xal",
        time: "12:45",
        text: "i think they\u2019re talking about like"
      },
      {
        author: "Xal",
        time: "12:45",
        text: "if someone big and buff hits you with a baseball bat in the head with intent to kill you"
      },
      {
        author: "Clom",
        time: "12:45",
        text: "did they need to crack your skull to release the pressure from the bleeding in your skull?"
      },
      {
        author: "Xal",
        time: "12:45",
        text: "you will fucking die"
      },
      {
        author: "Clom",
        time: "12:45",
        text: "your brain bleeds so fast"
      },
      {
        author: "Clom",
        time: "12:45",
        text: "that it fills your skull"
      },
      {
        author: "Clom",
        time: "12:45",
        text: "and causes so much pressure that your brain is squeezed from the inside"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Nic", "Xal"],
    start: "2025-06-09T12:47:00",
    messages: [
      {
        author: "Nic",
        time: "12:47",
        text: "the hitting the part of you being dead instantly is what kills you, you can survive getting hit in the head with a bat"
      },
      {
        author: "Xal",
        time: "12:47",
        text: "yes"
      },
      {
        author: "Nic",
        time: "12:48",
        text: "exactly my point is that more commonly you don't die on the first hit of a bludgeoning weapon instantly"
      },
      {
        author: "Nic",
        time: "12:48",
        text: "see what happens"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Charlie", "Ava"],
    start: "2025-06-12T13:18:00",
    messages: [
      {
        author: "Charlie",
        time: "13:18",
        text: "hijacking but they forgot to use hijackers that know how to fly"
      },
      {
        author: "Ava",
        time: "13:18",
        text: "Maybe but that's a fast ass takeover and prolly have a callout for that"
      },
      {
        author: "Charlie",
        time: "13:19",
        text: "it was the hijackers calling mayday but then they turned the radio off by accident"
      },
      {
        author: "Ava",
        time: "13:19",
        text: "If ur being held at gunpoint seems weird to drop a mayday in the chat"
      },
      {
        author: "Charlie",
        time: "13:19",
        text: "/all 9x"
      },
      {
        author: "Ava",
        time: "13:20",
        text: "X9 pilot for miscommunication"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Blithe", "Joey"],
    start: "2025-06-14T16:27:00",
    messages: [
      {
        author: "Blithe",
        time: "16:27",
        text: "Mariokart goated"
      },
      {
        author: "Blithe",
        time: "16:28",
        text: "so many fun memories of me and friends just chilling and playing"
      },
      {
        author: "Joey",
        time: "16:28",
        text: "I wanna try the new one so bad but I can't justify buying a switch 2"
      },
      {
        author: "Blithe",
        time: "16:28",
        text: "HELL NO"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Nic", "Smuck"],
    start: "2025-06-17T10:47:00",
    messages: [
      {
        author: "Smuck",
        time: "10:47",
        text: "A lot of you are not considering how fucking awesome it'd be to have a cheeseburger as a dog"
      },
      {
        author: "Nic",
        time: "10:49",
        text: "But how do you communicate that you want a cherseburger"
      },
      {
        author: "Nic",
        time: "10:49",
        text: "You'll be put in a home for retards and fed frozen meals untill you die"
      },
      {
        author: "Smuck",
        time: "10:53",
        text: "But I'd be lovin it and I know ONE day i'd get that cheeseburger"
      },
      {
        author: "Smuck",
        time: "10:54",
        text: "Also they just let me walk outside for an hour a day it'd probably feel better than all my lives joy combined"
      },
      {
        author: "Nic",
        time: "10:56",
        text: "Do you think it's because of it's brain or because of it's tongue?"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Nic", "Smuck"],
    start: "2025-06-17T11:19:00",
    messages: [
      {
        author: "Nic",
        time: "11:19",
        text: "it could bee like, you get her on the week days and he gets her on the weekend"
      },
      {
        author: "Smuck",
        time: "11:19",
        text: "Feel like it'd be really fucking funny to be mad at a normal bee who stole my partner"
      },
      {
        author: "Smuck",
        time: "11:20",
        text: "But if the bee can talk it feels to justified, then I think it'd be funnier to absolutely be pissed of at Scooby Doo"
      },
      {
        author: "Nic",
        time: "11:20",
        text: "I agree, I wouldn't be able to handle it"
      },
      {
        author: "Nic",
        time: "11:20",
        text: "it would be my biggest crash out I think"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Charlie", "Ava"],
    start: "2025-06-17T19:32:00",
    messages: [
      {
        author: "Ava",
        time: "19:32",
        text: "this is equivalent to drowning"
      },
      {
        author: "Ava",
        time: "19:32",
        text: "shouldve done carbon monoxide poisoning"
      },
      {
        author: "Charlie",
        time: "19:35",
        text: "drowning is an alright way to die but a shit way to commit suicide"
      },
      {
        author: "Ava",
        time: "19:38",
        text: "can't beat hitting a sick flip and giving up 75% of the way i fear"
      },
      {
        author: "Charlie",
        time: "19:38",
        text: "nah that sucks"
      },
      {
        author: "Charlie",
        time: "19:38",
        text: "50% chance you fuck it up and just parsnip mode for 60 years"
      },
      {
        author: "Ava",
        time: "19:39",
        text: "swede-o mode"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Blithe", "Smuck"],
    start: "2025-06-20T10:19:00",
    messages: [
      {
        author: "Blithe",
        time: "10:19",
        text: "What do suppliers do"
      },
      {
        author: "Smuck",
        time: "10:22",
        text: "Make sure everyone has access to horses and the other supplies you need on mission"
      },
      {
        author: "Blithe",
        time: "10:26",
        text: "Mf"
      },
      {
        author: "Blithe",
        time: "10:26",
        text: "I did not watch AoT"
      },
      {
        author: "Blithe",
        time: "10:27",
        text: "Supplier is like saying \"I brought the stuff you asked for\" without saying what it is"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Kaddy", "Smuck"],
    start: "2025-06-20T19:50:00",
    messages: [
      {
        author: "Smuck",
        time: "19:50",
        text: "Tough day :/"
      },
      {
        author: "Kaddy",
        time: "19:50",
        text: "<@554275447710548018> be real do you just think I don't like anyone here besides smuck..."
      },
      {
        author: "Smuck",
        time: "19:51",
        text: "No it's what he thinks THEY think if you, not vice versa (right?)"
      },
      {
        author: "Kaddy",
        time: "19:51",
        text: "I thought it was how much everyone likes them"
      },
      {
        author: "Smuck",
        time: "19:52",
        text: "Maybe, now I'm confused again"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Kaddy", "Blithe"],
    start: "2025-06-21T16:43:00",
    messages: [
      {
        author: "Kaddy",
        time: "16:43",
        text: "sorry"
      },
      {
        author: "Kaddy",
        time: "16:43",
        text: "I had to judge based on the limited info I have"
      },
      {
        author: "Blithe",
        time: "16:48",
        text: "Are you basing it off the fact I'm a STEM major"
      },
      {
        author: "Kaddy",
        time: "17:01",
        text: "physics specifically\nalso austria\nalso anxious at least about a couple things so probably sweatin"
      },
      {
        author: "Kaddy",
        time: "17:02",
        text: "and I think I've seen a picture of you (I hope I'm not mixing them up)"
      },
      {
        author: "Blithe",
        time: "17:03",
        text: "WDYM AUSTRIA"
      },
      {
        author: "Blithe",
        time: "17:03",
        text: "Also yes that sweating part is true but I shower every day and obviously use deodorant because of it"
      },
      {
        author: "Blithe",
        time: "17:06",
        text: "There's probably a the only pic I ever posted of me on here somewhere"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#food",
    participants: ["Jake", "Buppy"],
    start: "2025-06-24T05:35:00",
    messages: [
      {
        author: "Buppy",
        time: "05:35",
        text: "Im having real food jaq is saving me"
      },
      {
        author: "Jake",
        time: "05:36",
        text: "That looks so good but no shot ur ass is finishing all dat"
      },
      {
        author: "Buppy",
        time: "05:36",
        text: "I still have left overs and that was atleast 7 hours ago"
      },
      {
        author: "Buppy",
        time: "05:36",
        text: "<:pegin:1311430349712003133>"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Fishes", "Joey"],
    start: "2025-06-24T14:09:00",
    messages: [
      {
        author: "Fishes",
        time: "14:09",
        text: "Exactly"
      },
      {
        author: "Joey",
        time: "14:09",
        text: "absolute plonker"
      },
      {
        author: "Fishes",
        time: "14:10",
        text: "Not the same vein but a rule of not dating your friends sister"
      },
      {
        author: "Joey",
        time: "14:10",
        text: "its also definitely not ok if you are under 18, want to have a kid with them, or if it's with a parent"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Clom", "Smuck"],
    start: "2025-06-24T17:47:00",
    messages: [
      {
        author: "Smuck",
        time: "17:47",
        text: "Mostly just pleasantries. But S is you will banter and wanna start conversations to pass the time"
      },
      {
        author: "Smuck",
        time: "18:06",
        text: "Looks like a copper miner"
      },
      {
        author: "Clom",
        time: "18:11",
        text: "<:ImpNic:1292965003527196673>"
      },
      {
        author: "Smuck",
        time: "18:13",
        text: "Real"
      },
      {
        author: "Smuck",
        time: "18:14",
        text: "Which is funny af but also really annoying to deal with afterwards"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Charlie", "Smuck"],
    start: "2025-06-24T19:56:00",
    messages: [
      {
        author: "Smuck",
        time: "19:56",
        text: "The R3bbid one is so good. All time classic lethal Company moment"
      },
      {
        author: "Charlie",
        time: "19:56",
        text: "All the Alliteration Andrews will always be a goated bit"
      },
      {
        author: "Smuck",
        time: "19:57",
        text: "Sadly I have no recollection of ever raving about Rick and Morty but I 100% can see myself doing it"
      },
      {
        author: "Charlie",
        time: "19:57",
        text: "Yours was when Justin Roiland was found innocent (legally at least) and you just screamed that from your kitchen"
      },
      {
        author: "Smuck",
        time: "19:58",
        text: "Awesome. Making myself chuckle from that. Good job past me \ud83d\udc4f"
      },
      {
        author: "Charlie",
        time: "19:59",
        text: "You cant win them all in life but Ive at least won at having specific and useless memories"
      },
      {
        author: "Charlie",
        time: "20:00",
        text: "For better or for worse"
      },
      {
        author: "Charlie",
        time: "20:00",
        text: "I'd rather be idk able to talk to women but we take what we can get"
      },
      {
        author: "Charlie",
        time: "20:01",
        text: "Anyone ever asks me the capital of Brunei i got that shit in the bag"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Robbe", "Smuck"],
    start: "2025-06-27T01:13:00",
    messages: [
      {
        author: "Smuck",
        time: "01:13",
        text: "What time does Fishlympics start?"
      },
      {
        author: "Robbe",
        time: "01:13",
        text: "6UK"
      },
      {
        author: "Smuck",
        time: "01:19",
        text: "Mannn, don't think I can fix my PC by then <:NotLikeThisCat:629007163557281802>"
      },
      {
        author: "Smuck",
        time: "01:19",
        text: "Guess oldie will have to suffice.. Cause apparently that's a 14 hour process when I thought it was 4 at most"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#shooter-games",
    participants: ["Joey", "Ava"],
    start: "2025-06-28T16:08:00",
    messages: [
      {
        author: "Joey",
        time: "16:08",
        text: "<@967421458949238866> Brig's relative shielding sens should be 107.35 for 1:1 with normal sens apparently"
      },
      {
        author: "Joey",
        time: "16:08",
        text: "other 1:1 relative sens settings if anyone is interested\nAna 37.79\nAshe 51.47\nFreja 62.50\nWidow 37.89"
      },
      {
        author: "Ava",
        time: "16:08",
        text: "why dis"
      },
      {
        author: "Joey",
        time: "16:10",
        text: "when shielding fov lowers a bit, so your sens is temporarily lowered to compensate. if you want it to be always the same sens (helps muscle memory), go controls settings -> change hero -> brig -> hero & hud -> relative sens 107.35"
      },
      {
        author: "Ava",
        time: "16:10",
        text: "i mightve changed that already but ill check"
      },
      {
        author: "Joey",
        time: "16:10",
        text: "7.35% increase because Brig's 96 fov is 7.35% lower than default 103 I guess"
      },
      {
        author: "Joey",
        time: "16:11",
        text: "these settings are awesome btw for anyone who plays these heroes \ud83d\udc4d\ud83d\udc4d\ud83d\udc4d\ud83d\udc4d feels much more natural"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#real-talk",
    participants: ["Charlie", "Ava"],
    start: "2025-06-29T12:21:00",
    messages: [
      {
        author: "Ava",
        time: "12:21",
        text: "Team my mum is trying to get me to do hypnotherapy"
      },
      {
        author: "Ava",
        time: "12:22",
        text: "Do I rly just have to stay resilient to all this shit she throws at me or wot"
      },
      {
        author: "Charlie",
        time: "12:32",
        text: "as in she wants to do it to you or she wants you to go see a hypnotherapist"
      },
      {
        author: "Ava",
        time: "12:33",
        text: "She wants me to do past life regression"
      },
      {
        author: "Ava",
        time: "12:33",
        text: "Idk if that means seeing a hypnotherapist or her doing it"
      },
      {
        author: "Ava",
        time: "12:34",
        text: "She keeps saying things that happened in my childhood are made up"
      },
      {
        author: "Charlie",
        time: "12:34",
        text: "do you think she'll flip her lid if you refuse on grounds of it being bullshit"
      },
      {
        author: "Ava",
        time: "12:38",
        text: "Likely"
      },
      {
        author: "Ava",
        time: "12:38",
        text: "It's just weird bc she thinks I have forged memories so she wants me to do a thing which has a likelihood of creating forged memories"
      },
      {
        author: "Ava",
        time: "12:39",
        text: "Like \ud83e\udd78"
      },
      {
        author: "Ava",
        time: "12:39",
        text: "She's asked me to recall all my information from comp bc she thinks a bunch of stuff that happened to me didn't bc she wasn't told about it"
      },
      {
        author: "Ava",
        time: "12:41",
        text: "Is it possible I'm crazy bc she's crazy"
      },
      {
        author: "Ava",
        time: "12:41",
        text: "<:Glorp:1295780435539923024>"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#league-of-legends",
    participants: ["Charlie", "Smuck"],
    start: "2025-07-02T12:35:00",
    messages: [
      {
        author: "Charlie",
        time: "12:35",
        text: "cant believe you outrank me"
      },
      {
        author: "Smuck",
        time: "12:39",
        text: "Dude they weren't kidding when they was talking about that global warming stuff huh"
      },
      {
        author: "Smuck",
        time: "12:40",
        text: "I don't know what that means but I'm very concerned"
      },
      {
        author: "Charlie",
        time: "12:40",
        text: "league of legends"
      },
      {
        author: "Smuck",
        time: "12:40",
        text: "Got hands of magic"
      },
      {
        author: "Smuck",
        time: "12:40",
        text: "But I don't read"
      },
      {
        author: "Smuck",
        time: "12:42",
        text: "I swear I went through so many iterations and never once even got the \"One away\" message. ||Do they have an execute, true damage, become untargetable, did it have anything to do with their lore region, can they go through walls, percent health damage, cc on ultimate||"
      },
      {
        author: "Charlie",
        time: "12:43",
        text: "other categories were ||suppression ult, magic damage shield, execute damage||"
      },
      {
        author: "Smuck",
        time: "12:44",
        text: "Nah man, I was on two of those just not quite on the right track I guess \ud83d\ude2d"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Kaddy", "Blithe"],
    start: "2025-07-02T14:51:00",
    messages: [
      {
        author: "Blithe",
        time: "14:51",
        text: "What the hell"
      },
      {
        author: "Kaddy",
        time: "14:52",
        text: "what else am I supposed to do when I get 3/4 but no idea what it is"
      },
      {
        author: "Kaddy",
        time: "14:52",
        text: "at that point it's brute force time"
      },
      {
        author: "Blithe",
        time: "14:53",
        text: "never played connections so my brain just farded seeing that"
      },
      {
        author: "Kaddy",
        time: "14:55",
        text: "now that my internet is back up and school is out I wanna get back on the daily connectioning"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Kaddy", "Blithe"],
    start: "2025-07-02T14:56:00",
    messages: [
      {
        author: "Blithe",
        time: "14:56",
        text: "I still got exams till the 17.07 <:Despair:1023337372928184320>"
      },
      {
        author: "Kaddy",
        time: "14:56",
        text: "what the helly"
      },
      {
        author: "Kaddy",
        time: "14:56",
        text: "aren't uni summer breaks supposed to be longer or is that just a germany thing"
      },
      {
        author: "Blithe",
        time: "14:57",
        text: "yeah but my exams usually reach till mid to end of july"
      },
      {
        author: "Blithe",
        time: "14:58",
        text: "like officially uni's over with start of July but all the Physics departments still do their exams till that time frame"
      },
      {
        author: "Blithe",
        time: "15:01",
        text: "very jealous of you <a:MODS:950422357502230549>"
      },
      {
        author: "Kaddy",
        time: "15:11",
        text: "not gonna post mine but it was 41 tries I think\n(I had one right and thought I had already clicked it, but actually hadn't, so I spammed everything else... unfortunate)"
      },
      {
        author: "Kaddy",
        time: "15:12",
        text: "fucking physics department"
      },
      {
        author: "Kaddy",
        time: "15:12",
        text: "imagine"
      },
      {
        author: "Blithe",
        time: "15:12",
        text: "ight just tell me to kill myself geez"
      },
      {
        author: "Kaddy",
        time: "15:14",
        text: "I do wish this version gave you \"you already guessed this one\" like the original"
      },
      {
        author: "Kaddy",
        time: "15:17",
        text: "when does your break end"
      },
      {
        author: "Kaddy",
        time: "15:17",
        text: "is it just shifted back comparatively or do you not really get any"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#media",
    participants: ["Clom", "Kaddy"],
    start: "2025-07-05T23:28:00",
    messages: [
      {
        author: "Kaddy",
        time: "23:28",
        text: "this is really sad gang, I either never went there at all or not when I was old enough to remember anything"
      },
      {
        author: "Kaddy",
        time: "23:28",
        text: "I could maybe find out if they still do real life steam trains"
      },
      {
        author: "Clom",
        time: "23:28",
        text: "<:TrollDespair:1292965617359650871>"
      },
      {
        author: "Kaddy",
        time: "23:31",
        text: "steam train museum still exists but they're obv stationary"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#shooter-games",
    participants: ["Freddie", "Hanne"],
    start: "2025-07-08T19:54:00",
    messages: [
      {
        author: "Freddie",
        time: "19:54",
        text: "<@&1292953335464464497> 3 spots"
      },
      {
        author: "Hanne",
        time: "19:55",
        text: "I\u2019m around but idk if my internet will cut out like yesterday. I don\u2019t wanna piss you guys off with it \ud83d\ude02"
      },
      {
        author: "Freddie",
        time: "19:56",
        text: "try it if u want, up to u"
      },
      {
        author: "Hanne",
        time: "19:57",
        text: "Well I've been playing the sims for 10 hours straight, I think I'm due for a change of game"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Jake", "Joey"],
    start: "2025-07-09T15:25:00",
    messages: [
      {
        author: "Joey",
        time: "15:25",
        text: "weve been slacking recently but it used to be multiple times per week"
      },
      {
        author: "Joey",
        time: "15:25",
        text: "do we play this <@91198671168753664>"
      },
      {
        author: "Jake",
        time: "15:29",
        text: "we played it once yearss ago"
      },
      {
        author: "Jake",
        time: "15:29",
        text: "have heard good things about it though"
      },
      {
        author: "Joey",
        time: "15:30",
        text: "if its a social deduction game we play one called blood on the clocktower which isnt on tabletop but seems to have a lot of crossover with board gmae enjoyers"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Blithe", "Robbe"],
    start: "2025-07-09T15:52:00",
    messages: [
      {
        author: "Robbe",
        time: "15:52",
        text: "I thought I knew what gif you'd associate with me"
      },
      {
        author: "Blithe",
        time: "15:54",
        text: "Unironically me not being one of the nerd emojis confuses me so you win Joey, you could either hate my guts or like me and I wouldn't be able to tell"
      },
      {
        author: "Robbe",
        time: "15:55",
        text: "I think Joe likes me but I have no clue which gif I am"
      },
      {
        author: "Blithe",
        time: "15:55",
        text: "Oh it's the skeleton for me right"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Kaddy", "Smuck"],
    start: "2025-07-09T16:18:00",
    messages: [
      {
        author: "Smuck",
        time: "16:18",
        text: "I gotta be the shower or happy cat surely"
      },
      {
        author: "Kaddy",
        time: "16:19",
        text: "he's aspiring to be a rug and I have to say he's getting pretty close"
      },
      {
        author: "Kaddy",
        time: "16:19",
        text: "do you think he passed his finals"
      },
      {
        author: "Smuck",
        time: "16:20",
        text: "<@608382614453223444> My fellow swede didn't even vote for Bearnaise.... Tragic"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Kaddy", "Charlie"],
    start: "2025-07-09T20:13:00",
    messages: [
      {
        author: "Charlie",
        time: "20:13",
        text: "no superpower shit, if you jump off a bridge you'll cripple yourself, if you get into heroin you'll get addicted  But natural life occurances won't have a negative impact, you'll never get bad knees as you age, you'll never get chronic depression, you'll never get cancer without abusing carcinogens"
      },
      {
        author: "Charlie",
        time: "20:14",
        text: "i was imagining your natural death just comes x years earlier"
      },
      {
        author: "Kaddy",
        time: "20:15",
        text: "hmm idk then, if eating unhealthy puts me at risk just the same cause that's my choice it doesn't seem worth it\nif it just excludes major recklessness I would consider"
      },
      {
        author: "Charlie",
        time: "20:15",
        text: "well anything that someone could naturally experience due to good luck/genetics you'd get"
      },
      {
        author: "Charlie",
        time: "20:16",
        text: "so you couldn't eat actual poison but you wouldn't have to worry about eating healthily"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Jake", "Charlie"],
    start: "2025-07-09T20:26:00",
    messages: [
      {
        author: "Charlie",
        time: "20:26",
        text: "most people in my family have lived to late 80s/early 90s"
      },
      {
        author: "Charlie",
        time: "20:26",
        text: "i was imagining that"
      },
      {
        author: "Jake",
        time: "20:27",
        text: "obv own health and behaviiours will effect it a lot"
      },
      {
        author: "Jake",
        time: "20:27",
        text: "but you gotta imagine the average health aint too great either"
      },
      {
        author: "Charlie",
        time: "20:27",
        text: "yeah the smack wont help"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Clom", "Charlie"],
    start: "2025-07-09T20:45:00",
    messages: [
      {
        author: "Charlie",
        time: "20:45",
        text: "i think thats the last thing on earth i want to happen"
      },
      {
        author: "Clom",
        time: "20:45",
        text: "well just function without your body hurting"
      },
      {
        author: "Clom",
        time: "20:45",
        text: "would be good enough then"
      },
      {
        author: "Clom",
        time: "20:46",
        text: "me and fishes in 20-30 \ud83e\udd1d"
      },
      {
        author: "Charlie",
        time: "20:46",
        text: "i think biggest benefit has gotta be not worrying about diet"
      },
      {
        author: "Charlie",
        time: "20:47",
        text: "rn i know i got like 10 years to sort my shit out"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#other-games",
    participants: ["Kaddy", "Robbe"],
    start: "2025-07-12T17:51:00",
    messages: [
      {
        author: "Robbe",
        time: "17:51",
        text: "Nothing planned afaik"
      },
      {
        author: "Kaddy",
        time: "17:55",
        text: "not sure if I'm happy that I can sleep or sad cause I haven't done anything in forever"
      },
      {
        author: "Kaddy",
        time: "17:58",
        text: "Boeing not realizing that's not the sound their planes make when hitting the ground and they don't bounce back up either"
      },
      {
        author: "Kaddy",
        time: "18:01",
        text: "pov: you asked for a kiss"
      },
      {
        author: "Robbe",
        time: "18:06",
        text: "At least you got the thing tomorrow"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#other-games",
    participants: ["Kaddy", "Joey"],
    start: "2025-07-15T19:03:00",
    messages: [
      {
        author: "Kaddy",
        time: "19:03",
        text: "I'll be honest, not sure if drinking will make me feel better or facilitate a complete emotional breakdown, so I think I'll just hang out"
      },
      {
        author: "Kaddy",
        time: "19:04",
        text: "painkiller tastes atrocious (I confirmed personally) and she threw it back up immediately, so we're off to a great start"
      },
      {
        author: "Joey",
        time: "19:07",
        text: "Probably worse"
      },
      {
        author: "Joey",
        time: "19:07",
        text: "Not a good cope"
      },
      {
        author: "Joey",
        time: "19:08",
        text: "Have you tried the old wrap it in ham trick?"
      },
      {
        author: "Kaddy",
        time: "19:08",
        text: "it's unfortunately a liquid and she's supposed to take five drops"
      },
      {
        author: "Kaddy",
        time: "19:08",
        text: "impossible"
      },
      {
        author: "Joey",
        time: "19:08",
        text: "Oh dear"
      },
      {
        author: "Joey",
        time: "19:08",
        text: "Yeah not great. Maybe the more she has it the more she'll accept it"
      },
      {
        author: "Kaddy",
        time: "19:09",
        text: "put it on a piece of tuna, spat out the tuna and gagged again"
      },
      {
        author: "Kaddy",
        time: "19:09",
        text: "hopefully"
      },
      {
        author: "Kaddy",
        time: "19:09",
        text: "my next idea was pulling a poong, putting it on a crunchy treat and letting that soak it up because she doesn't chew those anymore"
      },
      {
        author: "Joey",
        time: "19:09",
        text: "<@&1292953335464464497> in 20?"
      },
      {
        author: "Joey",
        time: "19:09",
        text: "10-20"
      },
      {
        author: "Kaddy",
        time: "19:10",
        text: "maybe if she swallows them whole and it's absorbed into it and not on the surface she won't taste it"
      },
      {
        author: "Kaddy",
        time: "19:10",
        text: "yeee"
      },
      {
        author: "Kaddy",
        time: "19:10",
        text: "so true tho"
      },
      {
        author: "Joey",
        time: "19:11",
        text: "I imagine tipsy would be fine. But I wouldn't get drunk tonight if I were you"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#real-talk",
    participants: ["Demy", "Kaddy"],
    start: "2025-07-15T19:22:00",
    messages: [
      {
        author: "Kaddy",
        time: "19:22",
        text: "if she can taste it in tuna she's gonna taste it in wet food I'm afraid"
      },
      {
        author: "Kaddy",
        time: "19:22",
        text: "I took one and it's like a persistent bitter punch to your entire mouth somehow"
      },
      {
        author: "Kaddy",
        time: "19:23",
        text: "like from peppermint but without anything pleasant in it, and extremely bitter"
      },
      {
        author: "Kaddy",
        time: "19:23",
        text: "I feel really bad giving that to her in any way"
      },
      {
        author: "Demy",
        time: "19:25",
        text: "poor girl"
      },
      {
        author: "Kaddy",
        time: "19:26",
        text: "yee, it's not great\nshe did scream at me that she wanted food after which she hasn't done in a while so I hope it at least still helped with the pain a little"
      },
      {
        author: "Demy",
        time: "19:27",
        text: "yeah that sounds like it's working at least"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#shooter-games",
    participants: ["Jamie", "Joey"],
    start: "2025-07-15T19:48:00",
    messages: [
      {
        author: "Joey",
        time: "19:48",
        text: "I've got food soon so will need to skip 1/2 games after first one anyway"
      },
      {
        author: "Jamie",
        time: "19:48",
        text: "Then I\u2019ll hop in"
      },
      {
        author: "Joey",
        time: "19:48",
        text: "so we can swap out"
      },
      {
        author: "Jamie",
        time: "19:48",
        text: "My eyes are like half blurry and half open so"
      },
      {
        author: "Jamie",
        time: "19:49",
        text: "Just saw I had a discord notification and it summoned me from my nap"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#other-games",
    participants: ["Xal", "Smuck"],
    start: "2025-07-15T21:41:00",
    messages: [
      {
        author: "Smuck",
        time: "21:41",
        text: "Just got home, sowwy. Didn't think drunk parents would wanna talk dat much"
      },
      {
        author: "Smuck",
        time: "22:03",
        text: "I like dat, she deserves a good stone! She raised a bunch of good kitties!"
      },
      {
        author: "Xal",
        time: "22:03",
        text: "ok we done"
      },
      {
        author: "Smuck",
        time: "22:07",
        text: "<@&1292958744115675227> <@&1292954535467159582> We around and gonna play if people wanna join! Let us know if you comin :3"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Kaddy", "Ava"],
    start: "2025-07-18T15:18:00",
    messages: [
      {
        author: "Kaddy",
        time: "15:18",
        text: "you gonna drink and talk for 2 hours longer than expected again I'm calling it"
      },
      {
        author: "Kaddy",
        time: "15:21",
        text: "btw I know this is early but since it was brought up and I've discovered more crumbling walls and need some purpose to this sisyphean garbage (and maybe an idea how many rooms need to be finished)"
      },
      {
        author: "Kaddy",
        time: "15:25",
        text: "closest airport would be bremen, hamburg is usually cheaper tho and I don't mind picking people up there\nthen there's also the option of flying into berlin or amsterdam and spending a few nights there beforehand, both are 4-5h away"
      },
      {
        author: "Ava",
        time: "15:25",
        text: "did somebody say fremen?"
      },
      {
        author: "Kaddy",
        time: "15:26",
        text: "<a:SCgetoutofmyhead:841888624387817492>"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#real-talk",
    participants: ["Jake", "Kaddy"],
    start: "2025-07-19T23:59:00",
    messages: [
      {
        author: "Kaddy",
        time: "23:59",
        text: "she does! had a big scare this morning cause she didn't come to me and I found her with a mouth bleed, checked back in around 5 and she was still hiding and refused all food despite getting pain killers. just got home and she was waiting for me by the door with the \"bitch I'm HUNGRY\" look"
      },
      {
        author: "Kaddy",
        time: "00:00",
        text: "<a:notlikethis:971025837413531668>"
      },
      {
        author: "Jake",
        time: "00:00",
        text: "feeed her!"
      },
      {
        author: "Kaddy",
        time: "00:00",
        text: "I AM she just ate half a bag of cat food and half a bag of kitty tuna"
      },
      {
        author: "Kaddy",
        time: "00:01",
        text: "bit my finger as well"
      },
      {
        author: "Kaddy",
        time: "00:02",
        text: "I was already googling and calling for weekend emergency vets earlier and couldn't reach anyone and now look at her feasting at midnight"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Fishes", "Nils"],
    start: "2025-07-21T13:20:00",
    messages: [
      {
        author: "Fishes",
        time: "13:20",
        text: "I\u2019d like to see u on a pole"
      },
      {
        author: "Fishes",
        time: "13:21",
        text: "Tbf I\u2019ve been doing the same but I rotate through during the week"
      },
      {
        author: "Nils",
        time: "13:21",
        text: "Only if you tip well"
      },
      {
        author: "Fishes",
        time: "13:22",
        text: "Oh errr sorry I dropped my wallet can u pick it up for me"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Kaddy", "Nic"],
    start: "2025-07-22T11:30:00",
    messages: [
      {
        author: "Kaddy",
        time: "11:30",
        text: "yeah bit dumb"
      },
      {
        author: "Kaddy",
        time: "11:31",
        text: "how hard is it to have the tissue only in the place it needs to be and nowhere else"
      },
      {
        author: "Nic",
        time: "11:31",
        text: "Humans are capable of imagining pains and feelings they have never experienced. Ofc it's wrong sometimes, but a lot of times you can be spot on. Like with the shoe"
      },
      {
        author: "Kaddy",
        time: "11:31",
        text: "robbe have you ever poked yourself with a needle"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Kaddy", "Robbe"],
    start: "2025-07-22T12:17:00",
    messages: [
      {
        author: "Kaddy",
        time: "12:17",
        text: "maybe a definition issue but I think you can love and value your family but still be closer to friends in spending more time and being more honest and open with them"
      },
      {
        author: "Robbe",
        time: "12:18",
        text: "Absolutely"
      },
      {
        author: "Robbe",
        time: "12:18",
        text: "I love my parents I just don't like them very much"
      },
      {
        author: "Kaddy",
        time: "12:18",
        text: "but if it's just one thing you can't talk about but otherwise you still share everything that's still close imo"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#league-of-legends",
    participants: ["Charlie", "Nic"],
    start: "2025-07-22T15:50:00",
    messages: [
      {
        author: "Nic",
        time: "15:50",
        text: "Shut up charlie, no difference in doing this or looking up builds"
      },
      {
        author: "Nic",
        time: "15:51",
        text: "It makes it easier for new player so they don't have to worry about builds"
      },
      {
        author: "Charlie",
        time: "15:54",
        text: "bad habit"
      },
      {
        author: "Charlie",
        time: "15:55",
        text: "people whove been playing 10 years autopilot building dogshit items bc the app told them to"
      },
      {
        author: "Nic",
        time: "15:55",
        text: "you don't use it and still build dogshit items"
      },
      {
        author: "Charlie",
        time: "15:58",
        text: "at least i can think for myself"
      },
      {
        author: "Charlie",
        time: "15:58",
        text: "sheep"
      },
      {
        author: "Nic",
        time: "15:58",
        text: "doubt"
      },
      {
        author: "Nic",
        time: "15:59",
        text: "but the purpose as I told her was that it isn't a forever thing, but right now focusing on the core gameplay is more important than having to worry about what you lvl and buy because usually the core build for every  champ is about the same items"
      },
      {
        author: "Nic",
        time: "15:59",
        text: "and then it's like 2 items which are dependend on the situation, but being new you don't have the information to understand that yet"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#league-of-legends",
    participants: ["Nils", "Nic"],
    start: "2025-07-22T16:02:00",
    messages: [
      {
        author: "Nic",
        time: "16:02",
        text: "I think it's confusing, because it gives you like 3 item choices at a time usually"
      },
      {
        author: "Nils",
        time: "16:02",
        text: "Eh, if you're gonna follow some guide to build shit item a or shit item b, might as well use the built in one for the time being instead of a downloaded one"
      },
      {
        author: "Nic",
        time: "16:03",
        text: "but it's not shit items"
      },
      {
        author: "Nic",
        time: "16:03",
        text: "it's giving you the highest procent build, it's far better than the built in one"
      },
      {
        author: "Nic",
        time: "16:03",
        text: "and it also gives you a lot of other information"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Clom", "Smuck"],
    start: "2025-07-23T09:40:00",
    messages: [
      {
        author: "Clom",
        time: "09:40",
        text: "is this assuming that you wont die from the pain response"
      },
      {
        author: "Clom",
        time: "09:40",
        text: "because that can happen"
      },
      {
        author: "Smuck",
        time: "09:40",
        text: "Can you imagine how supperior I'd feel to everyone if someone was ever in pain tho."
      },
      {
        author: "Clom",
        time: "09:41",
        text: "I dont think you realise how fucked that would make you feel the rest of your life"
      },
      {
        author: "Clom",
        time: "09:41",
        text: "just having experienced that"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Blithe", "Nic"],
    start: "2025-07-23T09:46:00",
    messages: [
      {
        author: "Blithe",
        time: "09:46",
        text: "No?"
      },
      {
        author: "Nic",
        time: "09:47",
        text: "and then you just feel a lil embarrassed after"
      },
      {
        author: "Blithe",
        time: "09:47",
        text: "It still would, I'd just feel like I'd have a nice reference point to contemplate other forms of pain"
      },
      {
        author: "Blithe",
        time: "09:47",
        text: "I'm not staying I'd just feel indifferent to all other forms"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Robbe", "Nic"],
    start: "2025-07-24T08:48:00",
    messages: [
      {
        author: "Robbe",
        time: "08:48",
        text: "My honest reaction"
      },
      {
        author: "Nic",
        time: "08:49",
        text: "Robbe got that sexy rage"
      },
      {
        author: "Nic",
        time: "08:51",
        text: "Fr, in the last 22 days we have had 73 cases of pedophilia. That's like 3 pedos a day"
      },
      {
        author: "Nic",
        time: "08:52",
        text: "Thry are on the rise. Not their fault they are claiming free children after they have been lost for 2 hours"
      },
      {
        author: "Robbe",
        time: "08:55",
        text: "Put himself first"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Nic", "Smuck"],
    start: "2025-07-24T09:09:00",
    messages: [
      {
        author: "Smuck",
        time: "09:09",
        text: "They don't hide their anger. It's layed bare for the world to see"
      },
      {
        author: "Nic",
        time: "09:10",
        text: "You have only seen a fraction of the rage they can output"
      },
      {
        author: "Smuck",
        time: "09:10",
        text: "I truly doubt that"
      },
      {
        author: "Nic",
        time: "09:10",
        text: "What you are seeing is them holding back"
      },
      {
        author: "Smuck",
        time: "09:11",
        text: "If that's the case these mfs need to go into anger management"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#league-of-legends",
    participants: ["Xal", "Smuck"],
    start: "2025-07-24T14:51:00",
    messages: [
      {
        author: "Xal",
        time: "14:51",
        text: "need some help figuring out how to get used to unlocked cam"
      },
      {
        author: "Smuck",
        time: "14:54",
        text: "Have one game where you almost always have the finger (or piece of your hand if possible) on spacebar, only occasionally letting it go when you wanna check something further away"
      },
      {
        author: "Smuck",
        time: "14:54",
        text: "Then occasionally let go with every consecutive game"
      },
      {
        author: "Xal",
        time: "14:55",
        text: "just feels so janky"
      },
      {
        author: "Smuck",
        time: "14:55",
        text: "It is a bit"
      },
      {
        author: "Xal",
        time: "14:55",
        text: "also ending games with fuck all damage and idk what im doin wrong"
      },
      {
        author: "Smuck",
        time: "14:55",
        text: "Go crazier. Go for the one and one trade"
      },
      {
        author: "Xal",
        time: "15:00",
        text: "maybe then i get better at the game b4 i unlock the cam"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#real-talk",
    participants: ["Kaddy", "Robbe"],
    start: "2025-07-25T11:49:00",
    messages: [
      {
        author: "Kaddy",
        time: "11:49",
        text: "the real question"
      },
      {
        author: "Kaddy",
        time: "11:50",
        text: "or like a little preemptive towel or paper towel"
      },
      {
        author: "Kaddy",
        time: "11:51",
        text: "then again he thinks it's kinda neat so I guess there's no reason? I think stomach acid is fairly slow, not like your finger is gonna go up in smoke and only have bone left"
      },
      {
        author: "Robbe",
        time: "11:52",
        text: "'Kinda neat'"
      },
      {
        author: "Kaddy",
        time: "11:55",
        text: "I see the fox colours, but the shape is still wolf sorry"
      },
      {
        author: "Kaddy",
        time: "11:56",
        text: "did that guy see the apology video? pretty spot on with outfit"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Blithe", "Robbe"],
    start: "2025-07-25T14:55:00",
    messages: [
      {
        author: "Blithe",
        time: "14:55",
        text: "If you didn't put the quizzes literally every time I'm beyond ultra busy"
      },
      {
        author: "Blithe",
        time: "14:55",
        text: "I wanted to join the last one but I went on holiday the next morning at 3:00"
      },
      {
        author: "Robbe",
        time: "14:55",
        text: "ooffff"
      },
      {
        author: "Robbe",
        time: "14:55",
        text: "maybe next one"
      },
      {
        author: "Blithe",
        time: "14:55",
        text: "<:blobsweats:1292965401746997248>"
      },
      {
        author: "Robbe",
        time: "14:56",
        text: "I wanna play more lethal company"
      },
      {
        author: "Blithe",
        time: "14:57",
        text: "I haven't played that in forever and still it's written as favourite game in smackdle"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Blithe", "Smuck"],
    start: "2025-07-25T17:07:00",
    messages: [
      {
        author: "Smuck",
        time: "17:07",
        text: "Eat eats"
      },
      {
        author: "Blithe",
        time: "17:08",
        text: "My b gng"
      },
      {
        author: "Blithe",
        time: "17:09",
        text: "I mean I can also just hop on a VC and play Balatro and stream that if you prefer"
      },
      {
        author: "Blithe",
        time: "17:09",
        text: "Fully booked on the weekend, probably not home till like 9-10pm tomorrow and after 9-10h car ride I don't wanna play a new game and sunday is family gathering so I'm full that day as well"
      },
      {
        author: "Smuck",
        time: "17:09",
        text: "Honestly they probably aren't unless you get the quest that makes your first two refreshes be all 6 drops to get the two lvl 6 mech's (they match real hard). If you get that you get insane stats early on and just kill people until their comps can pop off"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#general",
    participants: ["Freddie", "Nils"],
    start: "2025-07-27T22:53:00",
    messages: [
      {
        author: "Nils",
        time: "22:53",
        text: "Just finished a pub quiz, question 3 \"What does the A stand for in AIDS\"?"
      },
      {
        author: "Freddie",
        time: "22:54",
        text: "auto"
      },
      {
        author: "Freddie",
        time: "22:54",
        text: "not"
      },
      {
        author: "Nils",
        time: "22:54",
        text: "Thanks for asking me to add some more acronyms <@71326010833899520>"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#shooter-games",
    participants: ["Fishes", "Jake"],
    start: "2025-07-28T15:21:00",
    messages: [
      {
        author: "Fishes",
        time: "15:21",
        text: "Well when I say good I mean they show what I perceive as a good high level skill"
      },
      {
        author: "Fishes",
        time: "15:21",
        text: "So in lesgue if they have good wave management trade pattens"
      },
      {
        author: "Fishes",
        time: "15:21",
        text: "Fundamental skill is a nice shiny buzzword"
      },
      {
        author: "Jake",
        time: "15:21",
        text: "okay but what you say is good trade patterns will change if you improve"
      },
      {
        author: "Fishes",
        time: "15:22",
        text: "I think of it as what u need to have a good understanding off how the game works"
      },
      {
        author: "Fishes",
        time: "15:22",
        text: "I can all also be good if they\u2019re good"
      },
      {
        author: "Fishes",
        time: "15:23",
        text: "If we\u2019re equal I can be like this guy clearly understands the game to a good level"
      },
      {
        author: "Jake",
        time: "15:23",
        text: "what rank is good in league"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#shooter-games",
    participants: ["Fishes", "Jake"],
    start: "2025-07-28T15:27:00",
    messages: [
      {
        author: "Fishes",
        time: "15:27",
        text: "Well I was thinking it in terms of tekken also"
      },
      {
        author: "Jake",
        time: "15:27",
        text: "if you were chovy you would think everyone is masters has a trash understanding of how the game works"
      },
      {
        author: "Jake",
        time: "15:27",
        text: "and have garvage wave management and trading"
      },
      {
        author: "Fishes",
        time: "15:27",
        text: "Cause in tekken I\u2019m like top 3% but I wouldn\u2019t really call myself good either"
      },
      {
        author: "Fishes",
        time: "15:27",
        text: "I have no one else to put myself against"
      },
      {
        author: "Fishes",
        time: "15:28",
        text: "That might be true"
      },
      {
        author: "Jake",
        time: "15:28",
        text: "you still have yourself in this case"
      },
      {
        author: "Jake",
        time: "15:28",
        text: "which sounds like its mostly about"
      },
      {
        author: "Jake",
        time: "15:28",
        text: "just them having a understanding that is similar or better then yours"
      },
      {
        author: "Fishes",
        time: "15:29",
        text: "Maybe mid masters is to high I\u2019m willing to say low masters"
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#real-talk",
    participants: ["Nils", "Charlie"],
    start: "2025-07-31T16:23:00",
    messages: [
      {
        author: "Nils",
        time: "16:23",
        text: "I've seen this, so not a hypothetical for me, and as I saw it once the old person starts refusing food they've basically given up anyway"
      },
      {
        author: "Nils",
        time: "16:23",
        text: "So yeah, chill to just let them because they've decided they'd rather die than be at the care home anyway\n==============================================================\nExported 5,947 message(s)\n=============================================================="
      },
      {
        author: "Charlie",
        time: "16:24",
        text: "shit vs poo"
      },
      {
        author: "Nils",
        time: "16:30",
        text: "Freddie AKA \"Bruce Forsyth\""
      },
    ],
  },
  {
    server: "Smack Den",
    channel: "#tier-lists",
    participants: ["Nils", "Kaddy"],
    start: "2025-08-03T17:28:00",
    messages: [
      {
        author: "Kaddy",
        time: "17:28",
        text: "ah shit forgot to vote"
      },
      {
        author: "Kaddy",
        time: "17:30",
        text: "can I tiebreak this one towards james blunt"
      },
      {
        author: "Nils",
        time: "17:31",
        text: "I got home about half hour ago and had to quickly listen to a bunch of songs since I forgot to yesterday"
      },
      {
        author: "Kaddy",
        time: "17:33",
        text: "I'll have to still listen to some cause I've never heard of them, but my vote wouldn't have mattered so that's okay"
      },
    ],
  },
];
